import React, { useState, useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getAllStudents, StudentDetailData, setFennToZero, setMultipleFennToZero, getAllTeachers } from '../../services/adminService';
import { getSelectedExam, getExamById, setSelectedExam } from '../../services/examService';
import { SINIFLAR, QRUPLAR, QRUP_CONFIGS, getFennlerByQrup } from '../../constants/fennConfig';
import { createApellyasiya, createApellyasiyaForBlok, getApellyasiyasByStudent, getFennFromQuestionNumber, getFennFromQuestionNumberForBlok, getTeachersByFenn } from '../../services/apellyasiyaService';
import { detectBlokMode, getQuestionPath, getQuestionEmptyStatus, detectExamMode } from '../../services/yoklaService';
import { Teacher, BlokMode, StudentEmptyPages, EmptyPage, ExamMode, ExamModeDetectionResult } from '../../types';
import * as XLSX from 'xlsx';
import QuestionScoringModal from './QuestionScoringModal';
import { db } from '../../firebase';
import { isQ26SpecialGrading } from '../../utils/examUtils';
import { blankCtxFromExam, getEffectiveBuraxilisQuestionsForStudent } from '../../constants/buraxilisConfig';
import { buildApellyasiyaWhatsAppMessage, openWhatsAppWithMessage } from '../../utils/apellyasiyaWhatsApp';
import EmptyPageZipModal from './EmptyPageZipModal';
import Icon from '../icons/Icon';
import { useToast } from '../../contexts/ToastContext';

// Vektor status ikonları (emoji yox)
const ICON_SIZE = 16;
const iconStyle: React.CSSProperties = { verticalAlign: 'middle', marginRight: 6, flexShrink: 0 };
const IconCheckCircle = (p: { size?: number; color?: string; style?: React.CSSProperties }) => (
  <svg width={p.size ?? ICON_SIZE} height={p.size ?? ICON_SIZE} viewBox="0 0 24 24" fill="none" stroke={p.color ?? 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ ...iconStyle, ...p.style }} aria-hidden><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
);
const IconClock = (p: { size?: number; color?: string; style?: React.CSSProperties }) => (
  <svg width={p.size ?? ICON_SIZE} height={p.size ?? ICON_SIZE} viewBox="0 0 24 24" fill="none" stroke={p.color ?? 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ ...iconStyle, ...p.style }} aria-hidden><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
);
const IconCheck = (p: { size?: number; color?: string; style?: React.CSSProperties }) => (
  <svg width={p.size ?? ICON_SIZE} height={p.size ?? ICON_SIZE} viewBox="0 0 24 24" fill="none" stroke={p.color ?? 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ ...iconStyle, ...p.style }} aria-hidden><polyline points="20 6 9 17 4 12" /></svg>
);
const IconX = (p: { size?: number; color?: string; style?: React.CSSProperties }) => (
  <svg width={p.size ?? ICON_SIZE} height={p.size ?? ICON_SIZE} viewBox="0 0 24 24" fill="none" stroke={p.color ?? 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ ...iconStyle, ...p.style }} aria-hidden><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
);
const IconCircle = (p: { size?: number; color?: string; style?: React.CSSProperties }) => (
  <svg width={p.size ?? ICON_SIZE} height={p.size ?? ICON_SIZE} viewBox="0 0 24 24" fill="none" stroke={p.color ?? 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ ...iconStyle, ...p.style }} aria-hidden><circle cx="12" cy="12" r="10" /></svg>
);

const WHATSAPP_ICON_SIZE = 18;
const IconWhatsApp = (p: { size?: number; style?: React.CSSProperties }) => (
  <svg width={p.size ?? WHATSAPP_ICON_SIZE} height={p.size ?? WHATSAPP_ICON_SIZE} viewBox="0 0 24 24" fill="currentColor" style={{ display: 'block', flexShrink: 0, ...p.style }} aria-hidden>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const Container = styled.div`
  min-height: 100vh;
  background: #1e3a8a;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const Header = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 14px;
  }
`;

const FilterSection = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FilterLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 8px;
`;

const FilterSelect = styled.select`
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #3b82f6;
  }
`;

const FilterInput = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  background: white;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #3b82f6;
  }

  &::placeholder {
    color: #94a3b8;
  }
`;

const StatsBarMain = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const StatItemMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StatLabel = styled.div`
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
`;

const StatValue = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
`;

const StudentTable = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow-x: auto;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
`;

const Thead = styled.thead`
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
`;

const Th = styled.th`
  padding: 12px 16px;
  text-align: left;
  font-size: 13px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
`;

const Tbody = styled.tbody``;

const Tr = styled.tr<{ clickable?: boolean }>`
  transition: all 0.2s ease;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};

  &:hover {
    background: ${props => props.clickable ? '#f8fafc' : 'transparent'};
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f1f5f9;
  }
`;

const Td = styled.td`
  padding: 14px 16px;
  font-size: 14px;
  color: #1e293b;
`;

const Badge = styled.div<{ color?: string }>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.color || 'linear-gradient(135deg, #3b82f6, #2563eb)'};
  color: white;
`;

const ScoreGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const ScoreBadge = styled.div<{ hasScore?: boolean }>`
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.hasScore ? 'linear-gradient(135deg, #10b981, #059669)' : '#f1f5f9'};
  color: ${props => props.hasScore ? 'white' : '#94a3b8'};
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: white;
`;

const LoadingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const NoData = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
  font-size: 16px;
`;

const TabContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 8px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 8px;
`;

const TabButton = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  background: ${props => props.active ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' : 'transparent'};
  color: ${props => props.active ? 'white' : '#64748b'};
  
  &:hover {
    background: ${props => props.active ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' : '#f8fafc'};
  }
`;

const EmptyVerificationContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const EmptyPageCard = styled.div`
  background: #f8fafc;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  border: 2px solid #e2e8f0;
`;

const EmptyPageImage = styled.div`
  margin: 20px 0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  
  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

const EmptyPageInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: white;
  border-radius: 8px;
`;

const InfoItem = styled.div`
  font-size: 14px;
  
  strong {
    color: #64748b;
    display: block;
    margin-bottom: 4px;
  }
  
  span {
    color: #1e293b;
    font-weight: 600;
  }
`;

const VerificationButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
`;

const VerifyButton = styled.button<{ variant?: 'confirm' | 'reject' }>`
  padding: 14px 32px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  ${props => props.variant === 'reject' ? `
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    color: white;
    &:hover { box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3); }
  ` : `
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    &:hover { box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3); }
  `}
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const ProgressIndicator = styled.div`
  text-align: center;
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
`;

const ViewModeToggle = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
`;

const ViewModeButton = styled.button<{ active: boolean }>`
  padding: 8px 16px;
  border: 2px solid ${props => props.active ? '#2196F3' : '#ddd'};
  background: ${props => props.active ? '#2196F3' : 'white'};
  color: ${props => props.active ? 'white' : '#666'};
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.active ? '#1976D2' : '#f5f5f5'};
  }
`;

const FilterContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

const FilterButton = styled.button<{ active: boolean }>`
  padding: 6px 14px;
  border: 1px solid ${props => props.active ? '#2196F3' : '#ddd'};
  background: ${props => props.active ? '#E3F2FD' : 'white'};
  color: ${props => props.active ? '#2196F3' : '#666'};
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.active ? '#BBDEFB' : '#f5f5f5'};
  }
`;

const ListView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 70vh;
  overflow-y: auto;
  padding: 10px;
`;

const ListItem = styled.div<{ status?: string }>`
  display: grid;
  grid-template-columns: 80px 150px 80px auto 120px 150px;
  gap: 15px;
  padding: 15px;
  background: white;
  border: 2px solid ${props => 
    props.status === 'confirmed' ? '#4CAF50' : 
    props.status === 'rejected' ? '#f44336' : '#e0e0e0'};
  border-radius: 8px;
  align-items: center;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transform: translateY(-2px);
  }
`;

const ListItemImage = styled.img`
  width: 70px;
  height: 70px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ddd;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }
`;

const ListItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
`;

const ListItemBadge = styled.span<{ type: 'pending' | 'confirmed' | 'rejected' }>`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  background: ${props => 
    props.type === 'confirmed' ? '#4CAF50' : 
    props.type === 'rejected' ? '#f44336' : '#FF9800'};
  color: white;
`;

const ListItemActions = styled.div`
  display: flex;
  gap: 8px;
`;

const ListActionButton = styled.button<{ variant: 'view' | 'confirm' | 'reject' }>`
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
  background: ${props => 
    props.variant === 'confirm' ? '#4CAF50' : 
    props.variant === 'reject' ? '#f44336' : '#2196F3'};
  color: white;

  &:hover {
    opacity: 0.85;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const StatsBar = styled.div`
  display: flex;
  gap: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .label {
    font-size: 12px;
    color: #666;
    text-transform: uppercase;
  }

  .value {
    font-size: 20px;
    font-weight: 700;
    color: #333;
  }
`;

const StudentDetailModal = styled.div<{ show: boolean }>`
  display: ${props => props.show ? 'flex' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  padding: 32px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f1f5f9;
`;

const ModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  color: #64748b;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
  }
`;

const StudentInfo = styled.div`
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #e2e8f0;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 4px;
  }
`;

const InfoLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
`;

const InfoValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
`;

const FennResultsSection = styled.div`
  margin-bottom: 20px;
`;

const FennTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 12px 0;
`;

const FennCard = styled.div`
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
`;

const FennHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
`;

const FennHeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const FennName = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #475569;
`;

const ZeroButton = styled.button`
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid #ef4444;
  background: white;
  color: #ef4444;
  
  &:hover {
    background: #ef4444;
    color: white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 12px;
`;

const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #3b82f6;

  &:disabled {
    cursor: not-allowed;
  }
`;

const CheckboxLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: #3b82f6;
  }
`;

const BulkActionsFooter = styled.div<{ show: boolean }>`
  display: ${props => props.show ? 'flex' : 'none'};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  padding: 20px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
  z-index: 1500;
  align-items: center;
  justify-content: space-between;
  border-top: 3px solid #3b82f6;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    padding: 16px;
    flex-direction: column;
    align-items: stretch;
  }
`;

const BulkActionsInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const BulkActionsCount = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #60a5fa;
`;

const BulkActionsText = styled.div`
  font-size: 14px;
  color: #cbd5e1;
`;

const BulkActionsButtons = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    
    button {
      flex: 1;
    }
  }
`;

const BulkButton = styled.button<{ variant?: 'danger' | 'cancel' }>`
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  
  ${props => props.variant === 'danger' ? `
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
    }
  ` : `
    background: linear-gradient(135deg, #64748b, #475569);
    color: white;
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(100, 116, 139, 0.4);
    }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

const FennTeacher = styled.div`
  font-size: 13px;
  color: #64748b;
`;

const TotalScore = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #10b981;
`;

const QuestionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 8px;
`;

const QuestionItem = styled.div`
  background: #f8fafc;
  padding: 8px;
  border-radius: 8px;
  text-align: center;
`;

const QuestionNumber = styled.div`
  font-size: 11px;
  color: #64748b;
  margin-bottom: 4px;
`;

const QuestionScore = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
`;

const NotesSection = styled.div`
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid #e2e8f0;
`;

const NotesSectionTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 12px;
`;

const NoteItem = styled.div`
  background: #fef3c7;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  border-left: 4px solid #f59e0b;
`;

const NoteLabel = styled.div`
  font-size: 12px;
  color: #92400e;
  font-weight: 600;
  margin-bottom: 4px;
`;

const NoteText = styled.div`
  font-size: 14px;
  color: #78350f;
  white-space: pre-wrap;
`;

const ViewButton = styled.button`
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid #3b82f6;
  background: white;
  color: #3b82f6;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    background: #3b82f6;
    color: white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const DeleteScoreButton = styled.button`
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid #ef4444;
  background: white;
  color: #ef4444;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    background: #ef4444;
    color: white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ImageModal = styled.div<{ show: boolean }>`
  display: ${props => props.show ? 'flex' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  z-index: 3000;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const ImageModalContent = styled.div`
  background: white;
  border-radius: 20px;
  padding: 32px;
  max-width: 1200px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

const ImageViewContainer = styled.div`
  position: relative;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f8fafc;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  
  &::-webkit-scrollbar {
    width: 12px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 6px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 6px;
    
    &:hover {
      background: #94a3b8;
    }
  }
`;

const ImageViewImg = styled.img`
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  vertical-align: top;
`;

const ImageLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  color: #64748b;
  gap: 16px;
`;

const ImageLoadingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
`;

const QuestionRangeInfo = styled.div`
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  padding: 12px 20px;
  border-radius: 10px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
`;

const SuccessToast = styled.div<{ show: boolean }>`
  display: ${props => props.show ? 'flex' : 'none'};
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(16, 185, 129, 0.3);
  z-index: 4000;
  font-weight: 600;
  font-size: 15px;
  align-items: center;
  gap: 8px;
  animation: slideDown 0.3s ease;

  @keyframes slideDown {
    from {
      transform: translateX(-50%) translateY(-100px);
      opacity: 0;
    }
    to {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
  }
`;

/** Href content query-ni parse edir: "Suallar: ... Şikayət: ..." → { suallar, sikayet }. Hər ikisi varsa qaytarır, yoxsa null. */
function parseContentQuery(raw: string | null): { suallar: string; sikayet: string } | null {
  if (!raw || !raw.trim()) return null;
  let decoded: string;
  try {
    decoded = decodeURIComponent(raw.replace(/\+/g, ' '));
  } catch {
    return null;
  }
  const suallarLabel = 'Suallar:';
  const sikayetLabel = 'Şikayət:';
  const iSuallar = decoded.indexOf(suallarLabel);
  const iSikayet = decoded.indexOf(sikayetLabel);
  if (iSuallar === -1 || iSikayet === -1 || iSikayet <= iSuallar) return null;
  const suallar = decoded.slice(iSuallar + suallarLabel.length, iSikayet).trim();
  const sikayet = decoded.slice(iSikayet + sikayetLabel.length).trim();
  if (!suallar || !sikayet) return null;
  return { suallar, sikayet };
}

const ContentNoteWrap = styled.div<{ minimized: boolean }>`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 3999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  ${props => props.minimized ? `
    width: 48px;
    height: 48px;
  ` : `
    max-width: 380px;
    width: 100%;
  `}
`;

const ContentNoteCard = styled.div<{ minimized: boolean }>`
  background: white;
  border-radius: ${props => props.minimized ? '50%' : '16px'};
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  border: 1px solid rgba(59, 130, 246, 0.2);
  transition: border-radius 0.2s ease, padding 0.2s ease;
  ${props => props.minimized ? `
    width: 48px;
    height: 48px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  ` : `
    padding: 16px;
    display: block;
  `}
`;

const ContentNoteHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
`;

const ContentNoteTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const ContentNoteActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ContentNoteBtn = styled.button<{ round?: boolean }>`
  width: ${props => props.round ? '32px' : '28px'};
  height: ${props => props.round ? '32px' : '28px'};
  min-width: ${props => props.round ? '32px' : '28px'};
  border: none;
  border-radius: ${props => props.round ? '50%' : '8px'};
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: #e2e8f0;
    color: #1e293b;
  }
`;

const ContentNoteBody = styled.div`
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
`;

const ContentNoteSection = styled.div`
  margin-bottom: 12px;
  &:last-child { margin-bottom: 0; }
`;

const ContentNoteSectionLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  margin-bottom: 4px;
`;

const ContentNoteSectionText = styled.div`
  font-size: 13px;
  color: #1e293b;
  white-space: pre-wrap;
  word-break: break-word;
`;

const InfoIconSvg = styled.svg<{ size?: number }>`
  width: ${p => p.size ?? 20}px;
  height: ${p => p.size ?? 20}px;
  flex-shrink: 0;
  color: inherit;
`;

const ConfirmDialog = styled.div<{ show: boolean }>`
  display: ${props => props.show ? 'flex' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const ConfirmDialogContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 450px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const ConfirmDialogTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 16px 0;
`;

const ConfirmDialogText = styled.p`
  font-size: 15px;
  color: #64748b;
  margin: 0 0 24px 0;
  line-height: 1.6;
`;

const ConfirmDialogButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

const ConfirmButton = styled.button<{ variant?: 'danger' | 'cancel' }>`
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  
  ${props => props.variant === 'danger' ? `
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
    }
  ` : `
    background: #f1f5f9;
    color: #475569;
    &:hover {
      background: #e2e8f0;
    }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ApellyasiyaContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const ApellyasiyaFilterBar = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  align-items: center;
`;

const ApellyasiyaFilterSelect = styled.select`
  padding: 10px 16px;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
  font-size: 14px;
  font-weight: 500;
  background: white;
  color: #1e293b;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #3b82f6;
  }

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

const ApellyasiyaWhatsAppSection = styled.div`
  margin-bottom: 24px;
  border-radius: 12px;
  border: 1px solid #bbf7d0;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  overflow: hidden;
`;

const ApellyasiyaWhatsAppToggle = styled.button`
  width: 100%;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  color: #166534;
  text-align: left;
  transition: background 0.2s;
  &:hover {
    background: rgba(22, 101, 52, 0.08);
  }
`;

const ApellyasiyaWhatsAppToggleIcon = styled.span<{ $open: boolean }>`
  display: inline-block;
  transition: transform 0.2s;
  transform: rotate(${p => (p.$open ? '180deg' : '0deg')});
`;

const ApellyasiyaWhatsAppContent = styled.div<{ $visible: boolean }>`
  display: ${p => (p.$visible ? 'block' : 'none')};
  padding: 12px 16px 16px;
`;

const ApellyasiyaWhatsAppGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const ApellyasiyaWhatsAppTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #166534;
  margin-bottom: 12px;
`;

const ApellyasiyaWhatsAppRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 10px 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
`;

const ApellyasiyaWhatsAppStats = styled.span`
  font-size: 13px;
  color: #475569;
`;

const ApellyasiyaProgressBarWrap = styled.div`
  width: 100%;
  max-width: 200px;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 6px;
`;

const ApellyasiyaProgressBarFill = styled.div<{ $pct: number }>`
  width: ${p => Math.min(100, Math.max(0, p.$pct))}%;
  height: 100%;
  background: linear-gradient(90deg, #22c55e 0%, #16a34a 100%);
  border-radius: 4px;
  transition: width 0.25s ease;
`;

const ApellyasiyaWhatsAppButton = styled.button`
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  background: #25D366;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  &:hover {
    background: #20BD5A;
    box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3);
  }
`;

const ApellyasiyaStudentCard = styled.div`
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 24px;
  background: #fafbfc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

const ApellyasiyaStudentCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-bottom: 2px solid #e2e8f0;
`;

const ApellyasiyaStudentCardTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #1e293b;
`;

const ApellyasiyaStudentCardMeta = styled.div`
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
`;

const ApellyasiyaStudentCardStats = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
`;

const ApellyasiyaStudentCardBody = styled.div`
  padding: 16px;
  background: white;
`;

const ApellyasiyaTable = styled.div`
  overflow-x: auto;
`;

const ApellyasiyaTableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr auto;
  gap: 16px;
  padding: 16px;
  background: #f1f5f9;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  color: #475569;
  margin-bottom: 12px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr auto;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr 1fr auto;
  }
`;

const ApellyasiyaRow = styled.div<{ $status?: 'pending' | 'completed' }>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr auto;
  gap: 16px;
  padding: 16px;
  background: white;
  border-radius: 10px;
  border: 2px solid ${props => props.$status === 'completed' ? '#10b981' : '#f59e0b'};
  margin-bottom: 12px;
  font-size: 14px;
  align-items: center;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr auto;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr 1fr auto;
  }
`;

const ApellyasiyaStudentCell = styled.div`
  cursor: pointer;
  &:hover { text-decoration: underline; }
`;

const ScoreChangeIndicator = styled.span<{ $change: number }>`
  font-weight: 600;
  color: ${props => {
    if (props.$change > 0) return '#10b981';
    if (props.$change < 0) return '#ef4444';
    return '#64748b';
  }};
`;

const StatusBadge = styled.span<{ $status: 'pending' | 'completed' }>`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.$status === 'completed'
    ? 'linear-gradient(135deg, #10b981, #059669)'
    : 'linear-gradient(135deg, #f59e0b, #d97706)'};
  color: white;
`;

// Student-based empty verification styled components
const StudentCardContainer = styled.div<{ $allEmpty?: boolean }>`
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 16px;
  border: 2px solid ${props => props.$allEmpty ? '#f59e0b' : '#e2e8f0'};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }

  ${props => props.$allEmpty && `
    background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
    border-color: #f59e0b;
  `}
`;

const StudentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
`;

const StudentName = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
`;

const StudentId = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  background: #f1f5f9;
  padding: 6px 12px;
  border-radius: 8px;
`;

const StudentMeta = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const MetaItem = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  background: #f8fafc;
  padding: 6px 12px;
  border-radius: 6px;
`;

const EmptyCountBadge = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  background: #e0f2fe;
  padding: 10px 16px;
  border-radius: 10px;
  display: inline-block;
  margin-bottom: 12px;
`;

const AllEmptyBadge = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #92400e;
  background: #fef3c7;
  padding: 8px 14px;
  border-radius: 8px;
  display: inline-block;
  margin-bottom: 12px;
  border: 1px solid #f59e0b;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 8px;
`;

const ProgressFill = styled.div<{ $percent: number }>`
  width: ${props => props.$percent}%;
  height: 100%;
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
  transition: width 0.3s ease;
`;

const ProgressText = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 16px;
`;

const CardActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const PreviewButton = styled.button`
  flex: 1;
  padding: 12px 20px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const QuickConfirmButton = styled.button`
  flex: 1;
  padding: 12px 20px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const StyledModal = styled.div<{ show: boolean }>`
  display: ${props => props.show ? 'flex' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const QuestionsGridModal = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  margin: 24px 0;
  max-height: 60vh;
  overflow-y: auto;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
`;

const QuestionImageCard = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  transition: all 0.2s ease;

  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
  }
`;

const QuestionImageCardContent = styled.div`
  padding: 12px;
`;

const QuestionImageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

const QuestionImageNumber = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
`;

const QuestionImageStatusBadge = styled.span<{ $status: 'pending' | 'confirmed' | 'rejected' }>`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  background: ${props =>
    props.$status === 'confirmed' ? '#dcfce7' :
    props.$status === 'rejected' ? '#fee2e2' : '#fef3c7'};
  color: ${props =>
    props.$status === 'confirmed' ? '#166534' :
    props.$status === 'rejected' ? '#991b1b' : '#92400e'};
`;

const QuestionImageImg = styled.img`
  width: 100%;
  height: 200px;
  object-fit: contain;
  background: #f8fafc;
  border-radius: 8px;
`;

const ModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding-top: 20px;
  border-top: 2px solid #e2e8f0;
  flex-wrap: wrap;
`;

const BackButton = styled.button`
  padding: 12px 24px;
  background: #f1f5f9;
  color: #475569;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #e2e8f0;
  }
`;

const ModalActionButton = styled.button<{ variant: 'confirm' | 'reject' }>`
  flex: 1;
  padding: 12px 24px;
  background: ${props => props.variant === 'confirm'
    ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
    : 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'};
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.variant === 'confirm'
      ? '0 4px 12px rgba(16, 185, 129, 0.3)'
      : '0 4px 12px rgba(239, 68, 68, 0.3)'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const BulkConfirmDialogContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const BulkConfirmDialogTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 16px 0;
`;

const BulkConfirmDialogText = styled.p`
  font-size: 15px;
  color: #475569;
  margin-bottom: 20px;
  line-height: 1.6;
`;

const QuestionList = styled.div`
  background: #f8fafc;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const QuestionListItem = styled.div`
  padding: 6px 12px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const AlreadyVerifiedBadge = styled.span`
  padding: 2px 8px;
  background: #dcfce7;
  color: #166534;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
`;

const BulkConfirmDialogButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

// ==================== PHASE 2: Validation Modal Components ====================

const ValidationPreviewModal = styled.div<{ show: boolean }>`
  display: ${props => props.show ? 'flex !important' : 'none !important'};
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const ValidationModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 900px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 5px;

    &:hover {
      background: #94a3b8;
    }
  }
`;

const ValidationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f1f5f9;
`;

const ValidationTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
`;

const ValidationWarning = styled.div`
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border-left: 4px solid #f59e0b;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  color: #92400e;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 12px;

  &:before {
    content: '!';
    font-size: 20px;
  }
`;

const ValidationStats = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

const ValidationStatBox = styled.div`
  flex: 1;
  min-width: 200px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 20px;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  text-align: center;

  .number {
    font-size: 36px;
    font-weight: 700;
    color: #8b5cf6;
    margin-bottom: 8px;
  }

  .label {
    font-size: 14px;
    color: #64748b;
    font-weight: 500;
  }
`;

const ValidationList = styled.div`
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  max-height: 400px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;

    &:hover {
      background: #94a3b8;
    }
  }
`;

const ValidationListItem = styled.div`
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr 100px auto;
  gap: 16px;
  align-items: center;
  transition: all 0.2s ease;

  &:hover {
    border-color: #8b5cf6;
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.1);
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8px;
  }
`;

const ValidationListLabel = styled.div`
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 4px;
`;

const ValidationListValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
`;

const ValidationListDetail = styled.div`
  font-size: 12px;
  color: #64748b;
  font-family: monospace;
  background: #f1f5f9;
  padding: 6px 10px;
  border-radius: 4px;
  word-break: break-all;
`;

const ValidationButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 2px solid #f1f5f9;
`;

const ValidationCancelButton = styled.button`
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid #e2e8f0;
  background: white;
  color: #64748b;

  &:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
  }
`;

const ValidationConfirmButton = styled.button`
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

const ValidationSuccessIcon = styled.div`
  font-size: 48px;
  text-align: center;
  margin-bottom: 16px;
`;

const ResultsSummary = styled.div`
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  border-left: 4px solid #10b981;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
`;

const ResultsErrorList = styled.div`
  background: #fef2f2;
  border-left: 4px solid #ef4444;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  max-height: 200px;
  overflow-y: auto;
`;

const ErrorItem = styled.div`
  padding: 8px 12px;
  background: white;
  border-radius: 4px;
  margin-bottom: 8px;
  font-size: 13px;
  color: #991b1b;

  &:last-child {
    margin-bottom: 0;
  }
`;

// ==================== END PHASE 2 Modal Components ====================

// Student List View Components for Empty Page Verification
interface StudentListViewProps {
  studentGroups: StudentEmptyPages[];
  onPreviewStudent: (group: StudentEmptyPages) => void;
  onQuickConfirm: (group: StudentEmptyPages) => void;
}

const StudentListView: React.FC<StudentListViewProps> = ({
  studentGroups,
  onPreviewStudent,
  onQuickConfirm
}) => {
  if (studentGroups.length === 0) {
    return (
      <NoData>
        <div style={{ marginBottom: '16px' }}><IconCheckCircle size={48} color="#10b981" style={{ marginRight: 0 }} /></div>
        <div style={{ fontSize: '20px', fontWeight: '600', color: '#10b981', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          Bütün boş səhifələr yoxlanıldı <IconCheck size={20} style={{ marginRight: 0 }} />
        </div>
      </NoData>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {studentGroups.map(group => (
        <StudentCard
          key={group.studentId}
          group={group}
          onPreview={onPreviewStudent}
          onQuickConfirm={onQuickConfirm}
        />
      ))}
    </div>
  );
};

interface StudentCardProps {
  group: StudentEmptyPages;
  onPreview: (group: StudentEmptyPages) => void;
  onQuickConfirm: (group: StudentEmptyPages) => void;
}

const StudentCard: React.FC<StudentCardProps> = ({ group, onPreview, onQuickConfirm }) => {
  const progressPercent = group.totalCount > 0
    ? (group.verifiedCount / group.totalCount) * 100
    : 0;

  return (
    <StudentCardContainer $allEmpty={group.isAllEmpty}>
      <StudentHeader>
        <StudentName>{group.studentName}</StudentName>
        <StudentId>{group.studentId}</StudentId>
      </StudentHeader>

      <StudentMeta>
        <MetaItem>Sinif: {group.grade}</MetaItem>
        {group.variant && <MetaItem>Variant: {group.variant}</MetaItem>}
        {group.specialtyGroup && <MetaItem>Qrup: {group.specialtyGroup}</MetaItem>}
      </StudentMeta>

      <EmptyCountBadge>
        {group.pendingCount > 0 && `${group.pendingCount} gözləyir • `}
        {group.totalCount} boş səhifə
      </EmptyCountBadge>

      {group.isAllEmpty && (
        <AllEmptyBadge>Bütün suallar boş</AllEmptyBadge>
      )}

      <ProgressBar>
        <ProgressFill $percent={progressPercent} />
      </ProgressBar>
      <ProgressText>{group.verifiedCount} / {group.totalCount} yoxlanıldı</ProgressText>

      <CardActions>
        <PreviewButton onClick={() => onPreview(group)}>
          <><Icon name="photo" size={16} /> Bütününü Göstər</>
        </PreviewButton>
        {group.pendingCount > 0 && (
          <QuickConfirmButton onClick={() => onQuickConfirm(group)}>
            <><IconCheck size={14} /> Sürətli Təsdiq ({group.pendingCount})</>
          </QuickConfirmButton>
        )}
      </CardActions>
    </StudentCardContainer>
  );
};

// Student Detail Modal Component
interface StudentDetailModalProps {
  show: boolean;
  studentGroup: StudentEmptyPages | null;
  onClose: () => void;
  onBulkConfirm: (selectedQuestions: Set<string>) => void;
  onBulkReject: (selectedQuestions: Set<string>) => void;
  bulkProcessing: boolean;
  selectedQuestionNumbers: Set<string>;
  onToggleQuestion: (questionNumber: string) => void;
}

const StudentEmptyPagesModal: React.FC<StudentDetailModalProps> = ({
  show,
  studentGroup,
  onClose,
  onBulkConfirm,
  onBulkReject,
  bulkProcessing,
  selectedQuestionNumbers,
  onToggleQuestion
}) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmAction, setConfirmAction] = useState<'confirm' | 'reject' | null>(null);

  if (!show || !studentGroup) return null;

  const handleBulkAction = (action: 'confirm' | 'reject') => {
    setConfirmAction(action);
    setShowConfirmDialog(true);
  };

  const confirmBulkAction = () => {
    if (confirmAction === 'confirm') {
      onBulkConfirm(selectedQuestionNumbers);
    } else if (confirmAction === 'reject') {
      onBulkReject(selectedQuestionNumbers);
    }
    setShowConfirmDialog(false);
    setConfirmAction(null);
  };

  return (
    <>
      <StyledModal show={show}>
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '32px',
          maxWidth: '900px',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1e293b', margin: 0 }}>
              {studentGroup.studentName}
            </h2>
            <button
              onClick={onClose}
              aria-label="Bağla"
              style={{
                background: 'none',
                border: 'none',
                fontSize: '28px',
                cursor: 'pointer',
                color: '#64748b',
                padding: '4px 8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <IconX size={18} />
            </button>
          </div>

          <div style={{ marginBottom: '24px', display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>Şagird ID</div>
              <div style={{ fontSize: '14px', color: '#1e293b', fontWeight: '500' }}>{studentGroup.studentId}</div>
            </div>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>Sinif</div>
              <div style={{ fontSize: '14px', color: '#1e293b', fontWeight: '500' }}>{studentGroup.grade}</div>
            </div>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px', fontWeight: '600' }}>Boş səhifə</div>
              <div style={{ fontSize: '14px', color: '#1e293b', fontWeight: '500' }}>{studentGroup.totalCount} sual</div>
            </div>
          </div>

          <QuestionsGridModal>
            {studentGroup.emptyPages.map((page) => {
              const isPending = page.verificationStatus === 'pending';
              const isChecked = selectedQuestionNumbers.has(page.questionNumber);

              return (
                <QuestionImageCard key={page.questionNumber}>
                  <QuestionImageCardContent>
                    <QuestionImageHeader>
                      <QuestionCheckboxLabel $disabled={!isPending}>
                        <QuestionCheckbox
                          type="checkbox"
                          checked={isChecked}
                          disabled={!isPending}
                          onChange={() => onToggleQuestion(page.questionNumber)}
                        />
                        <QuestionImageNumber>{page.questionNumber}</QuestionImageNumber>
                      </QuestionCheckboxLabel>
                      <QuestionImageStatusBadge $status={page.verificationStatus || 'pending'}>
                        {page.verificationStatus === 'confirmed' ? <><IconCheck /> Təsdiqləndi</> :
                         page.verificationStatus === 'rejected' ? <><IconX /> Rədd edilib</> : <><IconClock /> Gözləyir</>}
                      </QuestionImageStatusBadge>
                    </QuestionImageHeader>
                    <QuestionImageImg
                      src={page.questionData.path}
                      alt={`${page.questionNumber} - ${page.studentName}`}
                    />
                  </QuestionImageCardContent>
                </QuestionImageCard>
              );
            })}
          </QuestionsGridModal>

          <ModalActions>
            <BackButton onClick={onClose}>
              Geri qayıt
            </BackButton>
            <ModalActionButton
              variant="reject"
              onClick={() => handleBulkAction('reject')}
              disabled={bulkProcessing || studentGroup.pendingCount === 0}
            >
              <><IconX size={14} /> Hamısını Rədd Et ({studentGroup.pendingCount})</>
            </ModalActionButton>
            <ModalActionButton
              variant="confirm"
              onClick={() => handleBulkAction('confirm')}
              disabled={bulkProcessing || studentGroup.pendingCount === 0}
            >
              <><IconCheck size={14} /> Hamısını Təsdiqlə ({studentGroup.pendingCount})</>
            </ModalActionButton>
          </ModalActions>
        </div>
      </StyledModal>

      <BulkConfirmDialog
        show={showConfirmDialog}
        studentGroup={studentGroup}
        action={confirmAction}
        onConfirm={confirmBulkAction}
        onCancel={() => {
          setShowConfirmDialog(false);
          setConfirmAction(null);
        }}
        selectedQuestionNumbers={selectedQuestionNumbers}
      />
    </>
  );
};

// Bulk Confirm Dialog Component
interface BulkConfirmDialogProps {
  show: boolean;
  studentGroup: StudentEmptyPages | null;
  action: 'confirm' | 'reject' | null;
  onConfirm: () => void;
  onCancel: () => void;
  selectedQuestionNumbers: Set<string>;
}

const BulkConfirmDialog: React.FC<BulkConfirmDialogProps> = ({
  show,
  studentGroup,
  action,
  onConfirm,
  onCancel,
  selectedQuestionNumbers
}) => {
  if (!show || !action || !studentGroup) return null;

  const isConfirm = action === 'confirm';
  const pendingPages = studentGroup.emptyPages.filter(p => p.verificationStatus === 'pending');

  // If no selection, apply action to all pending questions
  const hasSelection = selectedQuestionNumbers.size > 0;
  const toConfirm = hasSelection
    ? isConfirm
      ? Array.from(selectedQuestionNumbers)
      : pendingPages
          .filter(p => !selectedQuestionNumbers.has(p.questionNumber))
          .map(p => p.questionNumber)
    : isConfirm
      ? pendingPages.map(p => p.questionNumber)
      : [];

  const toReject = hasSelection
    ? isConfirm
      ? pendingPages
          .filter(p => !selectedQuestionNumbers.has(p.questionNumber))
          .map(p => p.questionNumber)
      : Array.from(selectedQuestionNumbers)
    : isConfirm
      ? []
      : pendingPages.map(p => p.questionNumber);

  return (
    <StyledModal show={show}>
      <BulkConfirmDialogContent>
        <BulkConfirmDialogTitle>
          {isConfirm ? <><IconCheck size={14} /> Seçili Təsdiqləmə</> : <><IconX size={14} /> Seçili Rədd etmə</>}
        </BulkConfirmDialogTitle>
        <BulkConfirmDialogText>
          {studentGroup.studentName} üçün boş səhifələri yoxlamaq istədiyinizə əminsiniz?
          <br /><br />
          {!hasSelection ? (
            <strong>Bütün {pendingPages.length} boş səhifə {isConfirm ? 'təsdiqlənəcək' : 'rədd ediləcək'}</strong>
          ) : (
            <>
              {toConfirm.length > 0 && (
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#10b981' }}>
                    <><IconCheck size={14} /> {toConfirm.length} sual təsdiqlənəcək (0 bal):</>
                  </strong>
                </div>
              )}
              {toReject.length > 0 && (
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#ef4444' }}>
                    <><IconX size={14} /> {toReject.length} sual rədd ediləcək (hoca yoxlayacaq):</>
                  </strong>
                </div>
              )}
            </>
          )}
        </BulkConfirmDialogText>

        {toConfirm.length > 0 && (
          <>
            <div style={{ fontSize: '13px', fontWeight: '600', color: '#10b981', marginBottom: '8px' }}>
              Təsdiqlənəcək:
            </div>
            <QuestionList>
              {toConfirm.map(qNum => (
                <QuestionListItem key={qNum} style={{ borderColor: '#10b981' }}>
                  <><IconCheck size={14} /> {qNum}</>
                </QuestionListItem>
              ))}
            </QuestionList>
          </>
        )}

        {toReject.length > 0 && (
          <>
            <div style={{ fontSize: '13px', fontWeight: '600', color: '#ef4444', marginBottom: '8px' }}>
              Rədd ediləcək:
            </div>
            <QuestionList>
              {toReject.map(qNum => (
                <QuestionListItem key={qNum} style={{ borderColor: '#ef4444' }}>
                  <><IconX size={14} /> {qNum}</>
                </QuestionListItem>
              ))}
            </QuestionList>
          </>
        )}

        <BulkConfirmDialogButtons>
          <BulkConfirmButton onClick={onCancel} style={{ background: '#e5e7eb', color: '#374151' }}>
            Ləğv et
          </BulkConfirmButton>
          <BulkConfirmButton
            onClick={onConfirm}
            style={{
              background: isConfirm
                ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                : 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              color: 'white'
            }}
          >
            Bəli, {isConfirm ? 'Təsdiqlə' : 'Rədd Et'}
          </BulkConfirmButton>
        </BulkConfirmDialogButtons>
      </BulkConfirmDialogContent>
    </StyledModal>
  );
};

const BulkConfirmButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

const QuestionCheckbox = styled.input<{ disabled?: boolean }>`
  width: 18px;
  height: 18px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  accent-color: #3b82f6;
  margin-right: 8px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const QuestionCheckboxLabel = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  user-select: none;

  &:hover {
    color: ${props => props.$disabled ? 'inherit' : '#3b82f6'};
  }
`;

// Batch Apellyasiya Modal styled components
const BatchModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const SelectedQuestionsList = styled.div`
  background: #f8fafc;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 20px;
  max-height: 200px;
  overflow-y: auto;
`;

const SelectedQuestionTag = styled.span`
  display: inline-block;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  margin: 4px;
`;

// Appeal Statistics styled components
const AppealStatsCard = styled.div`
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  border: 2px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

const AppealStatsTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const AppealStatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
`;

const AppealStatItem = styled.div<{ $type: 'total' | 'pending' | 'completed' | 'rejected' }>`
  background: white;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  border: 2px solid ${props => {
    switch (props.$type) {
      case 'total': return '#3b82f6';
      case 'pending': return '#f59e0b';
      case 'completed': return '#10b981';
      case 'rejected': return '#ef4444';
      default: return '#e2e8f0';
    }
  }};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const AppealStatValue = styled.div<{ $type: 'total' | 'pending' | 'completed' | 'rejected' }>`
  font-size: 32px;
  font-weight: 700;
  color: ${props => {
    switch (props.$type) {
      case 'total': return '#3b82f6';
      case 'pending': return '#f59e0b';
      case 'completed': return '#10b981';
      case 'rejected': return '#ef4444';
      default: return '#1e293b';
    }
  }};
  margin-bottom: 8px;
`;

const AppealStatLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const AppealProgressBar = styled.div<{ $percentage: number }>`
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 12px;
  
  &::after {
    content: '';
    display: block;
    width: ${props => props.$percentage}%;
    height: 100%;
    background: linear-gradient(90deg, #10b981, #059669);
    transition: width 0.3s ease;
  }
`;

const FennCardSelected = styled(FennCard)<{ $selected?: boolean }>`
  border: ${props => props.$selected ? '3px solid #3b82f6' : '2px solid #10b981'} !important;
  background: ${props => props.$selected ? '#eff6ff' : 'white'} !important;
  transition: all 0.2s ease;
`;

// Helper function to convert score string (including fractions like "1/2") to number
const parseScoreToNumber = (score: string | number): number => {
  if (typeof score === 'number') {
    return isNaN(score) ? 0 : score;
  }
  
  if (!score || typeof score !== 'string') {
    return 0;
  }
  
  // Handle fractional scores like "1/2", "1/3", "2/3"
  if (score.includes('/')) {
    const [numerator, denominator] = score.split('/').map(s => parseFloat(s.trim()));
    if (!isNaN(numerator) && !isNaN(denominator) && denominator !== 0) {
      return numerator / denominator;
    }
    return 0;
  }
  
  // Handle regular numeric strings
  const num = parseFloat(score);
  return isNaN(num) ? 0 : num;
};

// Apellyasiya təyin tarixi: Firestore Timestamp və ya number → göstərmə / sıralama
const getApellyasiyaCreatedAtTime = (createdAt: any): number => {
  if (createdAt == null) return 0;
  if (typeof createdAt.toDate === 'function') return createdAt.toDate().getTime();
  if (typeof createdAt.toMillis === 'function') return createdAt.toMillis();
  if (typeof createdAt === 'number') return createdAt;
  if (createdAt?.seconds != null) return createdAt.seconds * 1000;
  return 0;
};
const formatApellyasiyaCreatedAt = (createdAt: any): string => {
  const t = getApellyasiyaCreatedAtTime(createdAt);
  if (!t) return '—';
  try {
    return new Date(t).toLocaleString('az-AZ', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return '—';
  }
};


const buraxilisBlankCtx = blankCtxFromExam;

const StudentResultsPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const toast = useToast();
  const urlStudentIdProcessedRef = useRef(false);

  const [students, setStudents] = useState<StudentDetailData[]>([]);
  const [filteredStudents, setFilteredStudents] = useState<StudentDetailData[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedStudent, setSelectedStudent] = useState<StudentDetailData | null>(null);
  
  // Seçili imtahan
  const [selectedExam, setSelectedExamState] = useState<any>(null);
  const [isBuraxilis, setIsBuraxilis] = useState(false);
  
  // Filtreler
  const [filterSinif, setFilterSinif] = useState<string>('');
  const [filterQrup, setFilterQrup] = useState<string>('');
  const [filterSubGroup, setFilterSubGroup] = useState<string>('');
  const [filterVariant, setFilterVariant] = useState<string>(''); // Buraxılış üçün
  const [filterXdil, setFilterXdil] = useState<string>(''); // Buraxılış üçün
  const [filterTeacher, setFilterTeacher] = useState<string>(''); // Buraxılış üçün - Q##_c hocaId
  const [filterStatus, setFilterStatus] = useState<string>(''); // all, yoklanmis, yoklanmamis
  const [searchQuery, setSearchQuery] = useState<string>('');
  
  // Boş kağıt confirmation
  const [confirmZeroFenn, setConfirmZeroFenn] = useState<string | null>(null);
  const [isSettingZero, setIsSettingZero] = useState(false);
  
  // Toplu boş kağıt için checkbox'lar
  const [selectedFennList, setSelectedFennList] = useState<string[]>([]);
  const [showBulkConfirm, setShowBulkConfirm] = useState(false);
  const [isBulkSettingZero, setIsBulkSettingZero] = useState(false);
  
  // Image viewer
  const [viewingImage, setViewingImage] = useState<{ fenn: string; studentId: string } | null>(null);
  const [imageLoading, setImageLoading] = useState(false);
  const imageContainerRef = React.useRef<HTMLDivElement>(null);
  
  // Success toast
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  // Content query (href content=Suallar:... Şikayət:...) – yalnız hər ikisi varsa göstərilir
  const [contentNoteData, setContentNoteData] = useState<{ suallar: string; sikayet: string } | null>(null);
  const [contentNoteMinimized, setContentNoteMinimized] = useState(false);
  const [contentNoteDismissed, setContentNoteDismissed] = useState(false);
  
  // Empty page verification
  const [activeTab, setActiveTab] = useState<'results' | 'emptyVerification' | 'apellyasiya'>('results');
  const [emptyPagesToVerify, setEmptyPagesToVerify] = useState<Array<{
    studentId: string;
    studentName: string;
    questionNumber: string;
    questionData: any;
    grade: number;
    verificationStatus?: 'pending' | 'confirmed' | 'rejected';
    verifiedAt?: Date;
    blokMode?: BlokMode;
  }>>([]);
  const [currentEmptyPageIndex, setCurrentEmptyPageIndex] = useState(0);
  const [verificationViewMode, setVerificationViewMode] = useState<'single' | 'list' | 'student'>('single');
  const [verificationFilter, setVerificationFilter] = useState<'all' | 'pending' | 'confirmed' | 'rejected'>('all');
  const [emptyPageSearchTerm, setEmptyPageSearchTerm] = useState('');

  // Pixel-based filtering state
  const [pixelFilterEnabled, setPixelFilterEnabled] = useState(false);
  const [pixelThreshold, setPixelThreshold] = useState<string>('800');
  const [pixelOperator, setPixelOperator] = useState<'>' | '<' | '>=' | '<=' | '='>('>=');

  // Apellyasiya list view
  const [allApellyasiyas, setAllApellyasiyas] = useState<Array<{
    id: string;
    studentId: string;
    studentName: string;
    questionNumber: string;
    fenn: string;
    previousScore: string | number;
    newScore: string | number | null;
    scoreChange: number | null;
    apellyasiyaNote?: string;
    apellyasiyaHoca?: string;
    apellyasiyaHocaId?: string;
    /** Təyin edən müəllim – yoxla-s sənədindən (hocaId/hocaName) */
    assignedHocaId?: string;
    assignedHocaName?: string;
    originalHoca?: string;
    status: 'pending' | 'completed';
    createdAt?: any;
    completedAt?: any;
    grade?: string;
  }>>([]);
  const [apellyasiyaListFilter, setApellyasiyaListFilter] = useState<'all' | 'pending' | 'completed'>('all');
  const [apellyasiyaScoreFilter, setApellyasiyaScoreFilter] = useState<'all' | 'increased' | 'decreased' | 'unchanged'>('all');
  const [apellyasiyaTeacherFilter, setApellyasiyaTeacherFilter] = useState<string>('all');
  // Şagird kartı statusu: kart bazlı (tamamen tamamlanan / tamamen gözləyən / qismən)
  const [apellyasiyaStudentCardFilter, setApellyasiyaStudentCardFilter] = useState<'all' | 'all_completed' | 'all_pending' | 'partial'>('all');
  // Sıralama: ad (A-Z / Z-A) və ya tarix (ən yeni / ən köhnə)
  const [apellyasiyaSortOrder, setApellyasiyaSortOrder] = useState<'name_asc' | 'name_desc' | 'date_desc' | 'date_asc'>('name_asc');
  const [showWhatsAppTeachersSection, setShowWhatsAppTeachersSection] = useState(true);
  const [teachersList, setTeachersList] = useState<Array<{ id: string; name: string; phoneNumber?: string }>>([]);

  // Buraxılış üçün: Q##_c field-lərindən mövcud müəllimlər (hocaId/hoca) siyahısı
  const [availableTeachers, setAvailableTeachers] = useState<Array<{ id: string; name: string }>>([]);
  const [emptyImageLoading, setEmptyImageLoading] = useState(false);

  // Student-based empty verification mode state
  const [selectedStudentGroup, setSelectedStudentGroup] = useState<StudentEmptyPages | null>(null);
  const [showStudentDetail, setShowStudentDetail] = useState(false);
  const [bulkProcessing, setBulkProcessing] = useState(false);
  const [showBulkConfirmDialog, setShowBulkConfirmDialog] = useState(false);
  const [bulkConfirmAction, setBulkConfirmAction] = useState<'confirm' | 'reject' | null>(null);

  // Track selected question numbers for checkbox-based verification
  const [selectedQuestionNumbers, setSelectedQuestionNumbers] = useState<Set<string>>(new Set());

  // Data validation and cleanup state (Phase 2)
  const [showValidationPreviewModal, setShowValidationPreviewModal] = useState(false);
  const [showValidationResultsModal, setShowValidationResultsModal] = useState(false);
  const [validationPreview, setValidationPreview] = useState<{
    inconsistencies: Array<{
      studentId: string;
      studentName: string;
      questionNumber: string;
      currentQ_c: any;
      documentId: string;
    }>;
    totalCount: number;
  } | null>(null);
  const [validationResults, setValidationResults] = useState<{
    deleted: number;
    errors: number;
    details: Array<{
      studentId: string;
      questionNumber: string;
      error?: string;
    }>;
  } | null>(null);
  const [isValidating, setIsValidating] = useState(false);
  const [isCleaningUp, setIsCleaningUp] = useState(false);
  const [showEmptyPageZipModal, setShowEmptyPageZipModal] = useState(false);

  // Reset loading state when page index changes (safety measure for consistent loading behavior)
  useEffect(() => {
    setEmptyImageLoading(true);
  }, [currentEmptyPageIndex]);

  // Reset to first page when pixel filter changes
  useEffect(() => {
    if (pixelFilterEnabled) {
      setCurrentEmptyPageIndex(0);
    }
  }, [pixelThreshold, pixelOperator, pixelFilterEnabled]);

  // Reset to first page when verification filter changes
  useEffect(() => {
    setCurrentEmptyPageIndex(0);
  }, [verificationFilter]);

  // Apellyasiya state-ləri
  const [showApellyasiyaModal, setShowApellyasiyaModal] = useState(false);
  const [apellyasiyaQuestionNum, setApellyasiyaQuestionNum] = useState<string | null>(null);
  const [apellyasiyaReason, setApellyasiyaReason] = useState<string>('');
  const [apellyasiyaSelectedTeacher, setApellyasiyaSelectedTeacher] = useState<string>('');
  const [apellyasiyaTeachers, setApellyasiyaTeachers] = useState<Teacher[]>([]);
  const [apellyasiyaLoading, setApellyasiyaLoading] = useState(false);
  const [apellyasiyas, setApellyasiyas] = useState<Map<string, any>>(new Map()); // questionNum -> apellyasiya data

  // Batch Apellyasiya state-ləri
  const [selectedQuestionsForAppeal, setSelectedQuestionsForAppeal] = useState<Set<string>>(new Set());
  const [showBatchApellyasiyaModal, setShowBatchApellyasiyaModal] = useState(false);
  const [batchModalStep, setBatchModalStep] = useState<'select' | 'assign'>('select'); // Modal aşaması: select (soru seçimi) veya assign (hoca/sebep)
  const [batchApellyasiyaReason, setBatchApellyasiyaReason] = useState<string>('');
  // Her soru için ayrı öğretmen seçimi: questionNum -> teacherId
  const [batchQuestionTeachers, setBatchQuestionTeachers] = useState<Map<string, string>>(new Map());
  // Her soru için öğretmen listesi: questionNum -> Teacher[]
  const [batchQuestionTeachersList, setBatchQuestionTeachersList] = useState<Map<string, Teacher[]>>(new Map());
  const [batchApellyasiyaLoading, setBatchApellyasiyaLoading] = useState(false);
  // Modal içinde seçilen sorular (modal açıldığında sıfırlanır)
  const [modalSelectedQuestions, setModalSelectedQuestions] = useState<Set<string>>(new Set());

  // Question Scoring Modal state-ləri
  const [showQuestionScoringModal, setShowQuestionScoringModal] = useState(false);
  const [scoringQuestionNumber, setScoringQuestionNumber] = useState<string | null>(null);
  const [savingScore, setSavingScore] = useState(false);

  // Xarici dillər siyahısı
  const FOREIGN_LANGUAGES = ['İngilis dili', 'Rus dili', 'Alman dili', 'Fransız dili'];

  // Helper: Xdil normalize et - "İngilis" -> "İngilis dili"
  const normalizeXdil = (xdil: string | undefined): string => {
    if (!xdil) return '';
    const normalized = xdil.trim();
    if (normalized === 'İngilis' || normalized === 'Rus' || normalized === 'Alman' || normalized === 'Fransız') {
      return `${normalized} dili`;
    }
    return normalized;
  };

  // Calculate appeal statistics for a student
  const calculateAppealStatistics = (student: StudentDetailData | null) => {
    if (!student) {
      return { total: 0, pending: 0, completed: 0, rejected: 0 };
    }

    let total = 0;
    let pending = 0;
    let completed = 0;
    let rejected = 0;

    // Check all Q##_c fields for appeal status
    const studentAny = student as any;
    Object.keys(studentAny).forEach((key) => {
      if (/^Q\d+_c$/.test(key)) {
        const gradingData = studentAny[key];
        if (gradingData && typeof gradingData === 'object') {
          // Check if there's an appeal in yoxla-s collection
          const questionNum = key.replace('_c', '');
          const apellyasiya = apellyasiyas.get(questionNum);
          
          // Check if appeal is completed (from Q##_c field)
          const isCompleted = gradingData.apellyasiya_status === true || gradingData.apellyasiya_result === true;
          const isRejected = gradingData.apellyasiya_result === false;
          
          // Check if appeal is pending (from yoxla-s collection)
          const isPending = apellyasiya && 
                           apellyasiya.apellyasiya_status === 'pending' && 
                           !isCompleted;

          if (isCompleted || isPending || isRejected || apellyasiya) {
            total++;
            if (isCompleted) {
              completed++;
            } else if (isRejected) {
              rejected++;
            } else if (isPending) {
              pending++;
            } else if (apellyasiya) {
              // Appeal exists but status unclear, assume pending
              pending++;
            }
          }
        }
      }
    });

    return { total, pending, completed, rejected };
  };

  // İlk yüklənmə: href query (exam, studentId) əmələ gətir, sonra şagirdləri yüklə
  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const examId = searchParams.get('exam');
      if (examId) {
        const exam = await getExamById(examId);
        if (exam && !cancelled) setSelectedExam(exam);
      }
      await loadStudents();
    };
    run();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- yalnız mount-da
  }, []);

  // Href-də studentId varsa və şagirdlər yüklənibsə: ətraflı modalı aç və ya xəta göstər
  useEffect(() => {
    if (loading || urlStudentIdProcessedRef.current) return;
    const studentId = searchParams.get('studentId');
    if (!studentId) return;
    urlStudentIdProcessedRef.current = true;
    const student = students.find(
      (s) => s.id === studentId || String(s.student_id) === studentId
    );
    if (student) {
      setSelectedStudent(student);
    } else {
      setSuccessMessage('Şagird tapılmadı: ' + studentId);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 5000);
    }
  }, [loading, students, searchParams]);

  // Href content query: yalnız Suallar və Şikayət hər ikisi varsa content not göstərilir
  useEffect(() => {
    const raw = searchParams.get('content');
    const parsed = parseContentQuery(raw);
    if (parsed) {
      setContentNoteData(parsed);
      setContentNoteDismissed(false);
      setContentNoteMinimized(false);
    } else {
      setContentNoteData(null);
    }
  }, [searchParams]);

  useEffect(() => {
    applyFilters();
  }, [students, filterSinif, filterQrup, filterSubGroup, filterVariant, filterXdil, filterTeacher, filterStatus, searchQuery]);

  // Buraxılış rejimində Q##_c field-lərinə görə müəllim siyahısını çıxart
  useEffect(() => {
    if (!isBuraxilis || students.length === 0) {
      setAvailableTeachers([]);
      return;
    }

    const teacherMap = new Map<string, string>();

    students.forEach((student) => {
      const sAny = student as any;
      Object.keys(sAny).forEach((key) => {
        if (/^Q\d+_c$/.test(key)) {
          const val = sAny[key];
          if (val && typeof val === 'object' && val.hocaId) {
            const id = String(val.hocaId);
            const name = val.hoca || (id === 'admin' ? 'Admin' : 'Müəllim');
            if (!teacherMap.has(id)) {
              teacherMap.set(id, name);
            }
          }
        }
      });
    });

    const teachersArray = Array.from(teacherMap.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((a, b) => a.name.localeCompare(b.name, 'az'));

    setAvailableTeachers(teachersArray);
  }, [isBuraxilis, students]);

  // Modal kapatıldığında seçili fennleri temizle
  useEffect(() => {
    if (!selectedStudent) {
      setSelectedFennList([]);
    }
  }, [selectedStudent]);

  // Helper function to get actual questions for Blok mode (new or legacy format)
  const getActualBlokQuestions = (student: StudentDetailData): string[] => {
    const mode = detectBlokMode(student);
    if (mode === 'new') {
      const studentQuestions = (student as any).questions || [];
      return studentQuestions.map((q: any) => q.questionNumber);
    } else {
      // LEGACY MODE: Return ONLY the 9 questions used in this system
      // Questions Q1-Q27, Q31-Q57, Q61-Q87 DO NOT EXIST in this Blok system
      return [
        'Q28', 'Q29', 'Q30',  // Fənn 1
        'Q58', 'Q59', 'Q60',  // Fənn 2
        'Q88', 'Q89', 'Q90'   // Fənn 3
      ];
    }
  };

  // Apply pixel-based filtering to create filtered list
  const getFilteredPagesByPixel = () => {
    if (!pixelFilterEnabled || !pixelThreshold) {
      return emptyPagesToVerify;
    }

    const threshold = parseInt(pixelThreshold);
    if (isNaN(threshold)) return emptyPagesToVerify;

    return emptyPagesToVerify.filter(page => {
      const pixelCount = page.questionData?.blue_pixels || 0;

      switch (pixelOperator) {
        case '>': return pixelCount > threshold;
        case '<': return pixelCount < threshold;
        case '>=': return pixelCount >= threshold;
        case '<=': return pixelCount <= threshold;
        case '=': return pixelCount === threshold;
        default: return true;
      }
    });
  };

  const filteredPagesByPixel = getFilteredPagesByPixel();

  // Apply both pixel AND verification status filters for single/list view navigation
  const getFilteredPages = () => {
    let pages = pixelFilterEnabled ? filteredPagesByPixel : emptyPagesToVerify;

    // Text search by student name or ID
    if (emptyPageSearchTerm.trim()) {
      const term = emptyPageSearchTerm.toLowerCase().trim();
      pages = pages.filter(p =>
        p.studentName.toLowerCase().includes(term) ||
        p.studentId.toLowerCase().includes(term)
      );
    }

    // Apply verification status filter
    if (verificationFilter !== 'all') {
      pages = pages.filter(page => page.verificationStatus === verificationFilter);
    }

    return pages;
  };

  const filteredPages = getFilteredPages();

  // Prevent index out-of-bounds when filters change or pages are verified
  useEffect(() => {
    if (currentEmptyPageIndex >= filteredPages.length && filteredPages.length > 0) {
      setCurrentEmptyPageIndex(Math.max(0, filteredPages.length - 1));
    }
  }, [filteredPages.length]);

  // Helper function to get total questions for a student (for student-based verification)
  const getTotalQuestionsForStudent = (studentId: string): number => {
    const student = students.find(s => s.student_id === studentId);
    if (!student) return 0;

    if (isBuraxilis) {
      const grade = parseInt(String(student.grade || '0'));
      const config = getEffectiveBuraxilisQuestionsForStudent(grade, student.xdil, buraxilisBlankCtx(selectedExam, student));
      return config ? config.reduce((sum, subj) => sum + subj.questions.length, 0) : 0;
    } else {
      // Blok: 9 questions (Q28-30, Q58-60, Q88-90)
      return getActualBlokQuestions(student).length;
    }
  };

  // Group empty pages by student for student-based verification mode
  const groupEmptyPagesByStudent = (emptyPages: Array<{
    studentId: string;
    studentName: string;
    questionNumber: string;
    questionData: any;
    grade: number;
    verificationStatus?: 'pending' | 'confirmed' | 'rejected';
    verifiedAt?: Date;
    blokMode?: BlokMode;
  }>): StudentEmptyPages[] => {
    const groupMap = new Map<string, StudentEmptyPages>();

    emptyPages.forEach(page => {
      if (!groupMap.has(page.studentId)) {
        // Find student for additional metadata
        const student = students.find(s => s.student_id === page.studentId);

        groupMap.set(page.studentId, {
          studentId: page.studentId,
          studentName: page.studentName,
          grade: page.grade,
          specialtyGroup: student?.specialtyGroup,
          variant: student?.variant,
          xdil: student?.xdil,
          emptyPages: [],
          totalCount: 0,
          verifiedCount: 0,
          pendingCount: 0,
          isAllEmpty: false,
          totalQuestions: getTotalQuestionsForStudent(page.studentId)
        });
      }

      const group = groupMap.get(page.studentId)!;
      group.emptyPages.push(page);
      group.totalCount++;

      if (page.verificationStatus === 'confirmed' || page.verificationStatus === 'rejected') {
        group.verifiedCount++;
      } else {
        group.pendingCount++;
      }
    });

    // Check if all questions are empty
    groupMap.forEach(group => {
      group.isAllEmpty = group.totalCount === group.totalQuestions;
    });

    return Array.from(groupMap.values());
  };

  // Sort students by priority: all-empty first, then by pending count, then by total count
  const sortStudentsByPriority = (groups: StudentEmptyPages[]): StudentEmptyPages[] => {
    return [...groups].sort((a, b) => {
      // Primary: all-empty first
      if (a.isAllEmpty && !b.isAllEmpty) return -1;
      if (!a.isAllEmpty && b.isAllEmpty) return 1;

      // Secondary: pending count descending
      if (a.pendingCount !== b.pendingCount) {
        return b.pendingCount - a.pendingCount;
      }

      // Tertiary: total count descending
      return b.totalCount - a.totalCount;
    });
  };

  // Derived state for student-based empty verification mode
  const studentGroups = useMemo(() => {
    const pagesToGroup = pixelFilterEnabled ? filteredPagesByPixel : emptyPagesToVerify;
    return groupEmptyPagesByStudent(pagesToGroup);
  }, [emptyPagesToVerify, pixelFilterEnabled, filteredPagesByPixel]);

  const sortedStudentGroups = useMemo(() => {
    return sortStudentsByPriority(studentGroups);
  }, [studentGroups]);

  const filteredSortedStudentGroups = useMemo(() => {
    if (!emptyPageSearchTerm.trim()) return sortedStudentGroups;
    const term = emptyPageSearchTerm.toLowerCase().trim();
    return sortedStudentGroups.filter(g =>
      g.studentName.toLowerCase().includes(term) ||
      g.studentId.toLowerCase().includes(term)
    );
  }, [sortedStudentGroups, emptyPageSearchTerm]);

  const collectEmptyPagesToVerify = (
    students: StudentDetailData[],
    detectedMode?: ExamMode,
    examForBlank?: any
  ) => {
    const examCtx = examForBlank ?? selectedExam;
    const emptyPages: Array<{
      studentId: string;
      studentName: string;
      questionNumber: string;
      questionData: any;
      grade: number;
      verificationStatus?: 'pending' | 'confirmed' | 'rejected';
      verifiedAt?: Date;
      blokMode?: BlokMode;
    }> = [];

    // Use detected mode as primary source of truth, fallback to isBuraxilis flag
    const effectiveMode = detectedMode || (isBuraxilis ? 'buraxilis' : 'blok');

    console.log('🔍 Empty page collection - Effective mode:', effectiveMode);
    console.log('🔍 Config mode (isBuraxilis):', isBuraxilis);
    console.log('🎓 Using', effectiveMode === 'buraxilis' ? 'Buraxılış' : 'Blok', 'question collection logic');
    console.log('📋 Grade11 blank scheme:', examCtx?.grade11BlankScheme, 'createdAt:', examCtx?.createdAt);

    if (effectiveMode === 'buraxilis') {
      // Buraxılış logic
      console.log('🎓 Collecting empty pages for Buraxılış exam');

      students.forEach((student, studentIndex) => {
        const grade = parseInt(String(student.grade || '0'));
        const buraxilisQuestions = getEffectiveBuraxilisQuestionsForStudent(
          grade,
          student.xdil,
          buraxilisBlankCtx(examCtx, student)
        );

        if (!buraxilisQuestions || buraxilisQuestions.length === 0) {
          console.error(`⚠️ No Buraxılış questions config for grade ${grade}`);
          console.error(`⚠️ Student: ${student.student_id} will be skipped`);
          // Don't skip - just log and continue to next student
          return;
        }

        const expectedCount = buraxilisQuestions.reduce(
          (sum, subj) => sum + subj.questions.length,
          0
        );

        if (studentIndex === 0) {
          console.log(`📋 Grade ${grade} expects ${expectedCount} questions:`,
            buraxilisQuestions.flatMap(s => s.questions)
          );
        }

        let foundEmptyCount = 0;

        buraxilisQuestions.forEach(subjectGroup => {
          subjectGroup.questions.forEach(qNum => {
            // Try to access the field directly from student object
            const studentObj = student as any;
            const questionData = studentObj[qNum];

            if (studentIndex === 0) {
              console.log(`🔍 Checking ${student.student_id} - ${qNum}:`, {
                exists: !!questionData,
                is_empty: questionData?.is_empty,
                has_path: !!questionData?.path
              });
            }

            // Check if question has is_empty: true and needs verification
            if (questionData &&
              typeof questionData === 'object' &&
              questionData.is_empty === true &&
              questionData.path) {

              foundEmptyCount++;
              emptyPages.push({
                studentId: student.student_id,
                studentName: `${student.firstName} ${student.lastName}`,
                questionNumber: qNum,
                questionData: questionData,
                grade: grade,
                verificationStatus: questionData.double_check_empty === true ? 'confirmed' :
                  questionData.double_check_empty === false ? 'rejected' : 'pending',
                verifiedAt: questionData.double_check_empty !== undefined ? new Date() : undefined,
                blokMode: undefined // Buraxılış doesn't use blokMode
              });
            }
          });
        });

        if (foundEmptyCount > 0 && studentIndex === 0) {
          console.log(`✅ First student has ${foundEmptyCount} empty pages out of ${expectedCount}`);
        }
      });

      console.log(`📋 Total Buraxılış empty pages collected: ${emptyPages.length}`);
    } else {
      // Blok exam logic
      console.log('🔧 Collecting empty pages for Blok exam');

      students.forEach((student, studentIndex) => {
        const grade = parseInt(String(student.grade || '0'));
        const qrup = student.specialtyGroup;

        // Detect Blok mode (legacy vs new format)
        const mode = detectBlokMode(student);
        console.log(`🔍 Student ${student.student_id} - Blok mode:`, mode);

        // Get fenn configurations for this qrup
        const fennConfigs = getFennlerByQrup(qrup);

        if (studentIndex === 0) {
          console.log('📋 Blok exam - First student details:', {
            grade,
            qrup,
            mode,
            fennConfigs: fennConfigs.map(f => `${f.fenn} (${f.start}-${f.end})`)
          });
        }

        // Get actual questions for this student (handles both new and legacy formats)
        const actualQuestions = getActualBlokQuestions(student);

        // Check each actual question for empty status
        actualQuestions.forEach(questionNumberStr => {
          // For legacy mode: check Q##.is_empty field
          if (mode === 'legacy') {
            const questionData = (student as any)[questionNumberStr];

            if (questionData &&
              typeof questionData === 'object' &&
              questionData.is_empty === true &&
              questionData.path) {

              emptyPages.push({
                studentId: student.student_id,
                studentName: `${student.firstName} ${student.lastName}`,
                questionNumber: questionNumberStr,
                questionData: questionData,
                grade: grade,
                verificationStatus: questionData.double_check_empty === true ? 'confirmed' :
                  questionData.double_check_empty === false ? 'rejected' : 'pending',
                verifiedAt: questionData.double_check_empty !== undefined ? new Date() : undefined,
                blokMode: mode
              });
            }
          } else if (mode === 'new') {
            // For new mode: check if question is missing from questions array
            const isEmpty = getQuestionEmptyStatus(student, questionNumberStr);

            if (isEmpty === true) {
              // Question is effectively empty (missing from questions array)
              // In new format, blank_question_count tells us how many are blank
              // We need to find which specific questions are empty
              const questionPath = getQuestionPath(student, questionNumberStr);

              emptyPages.push({
                studentId: student.student_id,
                studentName: `${student.firstName} ${student.lastName}`,
                questionNumber: questionNumberStr,
                questionData: { path: questionPath, is_empty: true },
                grade: grade,
                verificationStatus: 'pending',
                verifiedAt: undefined,
                blokMode: mode
              });
            }
          }
        });
      });

      console.log(`📋 Total Blok empty pages collected: ${emptyPages.length}`);
    }

    console.log('📋 Total empty pages to verify:', emptyPages.length);
    console.log('📋 Empty pages details:', emptyPages);
    setEmptyPagesToVerify(emptyPages);
  };

  // ==================== PHASE 2: Data Validation and Cleanup ====================

  // Scan all students for inconsistent Q##_c fields
  const scanForInconsistencies = async (): Promise<Array<{
    studentId: string;
    studentName: string;
    questionNumber: string;
    currentQ_c: any;
    documentId: string;
  }>> => {
    const inconsistencies: Array<{
      studentId: string;
      studentName: string;
      questionNumber: string;
      currentQ_c: any;
      documentId: string;
    }> = [];

    console.log('🔍 Starting data validation scan...');
    let scannedCount = 0;

    students.forEach((student) => {
      const studentAny = student as any;
      const studentName = `${student.firstName} ${student.lastName}`;

      // Check all Q##_c fields
      Object.keys(studentAny).forEach((key) => {
        if (!/^Q\d+_c$/.test(key)) return; // Only check Q##_c fields

        const q_c = studentAny[key];
        if (!q_c || typeof q_c !== 'object') return;

        // Check if this is an admin empty paper grading
        const isAdminEmptyPaper =
          q_c.note?.includes('Boş sual - Admin tərəfindən təsdiqləndi') ||
          q_c.note?.includes('Boş kağız');

        if (!isAdminEmptyPaper) return; // Skip non-admin-empty papers

        // Get corresponding Q## field to check double_check_empty status
        const qNum = key.replace('_c', '');
        const qData = studentAny[qNum];

        if (!qData || typeof qData !== 'object') return;

        // INCONSISTENCY: double_check_empty is not true, but Q##_c exists with admin empty paper
        if (qData.double_check_empty !== true) {
          inconsistencies.push({
            studentId: student.student_id,
            studentName,
            questionNumber: qNum,
            currentQ_c: q_c,
            documentId: student.id
          });
          console.log(`⚠️ Inconsistency found: ${studentName} (${student.student_id}) - ${qNum}`);
        }
      });

      scannedCount++;
    });

    console.log(`✅ Scan complete: ${inconsistencies.length} inconsistencies found in ${scannedCount} students`);
    return inconsistencies;
  };

  // Stage 1: Scan and show preview
  const handleValidateAndPreview = async () => {
    setIsValidating(true);
    try {
      console.log('🔍 Starting data validation...');
      const inconsistencies = await scanForInconsistencies();

      setValidationPreview({
        inconsistencies,
        totalCount: inconsistencies.length
      });
      setShowValidationPreviewModal(true);

      console.log(`✅ Preview ready: ${inconsistencies.length} items to review`);
    } catch (error) {
      console.error('❌ Validation scan error:', error);
      alert('Veriləri təhlil edərkən xəta baş verdi');
    } finally {
      setIsValidating(false);
    }
  };

  // Stage 2: Execute cleanup after confirmation
  const handleExecuteCleanup = async () => {
    if (!validationPreview) return;

    setIsCleaningUp(true);
    setShowValidationPreviewModal(false); // Close preview modal

    try {
      console.log(`🧹 Starting cleanup of ${validationPreview.totalCount} items...`);

      const { updateDoc, doc, deleteField } = await import('firebase/firestore');
      const { db } = await import('../../firebase');

      let deletedCount = 0;
      let errorCount = 0;
      const errorDetails: Array<{ studentId: string; questionNumber: string; error?: string }> = [];

      // Group updates by student for efficiency
      const updatesByStudent = new Map<string, string[]>();
      validationPreview.inconsistencies.forEach((item) => {
        if (!updatesByStudent.has(item.documentId)) {
          updatesByStudent.set(item.documentId, []);
        }
        updatesByStudent.get(item.documentId)!.push(item.questionNumber);
      });

      // Execute deletions per student
      for (const [documentId, questionNumbers] of updatesByStudent.entries()) {
        try {
          const updates: Record<string, any> = {};
          questionNumbers.forEach(qNum => {
            updates[`${qNum}_c`] = deleteField();
          });

          await updateDoc(doc(db, selectedExam?.collection || 'buraxilis2', documentId), updates);
          deletedCount += questionNumbers.length;
          console.log(`✅ Deleted ${questionNumbers.length} Q##_c fields for student ${documentId}`);
        } catch (error: any) {
          errorCount += questionNumbers.length;
          questionNumbers.forEach(qNum => {
            errorDetails.push({
              studentId: documentId,
              questionNumber: qNum,
              error: error.message
            });
          });
          console.error(`❌ Error deleting fields for student ${documentId}:`, error);
        }
      }

      // Set results and show results modal
      setValidationResults({
        deleted: deletedCount,
        errors: errorCount,
        details: errorDetails
      });
      setShowValidationResultsModal(true);

      // Show success toast
      setSuccessMessage(
        `✅ Data cleanup complete: ${deletedCount} deleted${errorCount > 0 ? `, ${errorCount} errors` : ''}`
      );
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 5000);

      // Refresh data
      console.log('🔄 Refreshing student data...');
      await loadStudents();

    } catch (error) {
      console.error('❌ Cleanup execution error:', error);
      alert('Təmizləmə əməliyyatı zamanı xəta baş verdi');
    } finally {
      setIsCleaningUp(false);
    }
  };

  // Cancel preview without cleanup
  const handleCancelPreview = () => {
    setShowValidationPreviewModal(false);
    setValidationPreview(null);
    console.log('ℹ️ Preview cancelled - no changes made');
  };

  // Close results modal and optionally re-run
  const handleCloseResults = () => {
    setShowValidationResultsModal(false);
    setValidationResults(null);
  };

  // Re-run validation from results modal
  const handleRerunValidation = () => {
    setShowValidationResultsModal(false);
    setValidationResults(null);
    handleValidateAndPreview();
  };

  // ==================== END PHASE 2 ====================

  const loadStudents = async () => {
    try {
      setLoading(true);
      
      const storedExam = getSelectedExam();
      let exam = storedExam;
      if (storedExam?.id) {
        const freshExam = await getExamById(storedExam.id);
        if (freshExam) {
          exam = freshExam;
          setSelectedExam(freshExam);
        }
      }
      const rawType = String(exam?.type || '').toLowerCase();
      const collectionFilter = exam?.collection || 'scanned2610';
      const isBuraxilisExam = rawType === 'buraxilis' || rawType === 'buraxılış' || rawType === 'buraxılıs';
      
      setSelectedExamState(exam);
      setIsBuraxilis(isBuraxilisExam);
      
      console.log('👨‍🎓 StudentResultsPage: Seçili imtahan:', exam);
      console.log('🔍 StudentResultsPage: Collection filter:', collectionFilter);
      console.log('🎓 StudentResultsPage: Buraxılış modu:', isBuraxilisExam);
      
      const data = await getAllStudents(collectionFilter);
      
      console.log('✅ StudentResultsPage: Yüklenen öğrenciler:', data.length);
      
      if (data.length > 0) {
        const firstStudent = data[0];
        const allKeys = Object.keys(firstStudent);
        const qFields = allKeys.filter(k => k.match(/^Q\d+_c$/));
        const questionFields = allKeys.filter(k => k.match(/^Q\d+$/));
        
        console.log('🔍 İLK ÖĞRENCİ TÜM VERİLERİ:', firstStudent);
        console.log('📋 Sual field-ləri (Q78, Q79 vs):', questionFields);
        console.log('📋 Qiymət field-ləri (Q78_c, Q79_c vs):', qFields);
        
        // Log sample question data
        if (questionFields.length > 0) {
          console.log('📋 Sample question data:', {
            field: questionFields[0],
            data: (firstStudent as any)[questionFields[0]]
          });
        }
        
        console.log('📋 İlk öğrenci DETAYI:', {
          id: firstStudent.id,
          student_id: firstStudent.student_id,
          firstName: firstStudent.firstName,
          lastName: firstStudent.lastName,
          grade: firstStudent.grade,
          gradeType: typeof firstStudent.grade,
          variant: firstStudent.variant,
          xdil: firstStudent.xdil,
          status: firstStudent.status,
          specialtyGroup: firstStudent.specialtyGroup,
          subGroup: firstStudent.subGroup,
          completedFennCount: firstStudent.completedFennCount,
          totalFennCount: firstStudent.totalFennCount,
          allFieldCount: allKeys.length,
          buraxilisFieldCount: qFields.length,
          buraxilisFields: qFields.slice(0, 10),
          sampleQField: qFields.length > 0 ? { 
            field: qFields[0], 
            value: (firstStudent as any)[qFields[0]] 
          } : null
        });
      }
      
      setStudents(data);

      // VALIDATE: Detect actual mode from first student document
      let detectedMode: ExamMode | null = null;
      if (data.length > 0) {
        const firstStudent = data[0] as any;
        const configMode = isBuraxilisExam ? 'buraxilis' : 'blok';
        const detection = detectExamMode(firstStudent, configMode);

        console.log('🔍 Mode detection result:', {
          mode: detection.mode,
          confidence: detection.confidence,
          indicators: detection.indicators,
          warnings: detection.warnings
        });

        // Store detected mode for use in empty page collection
        detectedMode = detection.mode;

        // Show warning if there's a mismatch
        if (detection.warnings && detection.warnings.length > 0 && !(isBuraxilisExam && detection.mode === 'blok')) {
          console.warn('⚠️ MODE MISMATCH DETECTED:');
          detection.warnings.forEach(w => console.warn(`  - ${w}`));

          // Show warning toast to user
          setSuccessMessage(
            `⚠️ İmtahan növü uyğunsuzluğu: Config says ${configMode} but documents suggest ${detection.mode}`
          );
          setShowSuccessToast(true);
          setTimeout(() => setShowSuccessToast(false), 5000);
        }
      }

      // Collect empty pages for verification - for both Buraxılış and Blok exams
      if (data.length > 0) {
        // İmtahan növü Buraxılışdırsa sənəddəki specialtyGroup bunu Blok etməsin.
        // Əks halda işlənmiş Q26/Q42 sahələri oxunmur və şagird Yoxlanmamış görünür.
        const modeForPages: ExamMode = isBuraxilisExam ? 'buraxilis' : (detectedMode || 'blok');
        collectEmptyPagesToVerify(data, modeForPages, exam);
      }
    } catch (error) {
      console.error('Şagirdlər yüklənərkən xəta:', error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...students];

    // Sinif filtri
    if (filterSinif) {
      filtered = filtered.filter(s => s.grade === filterSinif);
    }

    if (isBuraxilis) {
      // Buraxılış mode: filter by variant and xdil
      if (filterVariant) {
        filtered = filtered.filter(s => s.variant === filterVariant);
      }

      if (filterXdil) {
        filtered = filtered.filter(s => normalizeXdil(s.xdil) === filterXdil);
      }

      // Buraxılış: müəllimə görə filter (Q##_c.hocaId)
      if (filterTeacher) {
        filtered = filtered.filter(s => {
          const sAny = s as any;
          return Object.keys(sAny).some(key => {
            if (!/^Q\d+_c$/.test(key)) return false;
            const val = sAny[key];
            return val && typeof val === 'object' && String(val.hocaId) === filterTeacher;
          });
        });
      }
    } else {
      // Blok mode: filter by qrup and subGroup
      // Qrup filtri
      if (filterQrup) {
        filtered = filtered.filter(s => s.specialtyGroup === filterQrup);
      }

      // SubGroup filtri (normalize ederek karşılaştır)
      if (filterSubGroup) {
        const normalizeForComparison = (sg: string | undefined): string => {
          if (!sg) return '';
          // "RI" -> "Rİ", "RK" -> "RK" vb.
          return sg.toUpperCase().replace('RI', 'Rİ');
        };
        
        filtered = filtered.filter(s => 
          normalizeForComparison(s.subGroup) === normalizeForComparison(filterSubGroup)
        );
      }
    }

    // Vəziyyət filtri
    if (filterStatus === 'tamamlandi') {
      // Tamamlanmış: Tüm sorular yoklanmış
      if (isBuraxilis) {
        filtered = filtered.filter(s => {
          if (!s.grade) return false;
          const gradeNum = typeof s.grade === 'number' ? s.grade : parseInt(s.grade as string);
          const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, s.xdil, buraxilisBlankCtx(selectedExam, s));
          if (!gradeQuestions || gradeQuestions.length === 0) return false;
          const totalQuestions = gradeQuestions.reduce((sum: number, subj: { subject: string; questions: string[] }) => sum + subj.questions.length, 0);
          let gradedCount = 0;
          gradeQuestions.forEach((subj: { subject: string; questions: string[] }) => {
            subj.questions.forEach((q: string) => {
              const qField = `${q}_c`;
              const qValue = (s as any)[qField];
              if (qValue && typeof qValue === 'object' && qValue.hocaId) {
                gradedCount++;
              }
            });
          });
          return gradedCount === totalQuestions && gradedCount > 0;
        });
      } else {
        // Blok: Check actual assigned questions
        filtered = filtered.filter(s => {
          if (!s.specialtyGroup) return false;
          const mode = detectBlokMode(s);
          const actualQuestions = getActualBlokQuestions(s);
          let gradedCount = 0;

          actualQuestions.forEach(qNum => {
            const qField = `${qNum}_c`;
            if ((s as any)[qField]?.hocaId) {
              gradedCount++;
            }
          });

          return gradedCount === actualQuestions.length && gradedCount > 0;
        });
      }
    } else if (filterStatus === 'kismi') {
      // Qismən: Bazı sorular yoklanmış ama hepsi değil
      if (isBuraxilis) {
        filtered = filtered.filter(s => {
          if (!s.grade) return false;
          const gradeNum = typeof s.grade === 'number' ? s.grade : parseInt(s.grade as string);
          const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, s.xdil, buraxilisBlankCtx(selectedExam, s));
          if (!gradeQuestions || gradeQuestions.length === 0) return false;
          const totalQuestions = gradeQuestions.reduce((sum: number, subj: { subject: string; questions: string[] }) => sum + subj.questions.length, 0);
          let gradedCount = 0;
          gradeQuestions.forEach((subj: { subject: string; questions: string[] }) => {
            subj.questions.forEach((q: string) => {
              const qField = `${q}_c`;
              const qValue = (s as any)[qField];
              if (qValue && typeof qValue === 'object' && qValue.hocaId) {
                gradedCount++;
              }
            });
          });
          return gradedCount > 0 && gradedCount < totalQuestions;
        });
      } else {
        // Blok: Check actual assigned questions
        filtered = filtered.filter(s => {
          if (!s.specialtyGroup) return false;
          const mode = detectBlokMode(s);
          const actualQuestions = getActualBlokQuestions(s);
          let gradedCount = 0;

          actualQuestions.forEach(qNum => {
            const qField = `${qNum}_c`;
            if ((s as any)[qField]?.hocaId) {
              gradedCount++;
            }
          });

          return gradedCount > 0 && gradedCount < actualQuestions.length;
        });
      }
    } else if (filterStatus === 'yoklanmamis') {
      // Yoxlanmamış: Hiç soru yoklanmamış
      if (isBuraxilis) {
        filtered = filtered.filter(s => {
          if (!s.grade) return true;
          const gradeNum = typeof s.grade === 'number' ? s.grade : parseInt(s.grade as string);
          const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, s.xdil, buraxilisBlankCtx(selectedExam, s));
          if (!gradeQuestions || gradeQuestions.length === 0) return true;
          let gradedCount = 0;
          gradeQuestions.forEach((subj: { subject: string; questions: string[] }) => {
            subj.questions.forEach((q: string) => {
              const qField = `${q}_c`;
              const qValue = (s as any)[qField];
              if (qValue && typeof qValue === 'object' && qValue.hocaId) {
                gradedCount++;
              }
            });
          });
          return gradedCount === 0;
        });
      } else {
        // Blok: Check actual assigned questions
        filtered = filtered.filter(s => {
          if (!s.specialtyGroup) return true;
          const mode = detectBlokMode(s);
          const actualQuestions = getActualBlokQuestions(s);
          let gradedCount = 0;

          actualQuestions.forEach(qNum => {
            const qField = `${qNum}_c`;
            if ((s as any)[qField]?.hocaId) {
              gradedCount++;
            }
          });

          return gradedCount === 0;
        });
      }
    }

    // Axtarış filtri
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(s => 
        s.firstName.toLowerCase().includes(query) ||
        s.lastName.toLowerCase().includes(query) ||
        String(s.student_id).toLowerCase().includes(query)
      );
    }

    // Document ID'lerine göre sırala (Teacher panel ile aynı sıralama)
    // NOT: Sisteme eklenme sırasına göre göstermek için document ID'lerine göre sıralıyoruz
    filtered.sort((a, b) => {
      return a.id.localeCompare(b.id);
    });

    setFilteredStudents(filtered);
  };

  const clearFilters = () => {
    setFilterSinif('');
    setFilterQrup('');
    setFilterSubGroup('');
    setFilterVariant('');
    setFilterXdil('');
    setFilterTeacher('');
    setFilterStatus('');
    setSearchQuery('');
  };

  const handleSetFennToZero = async () => {
    if (!selectedStudent || !confirmZeroFenn) return;

    try {
      setIsSettingZero(true);
      const adminName = localStorage.getItem('userName') || 'Admin';
      
      await setFennToZero(selectedStudent.id, confirmZeroFenn, adminName);
      
      // Success toast göstər
      setSuccessMessage(`${confirmZeroFenn} fənni boş kağız olaraq işarələndi`);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
      
      // Modal'ı kapat ve verileri yenile
      setConfirmZeroFenn(null);
      setSelectedStudent(null);
      await loadStudents();
    } catch (error) {
      console.error('Boş kağız işarələnərkən xəta:', error);
      alert('Əməliyyat zamanı xəta baş verdi');
    } finally {
      setIsSettingZero(false);
    }
  };

  // Checkbox işaretleme/kaldırma
  const handleToggleFennCheckbox = (fennName: string) => {
    setSelectedFennList(prev => {
      if (prev.includes(fennName)) {
        return prev.filter(f => f !== fennName);
      } else {
        return [...prev, fennName];
      }
    });
  };

  // Empty page verification handlers
  const handleVerifyEmptyPage = async (isConfirmed: boolean) => {
    if (filteredPages.length === 0) return;

    const currentPage = filteredPages[currentEmptyPageIndex];

    try {
      // Update Firebase with double_check_empty field
      const { updateDoc, doc, Timestamp, deleteField } = await import('firebase/firestore');
      const { db } = await import('../../firebase');

      // Find student document
      const studentDoc = students.find(s => s.student_id === currentPage.studentId);
      if (!studentDoc) {
        alert('Şagird tapılmadı');
        return;
      }

      const adminId = localStorage.getItem('userId') || 'admin';
      const adminName = localStorage.getItem('userName') || 'Admin';

      if (isConfirmed) {
        // Boş səhifə TƏSDİQLƏNDİ - həm Q## həm də Q##_c update et
        await updateDoc(doc(db, selectedExam?.collection || 'buraxilis2', studentDoc.id), {
          [`${currentPage.questionNumber}.double_check_empty`]: true,
          [`${currentPage.questionNumber}_c`]: {
            hoca: adminName,
            hocaId: adminId,
            score: '0',
            timestamp: Timestamp.now(),
            note: 'Boş sual - Admin tərəfindən təsdiqləndi'
          }
        });
        console.log(`✅ ${currentPage.questionNumber} - BOŞ TƏSDİQLƏNDİ - 0 bal verildi`);
      } else {
        // Boş səhifə RƏDD EDİLDİ - double_check_empty: false VƏ Q##_c silinir
        await updateDoc(doc(db, selectedExam?.collection || 'buraxilis2', studentDoc.id), {
          [`${currentPage.questionNumber}.double_check_empty`]: false,
          [`${currentPage.questionNumber}_c`]: deleteField()
        });
        console.log(`❌ ${currentPage.questionNumber} - RƏDD EDİLDİ - hoca yoxlayacaq (Q##_c silindi)`);
      }

      // Update status in state immediately
      setEmptyPagesToVerify(prev => prev.map((page) =>
        page.studentId === currentPage.studentId && page.questionNumber === currentPage.questionNumber
          ? { ...page, verificationStatus: isConfirmed ? 'confirmed' as const : 'rejected' as const, verifiedAt: new Date() }
          : page
      ));

      // Show success message
      setSuccessMessage(
        isConfirmed
          ? `${currentPage.questionNumber} boş səhifə təsdiqləndi və 0 bal verildi`
          : `❌ ${currentPage.questionNumber} dolu səhifə - hoca yoxlayacaq`
      );
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);

      // Move to next page or finish
      // After state updates, filteredPages will recalculate.
      // The verified page will be removed, so array shrinks by 1.
      // Current index now points to what was the next page - DON'T increment!
      if (filteredPages.length > 1) {
        // Stay on same index - next page shifts into this position
        setEmptyImageLoading(true);
      } else {
        // Last page verified - all done
        alert('Bütün gözləyən boş səhifələr yoxlandı!');
        setActiveTab('results');
        setCurrentEmptyPageIndex(0);
        await loadStudents(); // Reload to get updated data
      }
    } catch (error) {
      console.error('Error verifying empty page:', error);
      alert('Xəta baş verdi');
    }
  };

  // Bulk verify all empty pages for a student (student-based mode)
  const handleBulkVerifyForStudent = async (
    studentGroup: StudentEmptyPages,
    isConfirmed: boolean,
    selectedQuestions: Set<string>
  ) => {
    try {
      setBulkProcessing(true);

      const { updateDoc, doc, Timestamp, deleteField } = await import('firebase/firestore');
      const { db } = await import('../../firebase');

      const studentDoc = students.find(s => s.student_id === studentGroup.studentId);
      if (!studentDoc) {
        throw new Error('Şagird tapılmadı');
      }

      const adminId = localStorage.getItem('userId') || 'admin';
      const adminName = localStorage.getItem('userName') || 'Admin';

      // Filter to only pending questions
      const pendingPages = studentGroup.emptyPages.filter(p => p.verificationStatus === 'pending');

      // Determine which questions to confirm/reject
      const hasSelection = selectedQuestions.size > 0;
      const toConfirm = hasSelection
        ? isConfirmed
          ? Array.from(selectedQuestions)
          : pendingPages.filter(p => !selectedQuestions.has(p.questionNumber)).map(p => p.questionNumber)
        : isConfirmed
          ? pendingPages.map(p => p.questionNumber)
          : [];

      const toReject = hasSelection
        ? isConfirmed
          ? pendingPages.filter(p => !selectedQuestions.has(p.questionNumber)).map(p => p.questionNumber)
          : Array.from(selectedQuestions)
        : isConfirmed
          ? []
          : pendingPages.map(p => p.questionNumber);

      // Build batch update object
      const updates: Record<string, any> = {};

      toConfirm.forEach(qNum => {
        updates[`${qNum}.double_check_empty`] = true;
        updates[`${qNum}_c`] = {
          hoca: adminName,
          hocaId: adminId,
          score: '0',
          timestamp: Timestamp.now(),
          note: 'Boş sual - Admin tərəfindən təsdiqləndi'
        };
      });

      toReject.forEach(qNum => {
        updates[`${qNum}.double_check_empty`] = false;
        updates[`${qNum}_c`] = deleteField(); // Clean up Q##_c when rejecting
      });

      // Single batch update
      await updateDoc(
        doc(db, selectedExam?.collection || 'buraxilis2', studentDoc.id),
        updates
      );

      // Update local state
      setEmptyPagesToVerify(prev => prev.map(page => {
        const belongsToStudent = page.studentId === studentGroup.studentId;
        if (!belongsToStudent) return page;

        const willConfirm = toConfirm.includes(page.questionNumber);
        const willReject = toReject.includes(page.questionNumber);

        if (willConfirm) {
          return { ...page, verificationStatus: 'confirmed' as const, verifiedAt: new Date() };
        } else if (willReject) {
          return { ...page, verificationStatus: 'rejected' as const, verifiedAt: new Date() };
        }
        return page;
      }));

      // Clear selection after operation
      setSelectedQuestionNumbers(new Set());

      // Show success toast
      setSuccessMessage(
        `${studentGroup.studentName} - ${toConfirm.length} təsdiqləndi, ${toReject.length} rədd edildi`
      );
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);

    } catch (error) {
      console.error('Bulk verification error:', error);
      alert('Əməliyyat zamanı xəta baş verdi');
    } finally {
      setBulkProcessing(false);
    }
  };

  // Toggle question selection for checkbox
  const handleToggleQuestionCheckbox = (questionNumber: string) => {
    setSelectedQuestionNumbers(prev => {
      const newSet = new Set(prev);
      if (newSet.has(questionNumber)) {
        newSet.delete(questionNumber);
      } else {
        newSet.add(questionNumber);
      }
      return newSet;
    });
  };

  // Clear selection when modal closes
  const handleStudentModalClose = () => {
    setSelectedQuestionNumbers(new Set());
    setShowStudentDetail(false);
  };

  // Toplu boş kağıt işaretleme
  const handleBulkSetToZero = async () => {
    if (!selectedStudent || selectedFennList.length === 0) return;

    try {
      setIsBulkSettingZero(true);
      const adminName = localStorage.getItem('userName') || 'Admin';
      
      const result = await setMultipleFennToZero(selectedStudent.id, selectedFennList, adminName);
      
      // Success toast göster
      if (result.success > 0) {
        setSuccessMessage(
          `${result.success} fənn boş kağız olaraq işarələndi` +
          (result.failed > 0 ? ` (${result.failed} xəta)` : '')
        );
        setShowSuccessToast(true);
        setTimeout(() => setShowSuccessToast(false), 4000);
      }
      
      if (result.errors.length > 0) {
        console.error('Xətalar:', result.errors);
      }
      
      // Modal'ı kapat ve verileri yenile
      setShowBulkConfirm(false);
      setSelectedFennList([]);
      setSelectedStudent(null);
      await loadStudents();
    } catch (error) {
      console.error('Toplu boş kağız işarələnərkən xəta:', error);
      alert('Əməliyyat zamanı xəta baş verdi');
    } finally {
      setIsBulkSettingZero(false);
    }
  };

  // Seçili fenn listesini temizle
  const handleClearSelection = () => {
    setSelectedFennList([]);
  };

  const getFennList = (qrup: string, subGroup?: string): string[] => {
    const qrupConfig = QRUP_CONFIGS.find(q => q.qrup === qrup);
    if (!qrupConfig) return [];
    
    // Alt qrup yoksa veya "-" ise
    const isSubGroupEmpty = !subGroup || subGroup === '-' || subGroup.trim() === '';
    
    if (isSubGroupEmpty) {
      // SubGroup gerektirmeyen fennleri döndür
      return qrupConfig.fennler
        .filter(f => !f.subGroup)
        .map(f => f.fenn);
    }
    
    // SubGroup normalize fonksiyonu (RI -> Rİ, ri -> Rİ vb.)
    const normalizeSubGroup = (sg: string): string => {
      return sg.toUpperCase().replace('I', 'İ'); // Normal I'yı Türkçe İ'ye çevir
    };
    
    const normalizedSubGroup = normalizeSubGroup(subGroup);
    
    // SubGroup varsa: ortak fennler + o subGroup'a ait fennler
    return qrupConfig.fennler
      .filter(f => !f.subGroup || normalizeSubGroup(f.subGroup) === normalizedSubGroup)
      .map(f => f.fenn);
  };

  const getFennNameForBlokQuestion = (questionNum: string, qrup: string, subGroup?: string): string => {
    const qNum = parseInt(questionNum.replace('Q', ''));

    // Q28-Q30: First fenn (same for all in qrup)
    if (qNum >= 28 && qNum <= 30) {
      if (qrup === 'I') return 'Riyaziyyat';
      if (qrup === 'II') return 'Riyaziyyat';
      if (qrup === 'III') return 'Azərbaycan dili';
      if (qrup === 'IV') return 'Biologiya';
    }

    // Q58-Q60: Second fenn (same for all in qrup)
    if (qNum >= 58 && qNum <= 60) {
      if (qrup === 'I') return 'Fizika';
      if (qrup === 'II') return 'Coğrafiya';
      if (qrup === 'III') return 'Tarix';
      if (qrup === 'IV') return 'Kimya';
    }

    // Q88-Q90: Third fenn (depends on subGroup)
    if (qNum >= 88 && qNum <= 90) {
      if (qrup === 'I') {
        const normalizedSubGroup = (subGroup || '').toUpperCase().replace('I', 'İ');
        if (normalizedSubGroup === 'RK') return 'Kimya';
        if (normalizedSubGroup === 'Rİ') return 'İnformatika';
        return 'Kimya/İnformatika'; // Fallback
      }
      if (qrup === 'II') return 'Tarix';
      if (qrup === 'III') {
        const normalizedSubGroup = (subGroup || '').toUpperCase().replace('I', 'İ');
        if (normalizedSubGroup === 'DT') return 'Ədəbiyyat';
        if (normalizedSubGroup === 'TC') return 'Coğrafiya';
        return 'Ədəbiyyat/Coğrafiya'; // Fallback
      }
      if (qrup === 'IV') return 'Fizika';
    }

    return 'Unknown';
  };

  const getImageAreaForFenn = (fenn: string, qrup: string): { start: number; end: number; imageUrl: string } | null => {
    if (!selectedStudent) return null;
    
    const qrupConfig = QRUP_CONFIGS.find(q => q.qrup === qrup);
    if (!qrupConfig) return null;
    
    const fennConfig = qrupConfig.fennler.find(f => f.fenn === fenn);
    if (!fennConfig) return null;
    
    // Sual nömrəsinə görə hansı şəkli göstərəcəyimizi təyin edirik
    // Resimlerdeki soru konumları:
    // arka_uz_sol: 28-30 sorular
    // arka_uz_sag: 58-60 sorular
    // on_uz_sol: 88-90 sorular
    
    let imageUrl = '';
    const startQuestion = fennConfig.start;
    
    if (startQuestion >= 1 && startQuestion <= 30) {
      // 1-30 arası sorular → arka_uz_sol
      imageUrl = selectedStudent.arka_uz_sol || '';
    } else if (startQuestion >= 31 && startQuestion <= 60) {
      // 31-60 arası sorular → arka_uz_sag
      imageUrl = selectedStudent.arka_uz_sag || '';
    } else if (startQuestion >= 61 && startQuestion <= 90) {
      // 61-90 arası sorular → on_uz_sol
      imageUrl = selectedStudent.on_uz_sol || '';
    }
    
    return {
      start: fennConfig.start,
      end: fennConfig.end,
      imageUrl: imageUrl
    };
  };

  const handleViewFennImage = (fenn: string, studentId: string) => {
    setViewingImage({ fenn, studentId });
    setImageLoading(true);
    // Modal açıldığında scroll'u sıfırla
    setTimeout(() => {
      if (imageContainerRef.current) {
        imageContainerRef.current.scrollTop = 0;
      }
    }, 100);
  };

  // Apellyasiya təyin et butonuna basıldığında
  const handleOpenApellyasiyaModal = async (student: StudentDetailData, questionNum: string) => {
    if (!selectedExam) return;

    setApellyasiyaQuestionNum(questionNum);
    setApellyasiyaReason('');

    // Əvvəlki yoxlama məlumatlarını al
    const gradingData = (student as any)[`${questionNum}_c`];
    if (!gradingData || !gradingData.hocaId) {
      alert('Bu sual üçün yoxlama məlumatı tapılmadı');
      return;
    }

    // Default olaraq yoxlayan hocanı seç
    setApellyasiyaSelectedTeacher(gradingData.hocaId);

    let fenn: string | null = null;

    if (isBuraxilis) {
      // Buraxılış: Sual nömrəsindən fənn tap
      const gradeNum = typeof student.grade === 'number' ? student.grade : parseInt(student.grade as string);
      const subject = getFennFromQuestionNumber(questionNum, gradeNum, buraxilisBlankCtx(selectedExam));
      if (!subject) {
        alert('Sual nömrəsi üçün fənn tapılmadı');
        return;
      }
      // Xarici dil üçün normalize et
      fenn = subject === 'Xarici dil'
        ? normalizeXdil(student.xdil) || 'İngilis dili'
        : subject;
    } else {
      // Blok: Qrup və sual nömrəsindən fənn tap
      const qrup = student.specialtyGroup;
      const subGroup = student.subGroup;
      fenn = getFennFromQuestionNumberForBlok(questionNum, qrup, subGroup);
      if (!fenn) {
        alert('Sual nömrəsi üçün fənn tapılmadı (qrup: ' + qrup + ')');
        return;
      }
    }

    // Bu fənn üçün müəllimləri al
    try {
      setApellyasiyaLoading(true);
      const teachers = await getTeachersByFenn(fenn);
      setApellyasiyaTeachers(teachers);

      // Default müəllim siyahıda yoxdursa, əlavə et
      if (!teachers.find(t => t.id === gradingData.hocaId)) {
        // Yoxlayan müəllim başqa fənn müəllimidir, amma default olaraq seçiləcək
        const allTeachers = await getAllTeachers();
        const defaultTeacher = allTeachers.find(t => t.id === gradingData.hocaId);
        if (defaultTeacher) {
          setApellyasiyaTeachers([defaultTeacher, ...teachers]);
        }
      }
    } catch (error) {
      console.error('Müəllimlər alınarkən xəta:', error);
      alert('Müəllimlər alınarkən xəta baş verdi');
    } finally {
      setApellyasiyaLoading(false);
    }

    setShowApellyasiyaModal(true);
  };

  // Apellyasiya yaradır
  const handleCreateApellyasiya = async () => {
    if (!selectedStudent || !apellyasiyaQuestionNum || !apellyasiyaReason.trim() || !apellyasiyaSelectedTeacher || !selectedExam) {
      alert('Zəhmət olmasa bütün məlumatları doldurun');
      return;
    }

    try {
      setApellyasiyaLoading(true);

      // Əvvəlki yoxlama məlumatlarını al
      const gradingData = (selectedStudent as any)[`${apellyasiyaQuestionNum}_c`];
      if (!gradingData) {
        alert('Əvvəlki yoxlama məlumatı tapılmadı');
        return;
      }

      // Seçilmiş müəllimi tap
      const selectedTeacher = apellyasiyaTeachers.find(t => t.id === apellyasiyaSelectedTeacher);
      if (!selectedTeacher) {
        alert('Seçilmiş müəllim tapılmadı');
        return;
      }

      let result: { success: boolean; message: string; apellyasiyaId?: string };

      if (isBuraxilis) {
        // Buraxılış üçün apellyasiya yarad
        const gradeNum = typeof selectedStudent.grade === 'number' ? selectedStudent.grade : parseInt(selectedStudent.grade as string);
        result = await createApellyasiya(
          selectedStudent.student_id,
          selectedStudent.id,
          apellyasiyaQuestionNum,
          apellyasiyaReason.trim(),
          apellyasiyaSelectedTeacher,
          selectedTeacher.name,
          selectedExam.collection || 'buraxilis2',
          gradeNum,
          {
            hocaId: gradingData.hocaId,
            hoca: gradingData.hoca || 'Müəllim',
            score: gradingData.score || '0',
            timestamp: gradingData.timestamp,
            note: gradingData.note
          },
          selectedStudent.xdil,
          buraxilisBlankCtx(selectedExam, selectedStudent)
        );
      } else {
        // Blok üçün apellyasiya yarad
        result = await createApellyasiyaForBlok(
          selectedStudent.student_id,
          selectedStudent.id,
          apellyasiyaQuestionNum,
          apellyasiyaReason.trim(),
          apellyasiyaSelectedTeacher,
          selectedTeacher.name,
          selectedExam.collection || 'scanned2610',
          selectedStudent.specialtyGroup,
          selectedStudent.subGroup,
          {
            hocaId: gradingData.hocaId,
            hoca: gradingData.hoca || 'Müəllim',
            score: gradingData.score || '0',
            timestamp: gradingData.timestamp,
            note: gradingData.note
          }
        );
      }

      if (result.success) {
        setSuccessMessage('Apellyasiya uğurla təyin edildi');
        setShowSuccessToast(true);
        setTimeout(() => setShowSuccessToast(false), 3000);

        // Modal-ı bağla
        setShowApellyasiyaModal(false);
        setApellyasiyaReason('');
        setApellyasiyaQuestionNum(null);

        // Şagirdləri yenilə
        await loadStudents();
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error('Apellyasiya yaradılarkən xəta:', error);
      alert('Apellyasiya yaradılarkən xəta baş verdi');
    } finally {
      setApellyasiyaLoading(false);
    }
  };

  // Batch Apellyasiya funksiyaları
  const handleToggleQuestionForAppeal = (questionNum: string) => {
    setSelectedQuestionsForAppeal(prev => {
      const newSet = new Set(prev);
      if (newSet.has(questionNum)) {
        newSet.delete(questionNum);
      } else {
        newSet.add(questionNum);
      }
      return newSet;
    });
  };

  // Tüm yoklanmış soruları al (apellyasiya olmayanlar için)
  const getAvailableQuestionsForAppeal = (student: StudentDetailData): string[] => {
    const availableQuestions: string[] = [];
    const studentAny = student as any;

    if (isBuraxilis && student.grade) {
      const gradeNum = typeof student.grade === 'number' ? student.grade : parseInt(student.grade as string);
      const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, student.xdil, buraxilisBlankCtx(selectedExam, student));
      if (gradeQuestions && gradeQuestions.length > 0) {
        gradeQuestions.forEach((subject: { subject: string; questions: string[] }) => {
          subject.questions.forEach((q: string) => {
            const gradingData = studentAny[`${q}_c`];
            if (gradingData && typeof gradingData === 'object' && gradingData.hocaId) {
              // Apellyasiya yoksa veya tamamlanmamışsa ekle
              const apellyasiya = apellyasiyas.get(q);
              const isApellyasiyaCompleted = gradingData.apellyasiya_status === true || gradingData.apellyasiya_result === true;
              const isApellyasiyaPending = apellyasiya && apellyasiya.apellyasiya_status === 'pending' && !isApellyasiyaCompleted;
              if (!apellyasiya && !isApellyasiyaCompleted && !isApellyasiyaPending) {
                availableQuestions.push(q);
              }
            }
          });
        });
      }
    } else if (student.specialtyGroup) {
      // Blok mode
      const actualQuestions = getActualBlokQuestions(student);
      actualQuestions.forEach((q: string) => {
        const gradingData = studentAny[`${q}_c`];
        if (gradingData && typeof gradingData === 'object' && gradingData.hocaId) {
          // Apellyasiya yoksa veya tamamlanmamışsa ekle
          const apellyasiya = apellyasiyas.get(q);
          const isApellyasiyaCompleted = gradingData.apellyasiya_status === true || gradingData.apellyasiya_result === true;
          const isApellyasiyaPending = apellyasiya && apellyasiya.apellyasiya_status === 'pending' && !isApellyasiyaCompleted;
          if (!apellyasiya && !isApellyasiyaCompleted && !isApellyasiyaPending) {
            availableQuestions.push(q);
          }
        }
      });
    }

    return availableQuestions;
  };

  const handleOpenBatchApellyasiyaModal = async (fromButton: boolean = false) => {
    if (!selectedStudent || !selectedExam) {
      return;
    }

    // Eğer butondan açılıyorsa ve hiç soru seçilmemişse, modal içinde seçim yapılacak
    if (fromButton && selectedQuestionsForAppeal.size === 0) {
      setBatchModalStep('select');
      setModalSelectedQuestions(new Set());
      setBatchApellyasiyaReason('');
      setBatchQuestionTeachers(new Map());
      setBatchQuestionTeachersList(new Map());
      setShowBatchApellyasiyaModal(true);
      return;
    }

    // Eğer sayfada sorular seçilmişse, direkt assign aşamasına geç
    if (selectedQuestionsForAppeal.size > 0) {
      setBatchModalStep('assign');
      setBatchApellyasiyaReason('');
      setBatchQuestionTeachers(new Map());
      setBatchQuestionTeachersList(new Map());

      // Her soru için fenn'e göre öğretmen listesi al
      try {
        setBatchApellyasiyaLoading(true);
        const questionNums = Array.from(selectedQuestionsForAppeal);
        const teachersMap = new Map<string, Teacher[]>();
        const selectedTeachersMap = new Map<string, string>();

        for (const questionNum of questionNums) {
          const gradingData = (selectedStudent as any)[`${questionNum}_c`];
          if (!gradingData || !gradingData.hocaId) {
            continue;
          }

          // Her soru için fenn tap
          let fenn: string | null = null;
          if (isBuraxilis) {
            const gradeNum = typeof selectedStudent.grade === 'number' ? selectedStudent.grade : parseInt(selectedStudent.grade as string);
            const subject = getFennFromQuestionNumber(questionNum, gradeNum, buraxilisBlankCtx(selectedExam));
            if (subject) {
              fenn = subject === 'Xarici dil'
                ? normalizeXdil(selectedStudent.xdil) || 'İngilis dili'
                : subject;
            }
          } else {
            const qrup = selectedStudent.specialtyGroup;
            const subGroup = selectedStudent.subGroup;
            fenn = getFennFromQuestionNumberForBlok(questionNum, qrup, subGroup);
          }

          if (fenn) {
            try {
              const teachers = await getTeachersByFenn(fenn);
              
              // Default öğretmeni (yoxlayan müəllim) siyahıda yoxdursa əlavə et
              let finalTeachers = [...teachers];
              if (!teachers.find(t => t.id === gradingData.hocaId)) {
                const allTeachers = await getAllTeachers();
                const defaultTeacher = allTeachers.find(t => t.id === gradingData.hocaId);
                if (defaultTeacher) {
                  finalTeachers = [defaultTeacher, ...teachers];
                }
              }

              teachersMap.set(questionNum, finalTeachers);
              // Default olaraq yoxlayan müəllimi seç
              selectedTeachersMap.set(questionNum, gradingData.hocaId);
            } catch (error) {
              console.error(`Müəllimlər alınarkən xəta (${questionNum}):`, error);
            }
          }
        }

        setBatchQuestionTeachersList(teachersMap);
        setBatchQuestionTeachers(selectedTeachersMap);
      } catch (error) {
        console.error('Müəllimlər alınarkən xəta:', error);
      } finally {
        setBatchApellyasiyaLoading(false);
      }

      setShowBatchApellyasiyaModal(true);
    }
  };

  const handleModalQuestionToggle = (questionNum: string) => {
    setModalSelectedQuestions(prev => {
      const newSet = new Set(prev);
      if (newSet.has(questionNum)) {
        newSet.delete(questionNum);
      } else {
        newSet.add(questionNum);
      }
      return newSet;
    });
  };

  const handleNextToAssignStep = async () => {
    if (!selectedStudent) {
      return;
    }

    if (modalSelectedQuestions.size === 0) {
      alert('Zəhmət olmasa ən azı bir sual seçin');
      return;
    }

    // Seçilen soruları selectedQuestionsForAppeal'a aktar
    setSelectedQuestionsForAppeal(new Set(modalSelectedQuestions));
    setBatchModalStep('assign');
    setBatchApellyasiyaReason('');
    setBatchQuestionTeachers(new Map());
    setBatchQuestionTeachersList(new Map());

    // Her soru için fenn'e göre öğretmen listesi al
    try {
      setBatchApellyasiyaLoading(true);
      const questionNums = Array.from(modalSelectedQuestions);
      const teachersMap = new Map<string, Teacher[]>();
      const selectedTeachersMap = new Map<string, string>();

      for (const questionNum of questionNums) {
        if (!selectedStudent) continue;
        
        const gradingData = (selectedStudent as any)[`${questionNum}_c`];
        if (!gradingData || !gradingData.hocaId) {
          continue;
        }

        // Her soru için fenn tap
        let fenn: string | null = null;
        if (isBuraxilis) {
          const gradeNum = typeof selectedStudent.grade === 'number' ? selectedStudent.grade : parseInt(selectedStudent.grade as string);
          const subject = getFennFromQuestionNumber(questionNum, gradeNum, buraxilisBlankCtx(selectedExam));
          if (subject) {
            fenn = subject === 'Xarici dil'
              ? normalizeXdil(selectedStudent.xdil) || 'İngilis dili'
              : subject;
          }
        } else {
          const qrup = selectedStudent.specialtyGroup;
          const subGroup = selectedStudent.subGroup;
          fenn = getFennFromQuestionNumberForBlok(questionNum, qrup, subGroup);
        }

        if (fenn) {
          try {
            const teachers = await getTeachersByFenn(fenn);
            
            // Default öğretmeni (yoxlayan müəllim) siyahıda yoxdursa əlavə et
            let finalTeachers = [...teachers];
            if (!teachers.find(t => t.id === gradingData.hocaId)) {
              const allTeachers = await getAllTeachers();
              const defaultTeacher = allTeachers.find(t => t.id === gradingData.hocaId);
              if (defaultTeacher) {
                finalTeachers = [defaultTeacher, ...teachers];
              }
            }

            teachersMap.set(questionNum, finalTeachers);
            // Default olaraq yoxlayan müəllimi seç
            selectedTeachersMap.set(questionNum, gradingData.hocaId);
          } catch (error) {
            console.error(`Müəllimlər alınarkən xəta (${questionNum}):`, error);
          }
        }
      }

      setBatchQuestionTeachersList(teachersMap);
      setBatchQuestionTeachers(selectedTeachersMap);
    } catch (error) {
      console.error('Müəllimlər alınarkən xəta:', error);
    } finally {
      setBatchApellyasiyaLoading(false);
    }
  };

  const handleBatchCreateApellyasiya = async () => {
    if (!selectedStudent || !selectedExam || selectedQuestionsForAppeal.size === 0 || !batchApellyasiyaReason.trim()) {
      alert('Zəhmət olmasa bütün məlumatları doldurun');
      return;
    }

    // Bütün sorular için öğretmen seçilmiş mi kontrol et
    const questionNums = Array.from(selectedQuestionsForAppeal);
    const missingTeachers: string[] = [];
    for (const questionNum of questionNums) {
      const selectedTeacherId = batchQuestionTeachers.get(questionNum);
      if (!selectedTeacherId) {
        missingTeachers.push(questionNum);
      }
    }

    if (missingTeachers.length > 0) {
      alert(`Zəhmət olmasa bütün suallar üçün müəllim seçin:\n${missingTeachers.join(', ')}`);
      return;
    }

    try {
      setBatchApellyasiyaLoading(true);
      const results: Array<{ questionNum: string; success: boolean; message: string }> = [];

      // Process appeals sequentially to avoid overwhelming the system
      for (const questionNum of questionNums) {
        const gradingData = (selectedStudent as any)[`${questionNum}_c`];
        if (!gradingData || !gradingData.hocaId) {
          results.push({ questionNum, success: false, message: 'Yoxlama məlumatı tapılmadı' });
          continue;
        }

        // Bu soru için seçilmiş öğretmeni al
        const selectedTeacherId = batchQuestionTeachers.get(questionNum);
        if (!selectedTeacherId) {
          results.push({ questionNum, success: false, message: 'Müəllim seçilməyib' });
          continue;
        }

        const teachersList = batchQuestionTeachersList.get(questionNum) || [];
        const selectedTeacher = teachersList.find(t => t.id === selectedTeacherId);
        if (!selectedTeacher) {
          results.push({ questionNum, success: false, message: 'Seçilmiş müəllim tapılmadı' });
          continue;
        }

        try {
          let result: { success: boolean; message: string; apellyasiyaId?: string };

          if (isBuraxilis) {
            const gradeNum = typeof selectedStudent.grade === 'number' ? selectedStudent.grade : parseInt(selectedStudent.grade as string);
            result = await createApellyasiya(
              selectedStudent.student_id,
              selectedStudent.id,
              questionNum,
              batchApellyasiyaReason.trim(),
              selectedTeacherId,
              selectedTeacher.name,
              selectedExam.collection || 'buraxilis2',
              gradeNum,
              {
                hocaId: gradingData.hocaId,
                hoca: gradingData.hoca || 'Müəllim',
                score: gradingData.score || '0',
                timestamp: gradingData.timestamp,
                note: gradingData.note
              },
              selectedStudent.xdil,
              buraxilisBlankCtx(selectedExam, selectedStudent)
            );
          } else {
            result = await createApellyasiyaForBlok(
              selectedStudent.student_id,
              selectedStudent.id,
              questionNum,
              batchApellyasiyaReason.trim(),
              selectedTeacherId,
              selectedTeacher.name,
              selectedExam.collection || 'scanned2610',
              selectedStudent.specialtyGroup,
              selectedStudent.subGroup,
              {
                hocaId: gradingData.hocaId,
                hoca: gradingData.hoca || 'Müəllim',
                score: gradingData.score || '0',
                timestamp: gradingData.timestamp,
                note: gradingData.note
              }
            );
          }

          results.push({ questionNum, success: result.success, message: result.message });
        } catch (error) {
          console.error(`Apellyasiya yaradılarkən xəta (${questionNum}):`, error);
          results.push({ questionNum, success: false, message: 'Xəta baş verdi' });
        }
      }

      const successCount = results.filter(r => r.success).length;
      const failCount = results.filter(r => !r.success).length;

      if (successCount > 0) {
        setSuccessMessage(`${successCount} apellyasiya uğurla təyin edildi${failCount > 0 ? `, ${failCount} uğursuz oldu` : ''}`);
        setShowSuccessToast(true);
        setTimeout(() => setShowSuccessToast(false), 5000);

        // Clear selection and close modal
        setSelectedQuestionsForAppeal(new Set());
        setModalSelectedQuestions(new Set());
        setShowBatchApellyasiyaModal(false);
        setBatchModalStep('select');
        setBatchApellyasiyaReason('');
        setBatchQuestionTeachers(new Map());
        setBatchQuestionTeachersList(new Map());

        // Reload students
        await loadStudents();
      } else {
        alert(`Apellyasiyalar yaradılmadı. Xətalar:\n${results.map(r => `${r.questionNum}: ${r.message}`).join('\n')}`);
      }
    } catch (error) {
      console.error('Batch apellyasiya yaradılarkən xəta:', error);
      alert('Batch apellyasiya yaradılarkən xəta baş verdi');
    } finally {
      setBatchApellyasiyaLoading(false);
    }
  };

  // Clear selection when student changes
  useEffect(() => {
    setSelectedQuestionsForAppeal(new Set());
  }, [selectedStudent]);

  // Tələbə üçün apellyasiyaları yüklə
  useEffect(() => {
    const loadApellyasiyas = async () => {
      if (!selectedStudent || !selectedExam) {
        setApellyasiyas(new Map());
        return;
      }

      try {
        const apellyasiyaList = await getApellyasiyasByStudent(
          selectedStudent.student_id,
          selectedExam.collection || (isBuraxilis ? 'buraxilis2' : 'scanned2610')
        );

        const apellyasiyaMap = new Map<string, any>();
        apellyasiyaList.forEach((ap: any) => {
          apellyasiyaMap.set(ap.questionNumber, ap);
        });
        setApellyasiyas(apellyasiyaMap);
      } catch (error) {
        console.error('Apellyasiyalar yüklənərkən xəta:', error);
      }
    };

    loadApellyasiyas();
  }, [selectedStudent, selectedExam, isBuraxilis, students]);

  // All apellyasiyaları yüklə (list view üçün)
  useEffect(() => {
    const loadAllApellyasiyas = async () => {
      if (!selectedExam || students.length === 0) {
        setAllApellyasiyas([]);
        return;
      }

      try {
        const { getDocs, query, where, collection } = await import('firebase/firestore');
        const { db } = await import('../../firebase');

        // yoxla-s collection-dan apellyasiya documents yüklə
        const apellyasiyaQuery = query(
          collection(db, 'yoxla-s'),
          where('type', '==', 'apellyasiya'),
          where('collectionName', '==', selectedExam.collection || (isBuraxilis ? 'buraxilis2' : 'scanned2610'))
        );
        const apellyasiyaSnapshot = await getDocs(apellyasiyaQuery);

        const apellyasiyaList: Array<{
          id: string;
          studentId: string;
          studentName: string;
          questionNumber: string;
          fenn: string;
          previousScore: string | number;
          newScore: string | number | null;
          scoreChange: number | null;
          apellyasiyaNote?: string;
          apellyasiyaHoca?: string;
          apellyasiyaHocaId?: string;
          /** Təyin edən müəllim – yoxla-s sənədindən (hocaId/hocaName) */
          assignedHocaId?: string;
          assignedHocaName?: string;
          originalHoca?: string;
          status: 'pending' | 'completed';
          createdAt?: any;
          completedAt?: any;
          grade?: string;
        }> = [];

        // Her apellyasiya document-i ucun
        for (const doc of apellyasiyaSnapshot.docs) {
          const ap = doc.data();
          const student = students.find(s => s.student_id === ap.studentId);

          if (!student) continue;

          // Student document-indeki grading data-nı al
          const gradingData = (student as any)[`${ap.questionNumber}_c`];
          const isCompleted = gradingData?.apellyasiya_status === true || gradingData?.apellyasiya_result === true;

          const previousScore = gradingData?.previous_score || ap.əvvəlki_yoxlama?.score || '0';
          // Gözləyir statusunda yeni bal və dəyişiklik hələ yoxdur — 0 göstərməyin, null saxla
          const newScore: string | number | null = isCompleted
            ? (gradingData?.new_score ?? ap.yeni_yoxlama?.score ?? '0')
            : null;
          const prevNum = parseScoreToNumber(previousScore);
          const newNum = newScore != null ? parseScoreToNumber(newScore) : 0;
          const scoreChange: number | null = isCompleted
            ? Math.round((newNum - prevNum) * 1000) / 1000
            : null;

          apellyasiyaList.push({
            id: doc.id,
            studentId: student.student_id,
            studentName: `${student.firstName} ${student.lastName}`,
            questionNumber: ap.questionNumber,
            fenn: ap.fenn || '',
            previousScore,
            newScore,
            scoreChange,
            apellyasiyaNote: gradingData?.apellyasiya_note || '',
            apellyasiyaHoca: gradingData?.apellyasiya_hoca || '',
            apellyasiyaHocaId: gradingData?.apellyasiya_hocaId || '',
            assignedHocaId: ap.hocaId,
            assignedHocaName: ap.hocaName || '',
            originalHoca: ap.əvvəlki_yoxlama?.hoca || '',
            status: isCompleted ? 'completed' : 'pending',
            createdAt: ap.createdAt,
            completedAt: gradingData?.apellyasiya_onaylanma_tarihi,
            grade: student.grade != null ? String(student.grade) : undefined
          });
        }

        setAllApellyasiyas(apellyasiyaList);
      } catch (error) {
        console.error('Apellyasiyalar yüklənərkən xəta:', error);
        setAllApellyasiyas([]);
      }
    };

    loadAllApellyasiyas();
  }, [selectedExam, students, isBuraxilis]);

  // Müəllim siyahısını erkən yüklə (Apellyasiya tabında WhatsApp üçün) – imtahan seçiləndə
  useEffect(() => {
    if (selectedExam) {
      getAllTeachers().then((list) => setTeachersList(list || []));
    }
  }, [selectedExam]);

  // Apellyasiya müəllimə görə qrupla (təyin edən müəllim – yoxla-s hocaId/hocaName)
  const apellyasiyaTeacherGroups = useMemo(() => {
    const map = new Map<string, { teacherId: string; teacherName: string; total: number; completedCount: number; pendingCount: number; fenns: Set<string>; sinifs: Set<string> }>();
    allApellyasiyas.forEach((a) => {
      const teacherId = a.assignedHocaId || a.apellyasiyaHocaId || a.apellyasiyaHoca || 'unknown';
      const teacherName = a.assignedHocaName || a.apellyasiyaHoca || a.apellyasiyaHocaId || '—';
      if (!map.has(teacherId)) {
        map.set(teacherId, { teacherId, teacherName, total: 0, completedCount: 0, pendingCount: 0, fenns: new Set(), sinifs: new Set() });
      }
      const g = map.get(teacherId)!;
      g.total += 1;
      if (a.status === 'completed') g.completedCount += 1;
      else g.pendingCount += 1;
      if (a.fenn) g.fenns.add(a.fenn);
      if (a.grade) g.sinifs.add(a.grade);
    });
    return Array.from(map.values()).map((g) => ({
      teacherId: g.teacherId,
      teacherName: g.teacherName,
      total: g.total,
      completedCount: g.completedCount,
      pendingCount: g.pendingCount,
      fenns: Array.from(g.fenns).join(', '),
      sinifs: Array.from(g.sinifs).join(', ')
    }));
  }, [allApellyasiyas]);

  // Apellyasiya nətcələrini topla (bir öğrenci için)
  const collectApellyasiyaResults = (student: StudentDetailData): Array<{
    questionNum: string;
    fenn: string;
    previousScore: string | number;
    newScore: string | number;
    apellyasiyaNote: string;
    apellyasiyaHoca: string;
    apellyasiyaHocaId: string;
    onaylanmaTarihi: string;
    studentId: string;
    studentName: string;
  }> => {
    const results: Array<{
      questionNum: string;
      fenn: string;
      previousScore: string | number;
      newScore: string | number;
      apellyasiyaNote: string;
      apellyasiyaHoca: string;
      apellyasiyaHocaId: string;
      onaylanmaTarihi: string;
      studentId: string;
      studentName: string;
    }> = [];

    if (isBuraxilis) {
      // Buraxılış logic
      if (!student.grade) return [];

      const gradeNum = typeof student.grade === 'number' ? student.grade : parseInt(student.grade as string);
      const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, student.xdil, buraxilisBlankCtx(selectedExam, student));
      if (!gradeQuestions || gradeQuestions.length === 0) return [];

      gradeQuestions.forEach((subjectGroup: { subject: string; questions: string[] }) => {
        const { subject, questions } = subjectGroup;

        questions.forEach((questionNum: string) => {
          const gradingData = (student as any)[`${questionNum}_c`];
          if (!gradingData || typeof gradingData !== 'object') return;

          // Apellyasiya tamamlandıysa
          const isApellyasiyaCompleted = gradingData.apellyasiya_status === true ||
            gradingData.apellyasiya_result === true;

          if (isApellyasiyaCompleted && gradingData.previous_score !== undefined && gradingData.new_score !== undefined) {
            // Fənn adını təyin et
            let fennName = subject;
            if (FOREIGN_LANGUAGES.includes(subject)) {
              fennName = subject; // Already the specific language name
            }

            results.push({
              questionNum,
              fenn: fennName,
              previousScore: gradingData.previous_score || '0',
              newScore: gradingData.new_score || '0',
              apellyasiyaNote: gradingData.apellyasiya_note || '',
              apellyasiyaHoca: gradingData.apellyasiya_hoca || '',
              apellyasiyaHocaId: gradingData.apellyasiya_hocaId || '',
              onaylanmaTarihi: gradingData.apellyasiya_onaylanma_tarihi
                ? new Date(
                  gradingData.apellyasiya_onaylanma_tarihi.toDate ?
                    gradingData.apellyasiya_onaylanma_tarihi.toDate() :
                    gradingData.apellyasiya_onaylanma_tarihi
                ).toLocaleString('az-AZ')
                : '',
              studentId: student.student_id,
              studentName: `${student.firstName} ${student.lastName}`
            });
          }
        });
      });
    } else {
      // Blok logic
      const mode = detectBlokMode(student);
      const actualQuestions = getActualBlokQuestions(student);

      // Get fenn configs for mapping question numbers to fenn names
      const qrup = student.specialtyGroup;
      const fennConfigs = getFennlerByQrup(qrup);

      actualQuestions.forEach(questionNum => {
        const gradingData = (student as any)[`${questionNum}_c`];
        if (!gradingData || typeof gradingData !== 'object') return;

        // Apellyasiya tamamlandıysa
        const isApellyasiyaCompleted = gradingData.apellyasiya_status === true ||
          gradingData.apellyasiya_result === true;

        if (isApellyasiyaCompleted && gradingData.previous_score !== undefined && gradingData.new_score !== undefined) {
          // Find which fenn this question belongs to
          const qNumInt = parseInt(questionNum.replace('Q', ''));
          const fennConfig = fennConfigs.find(f => qNumInt >= f.start && qNumInt <= f.end);

          results.push({
            questionNum,
            fenn: fennConfig?.fenn || 'Unknown',
            previousScore: gradingData.previous_score || '0',
            newScore: gradingData.new_score || '0',
            apellyasiyaNote: gradingData.apellyasiya_note || '',
            apellyasiyaHoca: gradingData.apellyasiya_hoca || '',
            apellyasiyaHocaId: gradingData.apellyasiya_hocaId || '',
            onaylanmaTarihi: gradingData.apellyasiya_onaylanma_tarihi
              ? new Date(
                gradingData.apellyasiya_onaylanma_tarihi.toDate ?
                  gradingData.apellyasiya_onaylanma_tarihi.toDate() :
                  gradingData.apellyasiya_onaylanma_tarihi
              ).toLocaleString('az-AZ')
              : '',
            studentId: student.student_id,
            studentName: `${student.firstName} ${student.lastName}`
          });
        }
      });
    }

    return results;
  };

  // Apellyasiya nəticələrini TXT məzmunu olaraq hazırla
  const generateApellyasiyaTxtContent = (): string | null => {
    if (!selectedStudent) return null;
    
    const results = collectApellyasiyaResults(selectedStudent);
    if (results.length === 0) {
      return null;
    }
    
    let txtContent = `APELLYASİYA NƏTİCƏLƏRİ\n`;
    txtContent += `═══════════════════════════════════════════════════════════\n\n`;
    txtContent += `Şagird: ${selectedStudent.firstName} ${selectedStudent.lastName}\n`;
    txtContent += `Şagird ID: ${selectedStudent.student_id}\n`;
    txtContent += `Sinif: ${selectedStudent.grade}. Sinif\n`;
    if (selectedStudent.variant) {
      txtContent += `Variant: ${selectedStudent.variant}\n`;
    }
    if (selectedStudent.xdil) {
      txtContent += `Xarici Dil: ${normalizeXdil(selectedStudent.xdil)}\n`;
    }
    txtContent += `\n`;
    txtContent += `═══════════════════════════════════════════════════════════\n\n`;
    
    results.forEach((result, index) => {
      txtContent += `${index + 1}. APELLYASİYA NƏTİCƏSİ\n`;
      txtContent += `─────────────────────────────────────────────────────────\n`;
      txtContent += `Sual: ${result.questionNum}\n`;
      txtContent += `Fənn: ${result.fenn}\n`;
      txtContent += `Əvvəlki Bal: ${result.previousScore}\n`;
      txtContent += `Yeni Bal: ${result.newScore}\n`;
      const prevScoreNum = Number(result.previousScore) || 0;
      const newScoreNum = Number(result.newScore) || 0;
      const diff = newScoreNum - prevScoreNum;
      if (!isNaN(diff) && prevScoreNum !== newScoreNum) {
        txtContent += `Dəyişiklik: ${diff > 0 ? '+' : ''}${diff}\n`;
      } else {
        txtContent += `Dəyişiklik: Dəyişməyib\n`;
      }
      if (result.apellyasiyaNote) {
        txtContent += `Müəllim Qeydi: ${result.apellyasiyaNote}\n`;
      }
      if (result.apellyasiyaHoca) {
        txtContent += `Apellyasiyanı Yoxlayan: ${result.apellyasiyaHoca}\n`;
      }
      if (result.onaylanmaTarihi) {
        txtContent += `Təsdiqlənmə Tarixi: ${result.onaylanmaTarihi}\n`;
      }
      txtContent += `\n`;
    });
    
    txtContent += `═══════════════════════════════════════════════════════════\n`;
    txtContent += `Ümumi Apellyasiya Sayı: ${results.length}\n`;
    txtContent += `Export Tarixi: ${new Date().toLocaleString('az-AZ')}\n`;
    
    return txtContent;
  };

  // Apellyasiya nəticələrini TXT olaraq export et
  const exportApellyasiyaToTxt = () => {
    if (!selectedStudent) return;
    
    const txtContent = generateApellyasiyaTxtContent();
    if (!txtContent) {
      alert('Bu şagird üçün apellyasiya nəticəsi tapılmadı');
      return;
    }
    
    // Download as TXT
    const blob = new Blob([txtContent], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Apellyasiya_Neticeleri_${selectedStudent.student_id}_${new Date().toISOString().split('T')[0]}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    setSuccessMessage('Apellyasiya nəticələri TXT formatında yükləndi');
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };

  // Apellyasiya nəticələrini panoya kopyala
  const copyApellyasiyaToClipboard = async () => {
    if (!selectedStudent) return;
    
    const txtContent = generateApellyasiyaTxtContent();
    if (!txtContent) {
      alert('Bu şagird üçün apellyasiya nəticəsi tapılmadı');
      return;
    }
    
    try {
      await navigator.clipboard.writeText(txtContent);
      setSuccessMessage('Apellyasiya nəticələri panoya kopyalandı');
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    } catch (error) {
      console.error('Panoya kopyalama xətası:', error);
      // Fallback: eski yöntem
      const textArea = document.createElement('textarea');
      textArea.value = txtContent;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setSuccessMessage('Apellyasiya nəticələri panoya kopyalandı');
        setShowSuccessToast(true);
        setTimeout(() => setShowSuccessToast(false), 3000);
      } catch (err) {
        alert('Panoya kopyalama uğursuz oldu');
      }
      document.body.removeChild(textArea);
    }
  };

  // Apellyasiya nəticələrini Excel olaraq export et
  const exportApellyasiyaToExcel = () => {
    if (!selectedStudent) return;
    
    const results = collectApellyasiyaResults(selectedStudent);
    if (results.length === 0) {
      alert('Bu şagird üçün apellyasiya nəticəsi tapılmadı');
      return;
    }
    
    const workbook = XLSX.utils.book_new();
    
    // Data hazırla
    const excelData: (string | number)[][] = [
      ['Şagird Məlumatları', ''],
      ['Ad Soyad', `${selectedStudent.firstName} ${selectedStudent.lastName}`],
      ['Şagird ID', selectedStudent.student_id],
      ['Sinif', `${selectedStudent.grade}. Sinif`],
      selectedStudent.variant ? ['Variant', selectedStudent.variant] : null,
      selectedStudent.xdil ? ['Xarici Dil', normalizeXdil(selectedStudent.xdil)] : null,
      ['', ''],
      ['Apellyasiya Nəticələri', ''],
      ['Sual', 'Fənn', 'Əvvəlki Bal', 'Yeni Bal', 'Dəyişiklik', 'Müəllim Qeydi', 'Apellyasiyanı Yoxlayan', 'Təsdiqlənmə Tarixi']
    ].filter(Boolean) as (string | number)[][];
    
    results.forEach(result => {
      const diff = Number(result.newScore) - Number(result.previousScore);
      const diffText = diff > 0 ? `+${diff}` : diff < 0 ? `${diff}` : 'Dəyişməyib';
      
      excelData.push([
        result.questionNum,
        result.fenn,
        result.previousScore,
        result.newScore,
        diffText,
        result.apellyasiyaNote || '-',
        result.apellyasiyaHoca || '-',
        result.onaylanmaTarihi || '-'
      ]);
    });
    
    excelData.push(['', '']);
    excelData.push(['Ümumi Apellyasiya Sayı', results.length]);
    excelData.push(['Export Tarixi', new Date().toLocaleString('az-AZ')]);
    
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Apellyasiya Nəticələri');
    
    const fileName = `Apellyasiya_Neticeleri_${selectedStudent.student_id}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
    
    setSuccessMessage('Apellyasiya nəticələri Excel formatında yükləndi');
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };

  // Tək sualın balını sil (yalnız Q##_c, sual şəkli Q## toxunulmaz qalır)
  // Handle opening question scoring modal
  const handleOpenQuestionScoringModal = (student: StudentDetailData, questionNum: string) => {
    setScoringQuestionNumber(questionNum);
    setSelectedStudent(student);
    setShowQuestionScoringModal(true);
  };

  // Handle saving question score
  const handleSaveQuestionScore = async (questionNumber: string, score: string, note: string, criteria?: any) => {
    if (!selectedStudent || !selectedExam) {
      throw new Error('Şagird və ya imtahan seçilməyib');
    }

    try {
      setSavingScore(true);
      const { updateDoc, doc, Timestamp } = await import('firebase/firestore');
      
      const adminId = 'admin';
      const adminName = 'Admin';

      const gradingData: any = {
        score: score,
        hocaId: adminId,
        hoca: adminName,
        timestamp: Timestamp.now(),
        ...(note.trim() && { note: note.trim() }),
        ...(criteria && { criteria: criteria })
      };

      const gradingFieldName = `${questionNumber}_c`;
      await updateDoc(doc(db, selectedExam.collection || 'buraxilis2', selectedStudent.id), {
        [gradingFieldName]: gradingData
      });

      console.log('💾 Admin bal yazıldı:', {
        studentId: selectedStudent.student_id,
        question: questionNumber,
        field: gradingFieldName,
        gradingData
      });

      // Show success message
      setSuccessMessage(`${questionNumber} üçün bal yadda saxlanıldı`);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);

      // Refresh student data
      await loadStudents();

      // Update selectedStudent if it's still the same student
      if (selectedStudent) {
        const updatedStudents = await getAllStudents(selectedExam.collection || 'buraxilis2');
        const updatedStudent = updatedStudents.find(s => s.id === selectedStudent.id);
        if (updatedStudent) {
          setSelectedStudent(updatedStudent);
        }
      }
    } catch (error) {
      console.error('❌ Bal yadda saxlanarkən xəta:', error);
      throw error;
    } finally {
      setSavingScore(false);
    }
  };

  const handleClearQuestionScore = async (student: StudentDetailData, questionNum: string) => {
    if (!selectedExam) {
      alert('İmtahan məlumatı tapılmadı');
      return;
    }

    const confirmDelete = window.confirm(
      `${questionNum} sualının balını silmək istədiyinizə əminsiniz? (Yalnız Q${questionNum}_c balı silinəcək, sual şəkli qalacaq)`
    );
    if (!confirmDelete) return;

    try {
      const { updateDoc, doc, deleteField } = await import('firebase/firestore');
      const { db } = await import('../../firebase');

      const ref = doc(db, selectedExam.collection || 'buraxilis2', student.id);
      await updateDoc(ref, {
        [`${questionNum}_c`]: deleteField()
      });

      // Local state-i yenilə: students
      setStudents(prev =>
        prev.map(s =>
          s.id === student.id
            ? ({ ...s, [`${questionNum}_c`]: undefined } as any)
            : s
        )
      );

      // Seçilmiş şagirdi də yenilə ki, modal dərhal yenilənsin
      setSelectedStudent(prev =>
        prev && prev.id === student.id
          ? ({ ...prev, [`${questionNum}_c`]: undefined } as any)
          : prev
      );

      setSuccessMessage(`${questionNum} sualının balı silindi`);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    } catch (error) {
      console.error('Sual balı silinərkən xəta:', error);
      alert('Sual balı silinərkən xəta baş verdi');
    }
  };

  const totalStudents = filteredStudents.length;
  
  const tamamlandiStudents = filteredStudents.filter(s => {
    if (isBuraxilis && s.grade) {
      const gradeNum = typeof s.grade === 'number' ? s.grade : parseInt(s.grade as string);
      const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, s.xdil, buraxilisBlankCtx(selectedExam, s));
      if (!gradeQuestions || gradeQuestions.length === 0) return false;
      const totalQuestions = gradeQuestions.reduce((sum: number, subj: { subject: string; questions: string[] }) => sum + subj.questions.length, 0);
      let gradedCount = 0;
      gradeQuestions.forEach((subj: { subject: string; questions: string[] }) => {
        subj.questions.forEach((q: string) => {
          if ((s as any)[`${q}_c`]) gradedCount++;
        });
      });
      return gradedCount === totalQuestions && gradedCount > 0;
    }
    return (s.completedFennCount || 0) === (s.totalFennCount || 0) && (s.completedFennCount || 0) > 0;
  }).length;

  const kismiStudents = filteredStudents.filter(s => {
    if (isBuraxilis && s.grade) {
      const gradeNum = typeof s.grade === 'number' ? s.grade : parseInt(s.grade as string);
      const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, s.xdil, buraxilisBlankCtx(selectedExam, s));
      if (!gradeQuestions || gradeQuestions.length === 0) return false;
      const totalQuestions = gradeQuestions.reduce((sum: number, subj: { subject: string; questions: string[] }) => sum + subj.questions.length, 0);
      let gradedCount = 0;
      gradeQuestions.forEach((subj: { subject: string; questions: string[] }) => {
        subj.questions.forEach((q: string) => {
          if ((s as any)[`${q}_c`]) gradedCount++;
        });
      });
      return gradedCount > 0 && gradedCount < totalQuestions;
    }
    return (s.completedFennCount || 0) > 0 && (s.completedFennCount || 0) < (s.totalFennCount || 0);
  }).length;

  const yoklanmamisStudents = filteredStudents.filter(s => {
    if (isBuraxilis && s.grade) {
      const gradeNum = typeof s.grade === 'number' ? s.grade : parseInt(s.grade as string);
      const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, s.xdil, buraxilisBlankCtx(selectedExam, s));
      if (!gradeQuestions || gradeQuestions.length === 0) return true;
      let gradedCount = 0;
      gradeQuestions.forEach((subj: { subject: string; questions: string[] }) => {
        subj.questions.forEach((q: string) => {
          if ((s as any)[`${q}_c`]) gradedCount++;
        });
      });
      return gradedCount === 0;
    }
    return (s.completedFennCount || 0) === 0;
  }).length;

  if (loading) {
    return (
      <Container>
        <LoadingContainer>
          <LoadingSpinner />
          <div>Şagirdlər yüklənir...</div>
        </LoadingContainer>
      </Container>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <Container>
        <Header>
        <Title>Şagird Nəticələri</Title>
          <Button onClick={() => navigate('/admin/dashboard')}>
          Geri Qayıt
          </Button>
        </Header>
        {selectedExam?.collection && (
          <div style={{ margin: '0 0 12px', color: '#64748b', fontSize: 13 }}>
            {selectedExam.name} · koleksiya: <strong>{selectedExam.collection}</strong>
            {isBuraxilis ? ' · Buraxılış' : ' · Blok'}
          </div>
        )}

      {/* Tab switcher - show for both buraxilis and blok */}
      <TabContainer>
        <TabButton
          active={activeTab === 'results'}
          onClick={() => setActiveTab('results')}
        >
          Nəticələr ({filteredStudents.length})
        </TabButton>
        <TabButton
          active={activeTab === 'emptyVerification'}
          onClick={() => setActiveTab('emptyVerification')}
        >
          Boş Səhifə Yoxlaması ({emptyPagesToVerify.length})
        </TabButton>
        <TabButton
          active={activeTab === 'apellyasiya'}
          onClick={() => setActiveTab('apellyasiya')}
        >
          Apellyasiyalar ({allApellyasiyas.length})
        </TabButton>
      </TabContainer>

      {/* Empty Page Verification Tab */}
      {activeTab === 'emptyVerification' && (
        <EmptyVerificationContainer>
          {emptyPagesToVerify.length === 0 ? (
            <NoData>
              <div style={{ marginBottom: '16px' }}><IconCheckCircle size={48} color="#10b981" style={{ marginRight: 0 }} /></div>
              <div style={{ fontSize: '20px', fontWeight: '600', color: '#10b981' }}>
                Bütün boş səhifələr yoxlanıldı və ya yoxlanacaq boş səhifə yoxdur
              </div>
            </NoData>
          ) : (
            <>
              <StatsBar>
                <StatItem>
                  <span className="label">Ümumi</span>
                  <span className="value">{emptyPagesToVerify.length}</span>
                </StatItem>
                <StatItem>
                  <span className="label">Gözləyən</span>
                  <span className="value" style={{ color: '#FF9800' }}>
                    {emptyPagesToVerify.filter(p => p.verificationStatus === 'pending').length}
                  </span>
                </StatItem>
                <StatItem>
                  <span className="label">Təsdiqləndi</span>
                  <span className="value" style={{ color: '#4CAF50' }}>
                    {emptyPagesToVerify.filter(p => p.verificationStatus === 'confirmed').length}
                  </span>
                </StatItem>
                <StatItem>
                  <span className="label">Rədd edildi</span>
                  <span className="value" style={{ color: '#f44336' }}>
                    {emptyPagesToVerify.filter(p => p.verificationStatus === 'rejected').length}
                  </span>
                </StatItem>
                <StatItem>
                  <Button
                    onClick={handleValidateAndPreview}
                    disabled={isValidating || isCleaningUp}
                    style={{
                      padding: '8px 16px',
                      fontSize: '13px',
                      minWidth: '140px',
                      background: isValidating || isCleaningUp
                        ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)'
                        : 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                      opacity: isValidating || isCleaningUp ? 0.7 : 1
                    }}
                  >
                    {isValidating ? '🔍 Skan edilir...' : isCleaningUp ? '🧹 Təmizlənir...' : '🔍 Data Validation'}
                  </Button>
                </StatItem>
                <StatItem>
                  <Button
                    onClick={() => setShowEmptyPageZipModal(true)}
                    disabled={emptyPagesToVerify.length === 0}
                    style={{
                      padding: '8px 16px',
                      fontSize: '13px',
                      minWidth: '160px',
                      background: emptyPagesToVerify.length === 0
                        ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)'
                        : 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                      opacity: emptyPagesToVerify.length === 0 ? 0.7 : 1
                    }}
                  >
                    <><Icon name="archive" size={14} /> Boş kağız nəticəsini ZIP endir</>
                  </Button>
                </StatItem>
              </StatsBar>

              <ViewModeToggle>
                <span style={{ fontSize: '14px', fontWeight: '500', color: '#666' }}>Görünüş:</span>
                <ViewModeButton
                  active={verificationViewMode === 'single'}
                  onClick={() => setVerificationViewMode('single')}
                >
                  <><Icon name="assignments" size={14} /> Tək-tək</>
                </ViewModeButton>
                <ViewModeButton
                  active={verificationViewMode === 'list'}
                  onClick={() => setVerificationViewMode('list')}
                >
                  <><Icon name="stats" size={14} /> Siyahı</>
                </ViewModeButton>
                <ViewModeButton
                  active={verificationViewMode === 'student'}
                  onClick={() => setVerificationViewMode('student')}
                >
                  <><Icon name="student" size={14} /> Şagirdə Görə</>
                </ViewModeButton>
              </ViewModeToggle>

              {/* Search by student name or ID */}
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text"
                  value={emptyPageSearchTerm}
                  onChange={e => setEmptyPageSearchTerm(e.target.value)}
                  placeholder="Şagird adı və ya ID ilə axtar..."
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none',
                    boxSizing: 'border-box',
                    background: '#f8fafc'
                  }}
                />
              </div>

              <FilterContainer>
                <FilterButton 
                  active={verificationFilter === 'all'}
                  onClick={() => setVerificationFilter('all')}
                >
                  Hamısı ({emptyPagesToVerify.length})
                </FilterButton>
                <FilterButton 
                  active={verificationFilter === 'pending'}
                  onClick={() => setVerificationFilter('pending')}
                >
                  <><IconClock size={14} /> Gözləyən ({emptyPagesToVerify.filter(p => p.verificationStatus === 'pending').length})</>
                </FilterButton>
                <FilterButton 
                  active={verificationFilter === 'confirmed'}
                  onClick={() => setVerificationFilter('confirmed')}
                >
                  <><IconCheck size={14} /> Təsdiqləndi ({emptyPagesToVerify.filter(p => p.verificationStatus === 'confirmed').length})</>
                </FilterButton>
                <FilterButton 
                  active={verificationFilter === 'rejected'}
                  onClick={() => setVerificationFilter('rejected')}
                >
                  <><IconX size={14} /> Rədd edildi ({emptyPagesToVerify.filter(p => p.verificationStatus === 'rejected').length})</>
                </FilterButton>
              </FilterContainer>

              {/* Pixel-based Filter Section */}
              <FilterContainer>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                  {/* Enable/Disable Toggle */}
                  <FilterButton
                    active={pixelFilterEnabled}
                    onClick={() => setPixelFilterEnabled(!pixelFilterEnabled)}
                  >
                    {pixelFilterEnabled ? <IconCheck size={14} /> : <IconCircle size={14} />} Piksel filteri
                  </FilterButton>

                  {/* Comparison Operator Dropdown */}
                  {pixelFilterEnabled && (
                    <>
                      <FilterSelect
                        value={pixelOperator}
                        onChange={(e) => setPixelOperator(e.target.value as any)}
                        style={{ width: '100px', padding: '6px 12px' }}
                      >
                        <option value=">=">&gt;= (Böyük-bərabər)</option>
                        <option value=">">&gt; (Böyük)</option>
                        <option value="<=">&lt;= (Kiçik-bərabər)</option>
                        <option value="<">&lt; (Kiçik)</option>
                        <option value="=">= (Bərabər)</option>
                      </FilterSelect>

                      {/* Pixel Threshold Input */}
                      <FilterInput
                        type="number"
                        value={pixelThreshold}
                        onChange={(e) => setPixelThreshold(e.target.value)}
                        placeholder="700"
                        style={{ width: '100px', padding: '6px 12px' }}
                      />

                      {/* Preset Buttons */}
                      <span style={{ fontSize: '13px', color: '#64748b', fontWeight: '500' }}>
                        Tez:
                      </span>
                      <FilterButton
                        active={pixelThreshold === '800' && pixelOperator === '>='}
                        onClick={() => { setPixelThreshold('800'); setPixelOperator('>='); }}
                      >
                        800+ piksel
                      </FilterButton>
                      <FilterButton
                        active={pixelThreshold === '600' && pixelOperator === '<'}
                        onClick={() => { setPixelThreshold('600'); setPixelOperator('<'); }}
                      >
                        600- piksel
                      </FilterButton>
                      <FilterButton
                        active={pixelThreshold === '700' && pixelOperator === '>='}
                        onClick={() => { setPixelThreshold('700'); setPixelOperator('>='); }}
                      >
                        700+ piksel
                      </FilterButton>
                    </>
                  )}
                </div>
              </FilterContainer>

              {/* Show filtered count info */}
              {pixelFilterEnabled && (
                <div style={{
                  padding: '12px 16px',
                  background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                  color: 'white',
                  borderRadius: '8px',
                  marginBottom: '16px',
                  fontSize: '14px',
                  fontWeight: '600',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <span>
                    Filter: {pixelOperator} {pixelThreshold} mavi piksel
                  </span>
                  <span>
                    {filteredPagesByPixel.length} / {emptyPagesToVerify.length} səhifə
                  </span>
                </div>
              )}

              {verificationViewMode === 'single' ? (
                // Single view mode
                <>
                  {/* Empty state check - when no pages match filter */}
                  {filteredPages.length === 0 ? (
                    <div style={{
                      textAlign: 'center',
                      padding: '48px 24px',
                      background: '#f9fafb',
                      borderRadius: '8px',
                      border: '2px dashed #d1d5db'
                    }}>
                      <p style={{
                        color: '#6b7280',
                        marginBottom: '16px',
                        fontSize: '16px'
                      }}>
                        Bütün səhifələr yoxlanılıb <IconCheckCircle size={20} style={{ marginRight: 0, verticalAlign: 'middle' }} />
                      </p>
                      <button
                        onClick={() => {
                          setVerificationFilter('all');
                          setCurrentEmptyPageIndex(0);
                        }}
                        style={{
                          background: '#3b82f6',
                          color: 'white',
                          padding: '10px 20px',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          fontWeight: '500'
                        }}
                      >
                        Bütün səhifələri göstər
                      </button>
                    </div>
                  ) : (
                    <>
                      <ProgressIndicator>
                        {currentEmptyPageIndex + 1} / {filteredPages.length} səhifə
                      </ProgressIndicator>

                      {(() => {
                        const currentPage = filteredPages[currentEmptyPageIndex];
                    return (
                      <EmptyPageCard>
                        {/* Naviqasiya düymələri: əvvəlki / növbəti */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px', gap: '8px', flexWrap: 'wrap' }}>
                          <Button
                            onClick={() => {
                              if (currentEmptyPageIndex > 0) {
                                setEmptyImageLoading(true);
                                setCurrentEmptyPageIndex(currentEmptyPageIndex - 1);
                              }
                            }}
                            disabled={currentEmptyPageIndex === 0}
                            style={{ padding: '6px 16px', fontSize: '13px', background: '#e5e7eb', color: '#111827' }}
                          >
                            Əvvəlki səhifə
                          </Button>
                          <Button
                            onClick={() => {
                              const maxIndex = filteredPages.length - 1;
                              if (currentEmptyPageIndex < maxIndex) {
                                setEmptyImageLoading(true);
                                setCurrentEmptyPageIndex(currentEmptyPageIndex + 1);
                              }
                            }}
                            disabled={currentEmptyPageIndex >= filteredPages.length - 1}
                            style={{ padding: '6px 16px', fontSize: '13px' }}
                          >
                            Növbəti səhifə
                          </Button>
                        </div>

                        <EmptyPageInfo>
                          <InfoItem>
                            <strong>Şagird</strong>
                            <span>{currentPage.studentName}</span>
                          </InfoItem>
                          <InfoItem>
                            <strong>İştirakçı ID</strong>
                            <span>{currentPage.studentId}</span>
                          </InfoItem>
                          <InfoItem>
                            <strong>Sual</strong>
                            <span>{currentPage.questionNumber}</span>
                          </InfoItem>
                          <InfoItem>
                            <strong>Status</strong>
                            <span>
                              <ListItemBadge type={currentPage.verificationStatus || 'pending'}>
                                {currentPage.verificationStatus === 'confirmed' ? <><IconCheck /> Təsdiqləndi</> :
                                 currentPage.verificationStatus === 'rejected' ? <><IconX /> Rədd edildi</> : <><IconClock /> Gözləyir</>}
                              </ListItemBadge>
                            </span>
                          </InfoItem>
                          <InfoItem>
                            <strong>Mavi piksel</strong>
                            <span>{currentPage.questionData.blue_pixels || 0}</span>
                          </InfoItem>
                          <InfoItem>
                            <strong>Mavi nisbət</strong>
                            <span>{((currentPage.questionData.blue_ratio || 0) * 100).toFixed(2)}%</span>
                          </InfoItem>
                        </EmptyPageInfo>

                        <EmptyPageImage>
                          {emptyImageLoading && (
                            <ImageLoadingContainer>
                              <ImageLoadingSpinner />
                              <div>Şəkil yüklənir...</div>
                            </ImageLoadingContainer>
                          )}
                          <img 
                            src={currentPage.questionData.path} 
                            alt={`${currentPage.questionNumber} - ${currentPage.studentName}`}
                            style={{ maxWidth: '100%', height: 'auto', display: emptyImageLoading ? 'none' : 'block' }}
                            onLoad={() => setEmptyImageLoading(false)}
                            onError={() => setEmptyImageLoading(false)}
                          />
                        </EmptyPageImage>

                        <VerificationButtons>
                          <VerifyButton
                            variant="reject"
                            onClick={() => handleVerifyEmptyPage(false)}
                            disabled={emptyImageLoading}
                          >
                            <><IconX size={14} /> Səhifə DOLU (Rədd et)</>
                          </VerifyButton>
                          <VerifyButton
                            variant="confirm"
                            onClick={() => handleVerifyEmptyPage(true)}
                            disabled={emptyImageLoading}
                          >
                            <><IconCheck size={14} /> Səhifə BOŞ (Təsdiqlə)</>
                          </VerifyButton>
                        </VerificationButtons>
                      </EmptyPageCard>
                    );
                  })()}
                    </>
                  )}
                </>
              ) : verificationViewMode === 'list' ? (
                // List view mode
                <ListView>
                  {filteredPages.map((page, index) => (
                      <ListItem key={`${page.studentId}-${page.questionNumber}`} status={page.verificationStatus}>
                        <ListItemImage
                          src={page.questionData.path}
                          alt={page.questionNumber}
                          onClick={() => {
                            setCurrentEmptyPageIndex(filteredPages.indexOf(page));
                            setVerificationViewMode('single');
                          }}
                        />
                        <ListItemInfo>
                          <strong>{page.studentName}</strong>
                          <span style={{ color: '#666' }}>{page.studentId}</span>
                        </ListItemInfo>
                        <ListItemInfo>
                          <strong>{page.questionNumber}</strong>
                        </ListItemInfo>
                        <ListItemInfo>
                          <span>Blue: {((page.questionData.blue_ratio || 0) * 100).toFixed(1)}%</span>
                          <span style={{ fontSize: '11px', color: '#999' }}>
                            {page.questionData.blue_pixels || 0} px
                          </span>
                        </ListItemInfo>
                        <ListItemBadge type={page.verificationStatus || 'pending'}>
                          {page.verificationStatus === 'confirmed' ? <><IconCheck /> Təsdiqləndi</> :
                           page.verificationStatus === 'rejected' ? <><IconX /> Rədd edildi</> : <><IconClock /> Gözləyir</>}
                        </ListItemBadge>
                        <ListItemActions>
                          <ListActionButton
                            variant="view"
                            onClick={() => {
                              setCurrentEmptyPageIndex(filteredPages.indexOf(page));
                              setVerificationViewMode('single');
                            }}
                          >
                            👁 Bax
                          </ListActionButton>
                          {page.verificationStatus !== 'confirmed' && (
                            <ListActionButton 
                              variant="confirm"
                              onClick={async () => {
                                try {
                                  const { updateDoc, doc, Timestamp } = await import('firebase/firestore');
                                  const { db } = await import('../../firebase');
                                  const studentDoc = students.find(s => s.student_id === page.studentId);
                                  if (studentDoc) {
                                    const adminId = localStorage.getItem('userId') || 'admin';
                                    const adminName = localStorage.getItem('userName') || 'Admin';
                                    
                                    // BOŞ TƏSDİQLƏNDİ - həm Q## həm də Q##_c update et
                                    await updateDoc(doc(db, selectedExam?.collection || 'buraxilis2', studentDoc.id), {
                                      [`${page.questionNumber}.double_check_empty`]: true,
                                      [`${page.questionNumber}_c`]: {
                                        hoca: adminName,
                                        hocaId: adminId,
                                        score: '0',
                                        timestamp: Timestamp.now(),
                                        note: 'Boş sual - Admin tərəfindən təsdiqləndi'
                                      }
                                    });
                                    setEmptyPagesToVerify(prev => prev.map(p => 
                                      p === page ? { ...p, verificationStatus: 'confirmed' as const, verifiedAt: new Date() } : p
                                    ));
                                    setSuccessMessage(`${page.questionNumber} boş səhifə təsdiqləndi və 0 bal verildi`);
                                    setShowSuccessToast(true);
                                    setTimeout(() => setShowSuccessToast(false), 3000);
                                  }
                                } catch (error) {
                                  console.error('Error confirming:', error);
                                  alert('Xəta baş verdi');
                                }
                              }}
                            >
                              <IconCheck size={18} style={{ marginRight: 0 }} />
                            </ListActionButton>
                          )}
                          {page.verificationStatus !== 'rejected' && (
                            <ListActionButton 
                              variant="reject"
                              onClick={async () => {
                                try {
                                  const { updateDoc, doc } = await import('firebase/firestore');
                                  const { db } = await import('../../firebase');
                                  const studentDoc = students.find(s => s.student_id === page.studentId);
                                  if (studentDoc) {
                                    // RƏDD EDİLDİ - yalnız double_check_empty: false (Q##_c dəyişməz)
                                    await updateDoc(doc(db, selectedExam?.collection || 'buraxilis2', studentDoc.id), {
                                      [`${page.questionNumber}.double_check_empty`]: false
                                    });
                                    setEmptyPagesToVerify(prev => prev.map(p => 
                                      p === page ? { ...p, verificationStatus: 'rejected' as const, verifiedAt: new Date() } : p
                                    ));
                                    setSuccessMessage(`${page.questionNumber} dolu səhifə - hoca yoxlayacaq`);
                                    setShowSuccessToast(true);
                                    setTimeout(() => setShowSuccessToast(false), 3000);
                                  }
                                } catch (error) {
                                  console.error('Error rejecting:', error);
                                  alert('Xəta baş verdi');
                                }
                              }}
                            >
                              <IconX size={18} style={{ marginRight: 0 }} />
                            </ListActionButton>
                          )}
                        </ListItemActions>
                      </ListItem>
                    ))
                  }
                </ListView>
              ) : (
                // Student view mode
                <StudentListView
                  studentGroups={filteredSortedStudentGroups.filter(group =>
                    verificationFilter === 'all' ||
                    (verificationFilter === 'pending' && group.pendingCount > 0) ||
                    (verificationFilter === 'confirmed' && group.verifiedCount > 0 && group.pendingCount === 0) ||
                    (verificationFilter === 'rejected' && group.emptyPages.some(p => p.verificationStatus === 'rejected'))
                  )}
                  onPreviewStudent={(group) => {
                    setSelectedStudentGroup(group);
                    setShowStudentDetail(true);
                  }}
                  onQuickConfirm={(group) => {
                    // Quick confirm applies to ALL pending questions (no selection)
                    setSelectedStudentGroup(group);
                    setBulkConfirmAction('confirm');
                    setShowBulkConfirmDialog(true);
                    setSelectedQuestionNumbers(new Set()); // Clear any existing selection
                  }}
                />
              )}
            </>
          )}
        </EmptyVerificationContainer>
      )}

      {/* Student Detail Modal for Empty Page Verification */}
      <StudentEmptyPagesModal
        show={showStudentDetail}
        studentGroup={selectedStudentGroup}
        onClose={handleStudentModalClose}
        onBulkConfirm={(selected) => {
          if (selectedStudentGroup) {
            handleBulkVerifyForStudent(selectedStudentGroup, true, selected);
            setShowStudentDetail(false);
          }
        }}
        onBulkReject={(selected) => {
          if (selectedStudentGroup) {
            handleBulkVerifyForStudent(selectedStudentGroup, false, selected);
            setShowStudentDetail(false);
          }
        }}
        bulkProcessing={bulkProcessing}
        selectedQuestionNumbers={selectedQuestionNumbers}
        onToggleQuestion={handleToggleQuestionCheckbox}
      />

      {/* Boş kağız nəticəsi ZIP – əvvəl UI-da şəkillər, sonra Indir ilə ZIP */}
      <EmptyPageZipModal
        show={showEmptyPageZipModal}
        onClose={() => setShowEmptyPageZipModal(false)}
        emptyPages={emptyPagesToVerify}
        onSuccess={(total, confirmed, rejected) => {
          toast.success(
            'ZIP endirildi',
            `${total} şəkil (Təsdiqləndi: ${confirmed}, Rədd edildi: ${rejected})`
          );
        }}
        onError={(msg) => toast.error('ZIP xətası', msg)}
      />

      {/* Bulk Confirm Dialog for Quick Confirm */}
      {showBulkConfirmDialog && selectedStudentGroup && bulkConfirmAction && (
        <BulkConfirmDialog
          show={showBulkConfirmDialog}
          studentGroup={selectedStudentGroup}
          action={bulkConfirmAction}
          onConfirm={() => {
            if (selectedStudentGroup) {
              handleBulkVerifyForStudent(selectedStudentGroup, bulkConfirmAction === 'confirm', new Set());
              setShowBulkConfirmDialog(false);
            }
          }}
          onCancel={() => {
            setShowBulkConfirmDialog(false);
            setBulkConfirmAction(null);
          }}
          selectedQuestionNumbers={new Set()}
        />
      )}

      {/* Apellyasiyalar Tab */}
      {activeTab === 'apellyasiya' && (
        <ApellyasiyaContainer>
          {(() => {
            // Filter apellyasiyas based on current filters
            let filteredApellyasiyas = [...allApellyasiyas];

            // Apply status filter
            if (apellyasiyaListFilter === 'pending') {
              filteredApellyasiyas = filteredApellyasiyas.filter(a => a.status === 'pending');
            } else if (apellyasiyaListFilter === 'completed') {
              filteredApellyasiyas = filteredApellyasiyas.filter(a => a.status === 'completed');
            }

            // Apply score change filter (only for completed apellyasiyas; pending has null scoreChange)
            const EPSILON = 0.001;
            if (apellyasiyaScoreFilter === 'increased') {
              filteredApellyasiyas = filteredApellyasiyas.filter(a =>
                a.status === 'completed' && a.scoreChange != null && a.scoreChange > EPSILON
              );
            } else if (apellyasiyaScoreFilter === 'decreased') {
              filteredApellyasiyas = filteredApellyasiyas.filter(a =>
                a.status === 'completed' && a.scoreChange != null && a.scoreChange < -EPSILON
              );
            } else if (apellyasiyaScoreFilter === 'unchanged') {
              filteredApellyasiyas = filteredApellyasiyas.filter(a =>
                a.status === 'completed' && a.scoreChange != null && Math.abs(a.scoreChange) <= EPSILON
              );
            }

            // Apply teacher filter
            if (apellyasiyaTeacherFilter !== 'all') {
              filteredApellyasiyas = filteredApellyasiyas.filter(a =>
                a.apellyasiyaHocaId === apellyasiyaTeacherFilter || a.originalHoca === apellyasiyaTeacherFilter
              );
            }

            // Sort alphabetically by student name
            filteredApellyasiyas.sort((a, b) => a.studentName.localeCompare(b.studentName, 'az', { sensitivity: 'base' }));

            // Qruplaşdır: şagirdə görə (bir şagirdin bir neçə apellyasiyası bir kartda)
            const byStudent = filteredApellyasiyas.reduce((acc, ap) => {
              const key = ap.studentId;
              if (!acc[key]) acc[key] = [];
              acc[key].push(ap);
              return acc;
            }, {} as Record<string, typeof filteredApellyasiyas>);
            const studentGroups = Object.entries(byStudent).map(([studentId, list]) => {
              const appeals = [...list];
              const createdTimes = appeals.map(a => getApellyasiyaCreatedAtTime(a.createdAt));
              appeals.sort((a, b) => getApellyasiyaCreatedAtTime(b.createdAt) - getApellyasiyaCreatedAtTime(a.createdAt)); // ən yeni üstə
              return {
                studentId,
                studentName: list[0]?.studentName ?? '',
                appeals,
                total: list.length,
                completed: list.filter(a => a.status === 'completed').length,
                pending: list.filter(a => a.status === 'pending').length,
                sortNewest: Math.max(0, ...createdTimes),
                sortOldest: createdTimes.length ? Math.min(...createdTimes.filter(t => t > 0), Infinity) || 0 : 0
              };
            });

            // Şagird kartı statusuna görə filter (kart bazlı)
            let filteredStudentGroups = studentGroups;
            if (apellyasiyaStudentCardFilter === 'all_completed') {
              filteredStudentGroups = studentGroups.filter(g => g.pending === 0);
            } else if (apellyasiyaStudentCardFilter === 'all_pending') {
              filteredStudentGroups = studentGroups.filter(g => g.completed === 0);
            } else if (apellyasiyaStudentCardFilter === 'partial') {
              filteredStudentGroups = studentGroups.filter(g => g.completed > 0 && g.pending > 0);
            }

            // Sıralama: ad və ya tarix
            if (apellyasiyaSortOrder === 'name_asc') {
              filteredStudentGroups = [...filteredStudentGroups].sort((a, b) => a.studentName.localeCompare(b.studentName, 'az', { sensitivity: 'base' }));
            } else if (apellyasiyaSortOrder === 'name_desc') {
              filteredStudentGroups = [...filteredStudentGroups].sort((a, b) => b.studentName.localeCompare(a.studentName, 'az', { sensitivity: 'base' }));
            } else if (apellyasiyaSortOrder === 'date_desc') {
              filteredStudentGroups = [...filteredStudentGroups].sort((a, b) => b.sortNewest - a.sortNewest);
            } else if (apellyasiyaSortOrder === 'date_asc') {
              filteredStudentGroups = [...filteredStudentGroups].sort((a, b) => (a.sortOldest || a.sortNewest) - (b.sortOldest || b.sortNewest));
            }

            return (
              <>
                <ApellyasiyaFilterBar>
                  <div>
                    <FilterLabel>Status</FilterLabel>
                    <ApellyasiyaFilterSelect
                      value={apellyasiyaListFilter}
                      onChange={(e) => setApellyasiyaListFilter(e.target.value as 'all' | 'pending' | 'completed')}
                    >
                      <option value="all">Hamısı</option>
                      <option value="pending">Gözləyir</option>
                      <option value="completed">Tamamlandı</option>
                    </ApellyasiyaFilterSelect>
                  </div>
                  <div>
                    <FilterLabel>Bal Dəyişikliyi</FilterLabel>
                    <ApellyasiyaFilterSelect
                      value={apellyasiyaScoreFilter}
                      onChange={(e) => setApellyasiyaScoreFilter(e.target.value as 'all' | 'increased' | 'decreased' | 'unchanged')}
                    >
                      <option value="all">Hamısı</option>
                      <option value="increased">Artıb ↑</option>
                      <option value="decreased">Azalıb ↓</option>
                      <option value="unchanged">Dəyişməyib →</option>
                    </ApellyasiyaFilterSelect>
                  </div>
                  <div>
                    <FilterLabel>Müəllim</FilterLabel>
                    <ApellyasiyaFilterSelect
                      value={apellyasiyaTeacherFilter}
                      onChange={(e) => setApellyasiyaTeacherFilter(e.target.value)}
                    >
                      <option value="all">Hamısı</option>
                      {[...new Set(allApellyasiyas.map(a => a.apellyasiyaHoca).filter(Boolean))].map(teacher => (
                        <option key={teacher} value={teacher}>{teacher}</option>
                      ))}
                    </ApellyasiyaFilterSelect>
                  </div>
                  <div>
                    <FilterLabel>Şagird kartı</FilterLabel>
                    <ApellyasiyaFilterSelect
                      value={apellyasiyaStudentCardFilter}
                      onChange={(e) => setApellyasiyaStudentCardFilter(e.target.value as 'all' | 'all_completed' | 'all_pending' | 'partial')}
                    >
                      <option value="all">Hamısı</option>
                      <option value="all_completed">Tamamen tamamlanan</option>
                      <option value="all_pending">Tamamen gözləyən</option>
                      <option value="partial">Qismən tamamlanan</option>
                    </ApellyasiyaFilterSelect>
                  </div>
                  <div>
                    <FilterLabel>Sıralama</FilterLabel>
                    <ApellyasiyaFilterSelect
                      value={apellyasiyaSortOrder}
                      onChange={(e) => setApellyasiyaSortOrder(e.target.value as 'name_asc' | 'name_desc' | 'date_desc' | 'date_asc')}
                    >
                      <option value="name_asc">Ad (A–Z)</option>
                      <option value="name_desc">Ad (Z–A)</option>
                      <option value="date_desc">Tarix (ən yeni)</option>
                      <option value="date_asc">Tarix (ən köhnə)</option>
                    </ApellyasiyaFilterSelect>
                  </div>
                </ApellyasiyaFilterBar>

                {apellyasiyaTeacherGroups.length > 0 && (
                  <ApellyasiyaWhatsAppSection>
                    <ApellyasiyaWhatsAppToggle
                      type="button"
                      onClick={() => setShowWhatsAppTeachersSection(s => !s)}
                      aria-expanded={showWhatsAppTeachersSection}
                    >
                      <span>Müəllimlərə WhatsApp mesajı</span>
                      <ApellyasiyaWhatsAppToggleIcon $open={showWhatsAppTeachersSection} aria-hidden>
                        ▼
                      </ApellyasiyaWhatsAppToggleIcon>
                    </ApellyasiyaWhatsAppToggle>
                    <ApellyasiyaWhatsAppContent $visible={showWhatsAppTeachersSection}>
                      <ApellyasiyaWhatsAppGrid>
                        {apellyasiyaTeacherGroups.map((group) => {
                          const teacher =
                            teachersList.find(t => t.id === group.teacherId) ||
                            teachersList.find(t => (t.name || '').trim() === (group.teacherName || '').trim());
                          const handleWhatsApp = () => {
                            if (!teacher) {
                              alert(`Müəllim tapılmadı (${group.teacherName}). Müəllimlər siyahısını yoxlayın.`);
                              return;
                            }
                            const phone = (teacher.phoneNumber || '').trim();
                            if (!phone) {
                              alert(`"${teacher.name}" üçün telefon nömrəsi qeyd edilməyib. Admin panelində Müəllimlər bölməsindən nömrə əlavə edin.`);
                              return;
                            }
                            const message = buildApellyasiyaWhatsAppMessage(group.teacherName, {
                              total: group.total,
                              completedCount: group.completedCount,
                              pendingCount: group.pendingCount,
                              fenns: group.fenns,
                              sinifs: group.sinifs
                            });
                            openWhatsAppWithMessage(phone, message);
                          };
                          const pct = group.total > 0 ? Math.round((group.completedCount / group.total) * 100) : 0;
                          return (
                            <ApellyasiyaWhatsAppRow key={group.teacherId}>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <span style={{ fontWeight: 600, marginRight: 8 }}>{group.teacherName}</span>
                                <ApellyasiyaWhatsAppStats>
                                  Ümumi: {group.total} · Yoxlanmış: {group.completedCount} · Qalmış: {group.pendingCount}
                                </ApellyasiyaWhatsAppStats>
                                <ApellyasiyaProgressBarWrap title={`${pct}% tamamlanıb`}>
                                  <ApellyasiyaProgressBarFill $pct={pct} />
                                </ApellyasiyaProgressBarWrap>
                                <ApellyasiyaWhatsAppStats style={{ marginTop: 4, display: 'block' }}>
                                  {pct}%
                                </ApellyasiyaWhatsAppStats>
                              </div>
                              <ApellyasiyaWhatsAppButton type="button" onClick={handleWhatsApp} title="WhatsApp">
                                <IconWhatsApp size={18} />
                              </ApellyasiyaWhatsAppButton>
                            </ApellyasiyaWhatsAppRow>
                          );
                        })}
                      </ApellyasiyaWhatsAppGrid>
                    </ApellyasiyaWhatsAppContent>
                  </ApellyasiyaWhatsAppSection>
                )}

                {filteredApellyasiyas.length === 0 ? (
                <NoData>
                    <div style={{ fontSize: '48px', marginBottom: '16px' }}><Icon name="assignments" size={48} style={{ marginRight: 0 }} /></div>
                    <div style={{ fontSize: '20px', fontWeight: '600', color: '#64748b' }}>
                      Apellyasiya tapılmadı
                    </div>
                  </NoData>
                ) : filteredStudentGroups.length === 0 ? (
                  <NoData>
                  <div style={{ fontSize: '32px', marginBottom: '12px' }}><Icon name="assignments" size={32} style={{ marginRight: 0 }} /></div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#64748b' }}>
                      Seçilən şagird kartı statusuna uyğun nəticə yoxdur
                    </div>
                  </NoData>
                ) : (
                  filteredStudentGroups.map((studentGroup) => (
                    <ApellyasiyaStudentCard key={studentGroup.studentId}>
                      <ApellyasiyaStudentCardHeader>
                        <div>
                          <ApellyasiyaStudentCardTitle>{studentGroup.studentName}</ApellyasiyaStudentCardTitle>
                          <ApellyasiyaStudentCardMeta>İş nömrəsi: {studentGroup.studentId}</ApellyasiyaStudentCardMeta>
                        </div>
                        <ApellyasiyaStudentCardStats>
                          <span>Ümumi: {studentGroup.total}</span>
                          <span style={{ color: '#10b981' }}>Tamamlanan: {studentGroup.completed}</span>
                          <span style={{ color: '#f59e0b' }}>Qalan: {studentGroup.pending}</span>
                        </ApellyasiyaStudentCardStats>
                      </ApellyasiyaStudentCardHeader>
                      <ApellyasiyaStudentCardBody>
                        <ApellyasiyaTable>
                          <ApellyasiyaTableHeader>
                            <div>Şagird</div>
                            <div>Sual</div>
                            <div>Fənn</div>
                            <div>Əvvəlki Bal</div>
                            <div>Yeni Bal</div>
                            <div>Dəyişiklik</div>
                            <div>Status</div>
                            <div>Təyin tarixi</div>
                            <div>Təyin edən müəllim</div>
                            <div>Təsdiqləmə tarixi</div>
                            <div title="WhatsApp"><IconWhatsApp size={16} style={{ margin: 0 }} /></div>
                          </ApellyasiyaTableHeader>
                          {studentGroup.appeals.map((ap) => {
                      const teacherGroup = apellyasiyaTeacherGroups.find(
                        g => g.teacherId === (ap.assignedHocaId || ap.apellyasiyaHocaId) || g.teacherName === (ap.assignedHocaName || ap.apellyasiyaHoca)
                      );
                      const teacherId = (ap.assignedHocaId || ap.apellyasiyaHocaId || '').trim();
                      const teacherName = (ap.assignedHocaName || ap.apellyasiyaHoca || '').trim();
                      const teacher =
                        (teacherId ? teachersList.find(t => t.id === teacherId) : null) ||
                        (teacherName ? teachersList.find(t => (t.name || '').trim() === teacherName) : null);
                      const displayAssignedTeacher = ap.assignedHocaName || (ap.assignedHocaId && teachersList.find(t => t.id === ap.assignedHocaId)?.name) || '—';
                      const handleRowWhatsApp = (e: React.MouseEvent) => {
                        e.stopPropagation();
                        if (!teacher) {
                          alert(`Müəllim tapılmadı (ID: ${ap.assignedHocaId || ap.apellyasiyaHocaId || '—'}, Ad: ${ap.assignedHocaName || ap.apellyasiyaHoca || '—'}). Müəllimlər siyahısını yoxlayın.`);
                          return;
                        }
                        const phone = (teacher.phoneNumber || '').trim();
                        if (!phone) {
                          alert(`"${teacher.name}" üçün telefon nömrəsi qeyd edilməyib. Admin panelində Müəllimlər bölməsindən nömrə əlavə edin.`);
                          return;
                        }
                        if (!teacherGroup) return;
                        const message = buildApellyasiyaWhatsAppMessage(teacherGroup.teacherName, {
                          total: teacherGroup.total,
                          completedCount: teacherGroup.completedCount,
                          pendingCount: teacherGroup.pendingCount,
                          fenns: teacherGroup.fenns,
                          sinifs: teacherGroup.sinifs
                        });
                        openWhatsAppWithMessage(phone, message);
                      };
                      const openStudentDetail = () => {
                        const student = students.find(s => s.student_id === ap.studentId || s.id === ap.studentId);
                        if (student) setSelectedStudent(student);
                      };
                      return (
                        <ApellyasiyaRow key={ap.id} $status={ap.status}>
                          <ApellyasiyaStudentCell onClick={openStudentDetail} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && openStudentDetail()}>
                            <div style={{ fontWeight: '600' }}>{ap.studentName}</div>
                            <div style={{ fontSize: '12px', color: '#64748b' }}>ID: {ap.studentId}</div>
                          </ApellyasiyaStudentCell>
                          <div>{ap.questionNumber}</div>
                          <div>{ap.fenn}</div>
                          <div>{ap.previousScore}</div>
                          <div>{ap.status === 'completed' && ap.newScore != null ? ap.newScore : '—'}</div>
                          <div>
                            {ap.status === 'completed' && ap.scoreChange != null ? (
                              <ScoreChangeIndicator $change={ap.scoreChange}>
                                {Math.abs(ap.scoreChange) <= 0.001 ? '→' : ap.scoreChange > 0 ? `+${ap.scoreChange}` : `${ap.scoreChange}`}
                              </ScoreChangeIndicator>
                            ) : (
                              <span style={{ color: '#94a3b8' }}>—</span>
                            )}
                          </div>
                          <div>
                            <StatusBadge $status={ap.status}>
                              {ap.status === 'completed' ? <><IconCheckCircle size={14} /> Tamamlandı</> : <><IconClock size={14} /> Gözləyir</>}
                            </StatusBadge>
                          </div>
                          <div style={{ fontSize: '12px', color: '#64748b', whiteSpace: 'nowrap' }}>
                            {formatApellyasiyaCreatedAt(ap.createdAt)}
                          </div>
                          <div style={{ fontSize: '13px', color: '#1e293b' }}>
                            {displayAssignedTeacher}
                          </div>
                          <div style={{ fontSize: '12px', color: '#64748b', whiteSpace: 'nowrap' }}>
                            {ap.status === 'completed' ? formatApellyasiyaCreatedAt(ap.completedAt) : '—'}
                          </div>
                          <div>
                            <ApellyasiyaWhatsAppButton type="button" onClick={handleRowWhatsApp} title="WhatsApp">
                              <IconWhatsApp size={18} />
                            </ApellyasiyaWhatsAppButton>
                          </div>
                        </ApellyasiyaRow>
                      );
                    })}
                          </ApellyasiyaTable>
                      </ApellyasiyaStudentCardBody>
                    </ApellyasiyaStudentCard>
                  ))
                )}
              </>
            );
          })()}
        </ApellyasiyaContainer>
      )}

      {/* Results Tab */}
      {activeTab === 'results' && (
        <>
          <FilterSection>
        <FilterGrid>
          <div>
            <FilterLabel>Sinif</FilterLabel>
            <FilterSelect value={filterSinif} onChange={(e) => setFilterSinif(e.target.value)}>
              <option value="">Hamısı</option>
              {SINIFLAR.map(sinif => (
                <option key={sinif} value={sinif}>{sinif}. Sinif</option>
              ))}
            </FilterSelect>
          </div>

          {isBuraxilis ? (
            <>
              <div>
                <FilterLabel>Variant</FilterLabel>
                <FilterSelect value={filterVariant} onChange={(e) => setFilterVariant(e.target.value)}>
                  <option value="">Hamısı</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                </FilterSelect>
              </div>

              <div>
                <FilterLabel>Xarici Dil</FilterLabel>
                <FilterSelect value={filterXdil} onChange={(e) => setFilterXdil(e.target.value)}>
                  <option value="">Hamısı</option>
                  <option value="İngilis dili">İngilis dili</option>
                  <option value="Rus dili">Rus dili</option>
                  <option value="Alman dili">Alman dili</option>
                  <option value="Fransız dili">Fransız dili</option>
                </FilterSelect>
              </div>

              <div>
                <FilterLabel>Müəllim (Q##_c üzrə)</FilterLabel>
                <FilterSelect value={filterTeacher} onChange={(e) => setFilterTeacher(e.target.value)}>
                  <option value="">Hamısı</option>
                  {availableTeachers.map(t => (
                    <option key={t.id} value={t.id}>
                      {t.name} ({t.id === 'admin' ? 'Admin' : t.id})
                    </option>
                  ))}
                </FilterSelect>
              </div>
            </>
          ) : (
            <>
              <div>
                <FilterLabel>Qrup</FilterLabel>
                <FilterSelect value={filterQrup} onChange={(e) => setFilterQrup(e.target.value)}>
                  <option value="">Hamısı</option>
                  {QRUPLAR.map(qrup => (
                    <option key={qrup} value={qrup}>Qrup {qrup}</option>
                  ))}
                </FilterSelect>
              </div>

              <div>
                <FilterLabel>SubGroup</FilterLabel>
                <FilterSelect value={filterSubGroup} onChange={(e) => setFilterSubGroup(e.target.value)}>
                  <option value="">Hamısı</option>
                  <option value="RK">RK (Riyazi-Kimya)</option>
                  <option value="RI">RI (Riyazi-İnformatika)</option>
                  <option value="DT">DT (Dil-Tarix)</option>
                  <option value="TC">TC (Tarix-Coğrafiya)</option>
                </FilterSelect>
              </div>
            </>
          )}

          <div>
            <FilterLabel>Vəziyyət</FilterLabel>
            <FilterSelect value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
              <option value="">Hamısı</option>
              <option value="tamamlandi">Tamamlandı (3/3)</option>
              <option value="kismi">Qismən Yoxlanmış</option>
              <option value="yoklanmamis">Yoxlanmamış (0/3)</option>
            </FilterSelect>
          </div>

          <div>
            <FilterLabel>Axtar (Ad, Soyad, ID)</FilterLabel>
            <FilterInput 
              type="text"
              placeholder="Axtarış..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Button onClick={clearFilters} style={{ width: '100%' }}>
              <><Icon name="refresh" size={16} style={{ marginRight: 8 }} /> Filtrləri Təmizlə</>
            </Button>
          </div>
        </FilterGrid>

        <StatsBarMain>
          <StatItemMain>
            <StatLabel>Ümumi Şagird</StatLabel>
            <StatValue>{totalStudents}</StatValue>
          </StatItemMain>
          <StatItemMain>
            <StatLabel>Tamamlandı (3/3)</StatLabel>
            <StatValue style={{ color: '#10b981' }}>{tamamlandiStudents}</StatValue>
          </StatItemMain>
          <StatItemMain>
            <StatLabel>Qismən Yoxlanmış</StatLabel>
            <StatValue style={{ color: '#f59e0b' }}>{kismiStudents}</StatValue>
          </StatItemMain>
          <StatItemMain>
            <StatLabel>Yoxlanmamış (0/3)</StatLabel>
            <StatValue style={{ color: '#ef4444' }}>{yoklanmamisStudents}</StatValue>
          </StatItemMain>
          <StatItemMain>
            <StatLabel>Tamamlanma Nisbəti</StatLabel>
            <StatValue style={{ color: '#3b82f6' }}>
              {totalStudents > 0 ? Math.round((tamamlandiStudents / totalStudents) * 100) : 0}%
            </StatValue>
          </StatItemMain>
        </StatsBarMain>
      </FilterSection>

      <StudentTable>
        {filteredStudents.length === 0 ? (
          <NoData>
            {students.length === 0 
              ? 'Sistemdə hələ şagird məlumatı yoxdur' 
              : 'Filtrlərə uyğun şagird tapılmadı'}
          </NoData>
        ) : (
          <Table>
            <Thead>
              <Tr>
                <Th>Şagird ID</Th>
                <Th>Ad Soyad</Th>
                <Th>Sinif</Th>
                {isBuraxilis ? (
                  <>
                    <Th>Variant</Th>
                    <Th>Xarici Dil</Th>
                    <Th>Yoxlanmış Sual</Th>
                  </>
                ) : (
                  <>
                    <Th>Qrup</Th>
                    <Th>SubGroup</Th>
                    <Th>Yoxlanmış Fənn</Th>
                    <Th>Yoxlanmış Sual</Th>
                  </>
                )}
                <Th>Vəziyyət</Th>
                <Th>Əməliyyat</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredStudents.map(student => {
                let gradedQuestionCount = 0;
                let totalQuestionCount = 0;

                // Calculate question statistics for both Buraxılış and Blok
                if (!isBuraxilis && student.specialtyGroup) {
                  // BLOK mode: count Q##_c graded questions using actual assigned questions
                  const mode = detectBlokMode(student);
                  const actualQuestions = getActualBlokQuestions(student);

                  totalQuestionCount = actualQuestions.length;

                  actualQuestions.forEach(questionNum => {
                    const qField = `${questionNum}_c`;
                    const qValue = (student as any)[qField];
                    if (qValue && typeof qValue === 'object' && qValue.hocaId) {
                      gradedQuestionCount++;
                    }
                  });
                } else if (isBuraxilis && student.grade) {
                  // Buraxılış mode: count from effective questions (xdil-filtered)
                  const gradeNum = typeof student.grade === 'number' ? student.grade : parseInt(student.grade as string);
                  const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, student.xdil, buraxilisBlankCtx(selectedExam, student));
                  if (gradeQuestions && gradeQuestions.length > 0) {
                    totalQuestionCount = gradeQuestions.reduce((sum: number, subject: { subject: string; questions: string[] }) => sum + subject.questions.length, 0);
                    gradeQuestions.forEach((subject: { subject: string; questions: string[] }) => {
                      subject.questions.forEach((q: string) => {
                        const qField = `${q}_c`;
                        const qValue = (student as any)[qField];
                        if (qValue && typeof qValue === 'object' && (qValue.hocaId || qValue.apellyasiya_status === true)) {
                          gradedQuestionCount++;
                        }
                      });
                    });
                  }
                }

                const displayCompletedCount = (student.specialtyGroup || isBuraxilis) ? gradedQuestionCount : (student.completedFennCount || 0);
                const displayTotalCount = (student.specialtyGroup || isBuraxilis) ? totalQuestionCount : (student.totalFennCount || 0);

                return (
                  <Tr key={student.id} clickable>
                    <Td>{student.student_id}</Td>
                    <Td>{student.firstName} {student.lastName}</Td>
                    <Td>{student.grade}. Sinif</Td>
                    {isBuraxilis ? (
                      <>
                        <Td>
                          {student.variant ? (
                            <Badge color="linear-gradient(135deg, #3b82f6, #2563eb)">
                              {student.variant}
                            </Badge>
                          ) : (
                            <span style={{ color: '#94a3b8' }}>-</span>
                          )}
                        </Td>
                        <Td>
                          {student.xdil ? (
                            <Badge color="linear-gradient(135deg, #8b5cf6, #7c3aed)">
                              {normalizeXdil(student.xdil)}
                            </Badge>
                          ) : (
                            <span style={{ color: '#94a3b8' }}>-</span>
                          )}
                        </Td>
                      </>
                    ) : (
                      <>
                        <Td>Qrup {student.specialtyGroup}</Td>
                        <Td>
                          {student.subGroup ? (
                            <Badge color="linear-gradient(135deg, #8b5cf6, #7c3aed)">
                              {student.subGroup}
                            </Badge>
                          ) : (
                            <span style={{ color: '#94a3b8' }}>-</span>
                          )}
                        </Td>
                      </>
                    )}
                    <Td>
                      {displayCompletedCount} / {displayTotalCount}
                    </Td>
                    <Td>
                      {gradedQuestionCount} / {totalQuestionCount}
                    </Td>
                    <Td>
                      {displayCompletedCount === displayTotalCount && displayCompletedCount > 0 ? (
                        <Badge color="linear-gradient(135deg, #10b981, #059669)">
                          Tamamlandı
                        </Badge>
                      ) : displayCompletedCount > 0 ? (
                        <Badge color="linear-gradient(135deg, #f59e0b, #d97706)">
                          Qismən ({displayCompletedCount}/{displayTotalCount})
                        </Badge>
                      ) : (
                        <Badge color="linear-gradient(135deg, #ef4444, #dc2626)">
                          Yoxlanmamış
                        </Badge>
                      )}
                    </Td>
                    <Td>
                      <Button 
                        onClick={() => setSelectedStudent(student)}
                        style={{ padding: '6px 16px', fontSize: '13px' }}
                      >
                        Ətraflı
                      </Button>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        )}
      </StudentTable>
        </>
      )}

      {/* Success Toast */}
      <SuccessToast show={showSuccessToast}>
        <IconCheckCircle size={18} color="#10b981" style={{ marginRight: 8, flexShrink: 0 }} /> {successMessage}
      </SuccessToast>

      {/* Content query bildirimi: yalnız content=Suallar:... Şikayət:... varsa, sağ üstdə hafif notification */}
      {contentNoteData && !contentNoteDismissed && (
        <ContentNoteWrap minimized={contentNoteMinimized}>
          <ContentNoteCard minimized={contentNoteMinimized}>
            {contentNoteMinimized ? (
              <ContentNoteBtn
                round
                onClick={() => setContentNoteMinimized(false)}
                title="Məlumatı aç"
              >
                <InfoIconSvg size={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <circle cx="12" cy="9" r="1.25" fill="currentColor" stroke="none" />
                  <line x1="12" y1="13" x2="12" y2="17" />
                </InfoIconSvg>
              </ContentNoteBtn>
            ) : (
              <>
                <ContentNoteHeader>
                  <ContentNoteTitle>
                    <InfoIconSvg size={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <circle cx="12" cy="9" r="1.25" fill="currentColor" stroke="none" />
                      <line x1="12" y1="13" x2="12" y2="17" />
                    </InfoIconSvg>
                    Məlumat
                  </ContentNoteTitle>
                  <ContentNoteActions>
                    <ContentNoteBtn
                      onClick={() => setContentNoteMinimized(true)}
                      title="Kiçilt"
                    >
                      −
                    </ContentNoteBtn>
                     <ContentNoteBtn
                       onClick={() => setContentNoteDismissed(true)}
                       title="Bağla"
                     >
                       <IconX size={14} />
                     </ContentNoteBtn>
                  </ContentNoteActions>
                </ContentNoteHeader>
                <ContentNoteBody>
                  <ContentNoteSection>
                    <ContentNoteSectionLabel>Suallar</ContentNoteSectionLabel>
                    <ContentNoteSectionText>{contentNoteData.suallar}</ContentNoteSectionText>
                  </ContentNoteSection>
                  <ContentNoteSection>
                    <ContentNoteSectionLabel>Şikayət</ContentNoteSectionLabel>
                    <ContentNoteSectionText>{contentNoteData.sikayet}</ContentNoteSectionText>
                  </ContentNoteSection>
                </ContentNoteBody>
              </>
            )}
          </ContentNoteCard>
        </ContentNoteWrap>
      )}

      {/* Image Viewer Modal */}
      <ImageModal show={!!viewingImage} onClick={() => setViewingImage(null)}>
        <ImageModalContent onClick={(e) => e.stopPropagation()}>
          {viewingImage && selectedStudent && (() => {
            // Tam səhifə şəkilləri: Ön üz (1_path), Arxa üz (2_path)
            const path1 = (selectedStudent as any)['1_path'];
            const path2 = (selectedStudent as any)['2_path'];
            if (viewingImage.fenn === 'Ön üz' && path1) {
              return (
                <>
                  <ModalHeader>
                    <ModalTitle>
                      Ön üz — {selectedStudent.firstName} {selectedStudent.lastName}
                    </ModalTitle>
                    <CloseButton onClick={() => setViewingImage(null)} aria-label="Bağla"><IconX size={18} /></CloseButton>
                  </ModalHeader>
                  <ImageViewContainer ref={imageContainerRef}>
                    {imageLoading && (
                      <ImageLoadingContainer>
                        <ImageLoadingSpinner />
                        <div>Şəkil yüklənir...</div>
                      </ImageLoadingContainer>
                    )}
                    <ImageViewImg
                      key={`${viewingImage.studentId}-onuz`}
                      src={path1}
                      alt={`Ön üz - ${selectedStudent.firstName}`}
                      onLoad={() => {
                        setImageLoading(false);
                        if (imageContainerRef.current) imageContainerRef.current.scrollTop = 0;
                      }}
                      onError={() => {
                        setImageLoading(false);
                        console.error('Şəkil yüklənmədi:', path1);
                      }}
                      style={{ display: imageLoading ? 'none' : 'block' }}
                    />
                  </ImageViewContainer>
                </>
              );
            }
            if (viewingImage.fenn === 'Arxa üz' && path2) {
              return (
                <>
                  <ModalHeader>
                    <ModalTitle>
                      Arxa üz — {selectedStudent.firstName} {selectedStudent.lastName}
                    </ModalTitle>
                    <CloseButton onClick={() => setViewingImage(null)} aria-label="Bağla"><IconX size={18} /></CloseButton>
                  </ModalHeader>
                  <ImageViewContainer ref={imageContainerRef}>
                    {imageLoading && (
                      <ImageLoadingContainer>
                        <ImageLoadingSpinner />
                        <div>Şəkil yüklənir...</div>
                      </ImageLoadingContainer>
                    )}
                    <ImageViewImg
                      key={`${viewingImage.studentId}-arzauz`}
                      src={path2}
                      alt={`Arxa üz - ${selectedStudent.firstName}`}
                      onLoad={() => {
                        setImageLoading(false);
                        if (imageContainerRef.current) imageContainerRef.current.scrollTop = 0;
                      }}
                      onError={() => {
                        setImageLoading(false);
                        console.error('Şəkil yüklənmədi:', path2);
                      }}
                      style={{ display: imageLoading ? 'none' : 'block' }}
                    />
                  </ImageViewContainer>
                </>
              );
            }
            if ((viewingImage.fenn === 'Ön üz' && !path1) || (viewingImage.fenn === 'Arxa üz' && !path2)) {
              return (
                <>
                  <ModalHeader>
                    <ModalTitle>{viewingImage.fenn}</ModalTitle>
                    <CloseButton onClick={() => setViewingImage(null)} aria-label="Bağla"><IconX size={18} /></CloseButton>
                  </ModalHeader>
                  <div style={{ padding: '40px', textAlign: 'center', color: '#ef4444' }}>
                    Bu şagird üçün {viewingImage.fenn} şəkli tapılmadı
                  </div>
                </>
              );
            }
            // Əgər viewingImage.fenn "Xarici dil - Q78" kimi bir başlıqdırsa və bu, tək sual görüntüsüdür
            const isSingleQuestionView = viewingImage.fenn.includes(' - Q');
            if (isSingleQuestionView) {
              const qMatch = viewingImage.fenn.match(/Q\d+/);
              const qNum = qMatch ? qMatch[0] : '';
              const qData = (selectedStudent as any)[qNum];
              const qPath = qData && typeof qData === 'object' ? qData.path : '';

              if (!qPath) {
                return (
                  <>
                    <ModalHeader>
                      <ModalTitle>Şəkil tapılmadı</ModalTitle>
                      <CloseButton onClick={() => setViewingImage(null)} aria-label="Bağla"><IconX size={18} /></CloseButton>
                    </ModalHeader>
                    <div style={{ padding: '40px', textAlign: 'center', color: '#ef4444' }}>
                      Bu sual üçün şəkil tapılmadı
                    </div>
                  </>
                );
              }

              return (
                <>
                  <ModalHeader>
                    <ModalTitle>
                      {viewingImage.fenn} - {selectedStudent.firstName} {selectedStudent.lastName}
                    </ModalTitle>
                      <CloseButton onClick={() => setViewingImage(null)} aria-label="Bağla"><IconX size={18} /></CloseButton>
                  </ModalHeader>
                  <ImageViewContainer ref={imageContainerRef}>
                    {imageLoading && (
                      <ImageLoadingContainer>
                        <ImageLoadingSpinner />
                        <div>Şəkil yüklənir...</div>
                      </ImageLoadingContainer>
                    )}
                    <ImageViewImg
                      key={`${viewingImage.studentId}-${viewingImage.fenn}`}
                      src={qPath}
                      alt={`${viewingImage.fenn} - ${selectedStudent.firstName}`}
                      onLoad={() => {
                        setImageLoading(false);
                        if (imageContainerRef.current) {
                          imageContainerRef.current.scrollTop = 0;
                        }
                      }}
                      onError={() => {
                        setImageLoading(false);
                        console.error('Şəkil yüklənmədi:', qPath);
                      }}
                      style={{ display: imageLoading ? 'none' : 'block' }}
                    />
                  </ImageViewContainer>
                </>
              );
            }

            const imageArea = getImageAreaForFenn(viewingImage.fenn, selectedStudent.specialtyGroup);
            
            if (!imageArea) {
              return (
                <>
                  <ModalHeader>
                    <ModalTitle>Xəta</ModalTitle>
                    <CloseButton onClick={() => setViewingImage(null)} aria-label="Bağla"><IconX size={18} /></CloseButton>
                  </ModalHeader>
                  <div style={{ padding: '20px', textAlign: 'center', color: '#ef4444' }}>
                    Şəkil məlumatı tapılmadı
                  </div>
                </>
              );
            }
            
            if (!imageArea.imageUrl) {
              return (
                <>
                  <ModalHeader>
                    <ModalTitle>
                      {viewingImage.fenn} - {selectedStudent.firstName} {selectedStudent.lastName}
                    </ModalTitle>
                    <CloseButton onClick={() => setViewingImage(null)} aria-label="Bağla"><IconX size={18} /></CloseButton>
                  </ModalHeader>
                  <div style={{ padding: '40px', textAlign: 'center', color: '#ef4444' }}>
                    <div style={{ fontSize: '48px', marginBottom: '16px' }}><Icon name="photo" size={48} style={{ marginRight: 0 }} /></div>
                    <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>
                      Şəkil Tapılmadı
                    </div>
                    <div style={{ color: '#64748b', fontSize: '14px' }}>
                      Bu şagird üçün {viewingImage.fenn} şəkli yüklənməyib
                    </div>
                  </div>
                </>
              );
            }
            
            return (
              <>
                <ModalHeader>
                  <ModalTitle>
                    {viewingImage.fenn} - {selectedStudent.firstName} {selectedStudent.lastName}
                  </ModalTitle>
                  <CloseButton onClick={() => setViewingImage(null)} aria-label="Bağla"><IconX size={18} /></CloseButton>
                </ModalHeader>
                  <QuestionRangeInfo>
                   <Icon name="assignments" size={16} style={{ marginRight: 8 }} /> Suallar: {imageArea.end - 2} - {imageArea.end}
                 </QuestionRangeInfo>
                <ImageViewContainer ref={imageContainerRef}>
                  {imageLoading && (
                    <ImageLoadingContainer>
                      <ImageLoadingSpinner />
                      <div>Şəkil yüklənir...</div>
                    </ImageLoadingContainer>
                  )}
                  <ImageViewImg
                    key={`${viewingImage.studentId}-${viewingImage.fenn}`}
                    src={imageArea.imageUrl}
                    alt={`${viewingImage.fenn} - ${selectedStudent.firstName}`}
                    onLoad={() => {
                      setImageLoading(false);
                      // Resim yüklendikten sonra scroll'u en üste al
                      if (imageContainerRef.current) {
                        imageContainerRef.current.scrollTop = 0;
                      }
                    }}
                    onError={(e) => {
                      setImageLoading(false);
                      console.error('Şəkil yüklənmədi:', imageArea.imageUrl);
                    }}
                    style={{ display: imageLoading ? 'none' : 'block' }}
                  />
                </ImageViewContainer>
              </>
            );
          })()}
        </ImageModalContent>
      </ImageModal>

      {/* Apellyasiya Modal */}
      <ConfirmDialog show={showApellyasiyaModal} onClick={() => !apellyasiyaLoading && setShowApellyasiyaModal(false)}>
        <ConfirmDialogContent onClick={(e) => e.stopPropagation()}>
          <ConfirmDialogTitle>Apellyasiya Təyin Et</ConfirmDialogTitle>
          {selectedStudent && apellyasiyaQuestionNum && (() => {
            const gradingData = (selectedStudent as any)[`${apellyasiyaQuestionNum}_c`];
            const previousGrading = gradingData || {};
            const previousDate = previousGrading.timestamp 
              ? new Date(previousGrading.timestamp.toDate ? previousGrading.timestamp.toDate() : previousGrading.timestamp)
              : null;
            
            return (
              <>
                <ConfirmDialogText>
                  <div style={{ marginBottom: '16px' }}>
                    <strong>Sual:</strong> {apellyasiyaQuestionNum}
                  </div>
                  
                  {previousGrading.hoca && (
                    <div style={{ 
                      background: '#f8fafc', 
                      padding: '12px', 
                      borderRadius: '8px', 
                      marginBottom: '16px' 
                    }}>
                      <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '8px', color: '#475569' }}>
                        Əvvəlki Yoxlama Məlumatları:
                      </div>
                      <div style={{ fontSize: '13px', color: '#64748b', lineHeight: '1.8' }}>
                        <div><strong>Müəllim:</strong> {previousGrading.hoca} ({previousGrading.hocaId})</div>
                        {previousDate && (
                          <div>
                            <strong>Tarix:</strong> {previousDate.toLocaleDateString('az-AZ')} 
                            <span style={{ marginLeft: '8px' }}>
                              <strong>Saat:</strong> {previousDate.toLocaleTimeString('az-AZ', { hour: '2-digit', minute: '2-digit' })}
                            </span>
                          </div>
                        )}
                        <div><strong>Bal:</strong> {previousGrading.score || '0'}</div>
                        {previousGrading.note && (
                          <div><strong>Qeyd:</strong> {previousGrading.note}</div>
                        )}
                      </div>
                    </div>
                  )}

                  <div style={{ marginBottom: '12px' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>
                      Apellyasiya Səbəbi: *
                    </label>
                    <textarea
                      value={apellyasiyaReason}
                      onChange={(e) => setApellyasiyaReason(e.target.value)}
                      placeholder="Apellyasiya səbəbini yazın..."
                      style={{
                        width: '100%',
                        minHeight: '100px',
                        padding: '10px',
                        border: '2px solid #e2e8f0',
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontFamily: 'inherit',
                        resize: 'vertical'
                      }}
                      disabled={apellyasiyaLoading}
                    />
                  </div>

                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>
                      Apellyasiyanı Yoxlayacaq Müəllim: *
                    </label>
                    {apellyasiyaLoading ? (
                      <div style={{ padding: '12px', textAlign: 'center', color: '#64748b' }}>
                        Müəllimlər yüklənir...
                      </div>
                    ) : (
                      <select
                        value={apellyasiyaSelectedTeacher}
                        onChange={(e) => setApellyasiyaSelectedTeacher(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '10px',
                          border: '2px solid #e2e8f0',
                          borderRadius: '8px',
                          fontSize: '14px',
                          background: 'white',
                          cursor: 'pointer'
                        }}
                        disabled={apellyasiyaLoading}
                      >
                        {apellyasiyaTeachers.map(teacher => (
                          <option key={teacher.id} value={teacher.id}>
                            {teacher.name} {teacher.id === previousGrading.hocaId ? '(Yoxlayan müəllim)' : ''}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </ConfirmDialogText>
                <ConfirmDialogButtons>
                  <ConfirmButton 
                    variant="cancel" 
                    onClick={() => setShowApellyasiyaModal(false)}
                    disabled={apellyasiyaLoading}
                  >
                    Ləğv et
                  </ConfirmButton>
                  <ConfirmButton 
                    variant="danger" 
                    onClick={handleCreateApellyasiya}
                    disabled={apellyasiyaLoading || !apellyasiyaReason.trim() || !apellyasiyaSelectedTeacher}
                  >
                    {apellyasiyaLoading ? 'İşlənir...' : 'Apellyasiya Təyin Et'}
                  </ConfirmButton>
                </ConfirmDialogButtons>
              </>
            );
          })()}
        </ConfirmDialogContent>
      </ConfirmDialog>

      {/* Batch Apellyasiya Modal */}
      <ConfirmDialog show={showBatchApellyasiyaModal} onClick={() => !batchApellyasiyaLoading && setShowBatchApellyasiyaModal(false)}>
        <BatchModalContent onClick={(e) => e.stopPropagation()}>
          <ConfirmDialogTitle>
            <><Icon name="assignments" size={16} style={{ marginRight: 8 }} /> Toplu Apellyasiya Təyin Et</>
            {batchModalStep === 'select' && ' - Sual Seçimi'}
            {batchModalStep === 'assign' && ' - Müəllim və Səbəb'}
          </ConfirmDialogTitle>
          {selectedStudent && (
            <>
              {batchModalStep === 'select' && (
                <>
                  <ConfirmDialogText>
                    <div style={{ marginBottom: '16px' }}>
                      <strong>Yoklanmış Sualları Seçin:</strong>
                      <span style={{ fontSize: '13px', color: '#64748b', marginLeft: '8px' }}>
                        ({modalSelectedQuestions.size} seçildi)
                      </span>
                    </div>
                    <div style={{ 
                      display: 'flex', 
                      flexWrap: 'wrap', 
                      gap: '12px',
                      padding: '16px',
                      background: '#f8fafc',
                      borderRadius: '10px',
                      maxHeight: '500px',
                      overflowY: 'auto',
                      border: '2px solid #e2e8f0'
                    }}>
                      {getAvailableQuestionsForAppeal(selectedStudent).map(questionNum => {
                        const isSelected = modalSelectedQuestions.has(questionNum);
                        const gradingData = (selectedStudent as any)[`${questionNum}_c`];
                        
                        // Fenn adını al
                        let fennName = '';
                        if (isBuraxilis) {
                          const gradeNum = typeof selectedStudent.grade === 'number' ? selectedStudent.grade : parseInt(selectedStudent.grade as string);
                          const subject = getFennFromQuestionNumber(questionNum, gradeNum, buraxilisBlankCtx(selectedExam));
                          if (subject) {
                            fennName = subject === 'Xarici dil'
                              ? normalizeXdil(selectedStudent.xdil) || 'İngilis dili'
                              : subject;
                          }
                        } else {
                          const qrup = selectedStudent.specialtyGroup;
                          const subGroup = selectedStudent.subGroup;
                          fennName = getFennFromQuestionNumberForBlok(questionNum, qrup, subGroup) || '';
                        }

                        return (
                          <label
                            key={questionNum}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '12px 16px',
                              background: isSelected ? '#eff6ff' : 'white',
                              border: isSelected ? '2px solid #3b82f6' : '2px solid #e2e8f0',
                              borderRadius: '8px',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              minWidth: '120px',
                              userSelect: 'none'
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={() => handleModalQuestionToggle(questionNum)}
                              style={{
                                width: '18px',
                                height: '18px',
                                marginRight: '10px',
                                cursor: 'pointer',
                                accentColor: '#3b82f6'
                              }}
                            />
                            <div>
                              <div style={{ fontWeight: '600', fontSize: '14px', color: '#1e293b' }}>
                                {questionNum}
                              </div>
                              {fennName && (
                                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>
                                  {fennName}
                                </div>
                              )}
                              {gradingData?.score && (
                                <div style={{ fontSize: '11px', color: '#10b981', marginTop: '2px' }}>
                                  Bal: {gradingData.score}
                                </div>
                              )}
                            </div>
                          </label>
                        );
                      })}
                    </div>
                    {getAvailableQuestionsForAppeal(selectedStudent).length === 0 && (
                      <div style={{ padding: '20px', textAlign: 'center', color: '#64748b' }}>
                        Apellyasiya üçün mövcud sual yoxdur. Bütün suallar ya apellyasiyada, ya da hələ yoxlanılmayıb.
                      </div>
                    )}
                  </ConfirmDialogText>
                  <ConfirmDialogButtons>
                    <ConfirmButton 
                      variant="cancel" 
                      onClick={() => {
                        setShowBatchApellyasiyaModal(false);
                        setModalSelectedQuestions(new Set());
                        setBatchModalStep('select');
                      }}
                      disabled={batchApellyasiyaLoading}
                    >
                      Ləğv et
                    </ConfirmButton>
                    <ConfirmButton 
                      variant="danger" 
                      onClick={handleNextToAssignStep}
                      disabled={batchApellyasiyaLoading || modalSelectedQuestions.size === 0}
                    >
                      {batchApellyasiyaLoading ? 'Yüklənir...' : 'Növbəti →'}
                    </ConfirmButton>
                  </ConfirmDialogButtons>
                </>
              )}

              {batchModalStep === 'assign' && selectedQuestionsForAppeal.size > 0 && (
                <>
                  <ConfirmDialogText>
                    <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <strong>Seçilmiş Suallar ({selectedQuestionsForAppeal.size}):</strong>
                      <Button
                        onClick={() => setBatchModalStep('select')}
                        style={{
                          padding: '6px 12px',
                          fontSize: '12px',
                          background: '#e5e7eb',
                          color: '#374151'
                        }}
                      >
                        ← Geri
                      </Button>
                    </div>
                    <SelectedQuestionsList>
                      {Array.from(selectedQuestionsForAppeal).map(qNum => (
                        <SelectedQuestionTag key={qNum}>{qNum}</SelectedQuestionTag>
                      ))}
                    </SelectedQuestionsList>

                    <div style={{ marginBottom: '20px' }}>
                      <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>
                        Apellyasiya Səbəbi (Hamısı üçün): *
                      </label>
                      <textarea
                        value={batchApellyasiyaReason}
                        onChange={(e) => setBatchApellyasiyaReason(e.target.value)}
                        placeholder="Apellyasiya səbəbini yazın (bütün seçilmiş suallar üçün eyni səbəb tətbiq olunacaq)..."
                        style={{
                          width: '100%',
                          minHeight: '100px',
                          padding: '10px',
                          border: '2px solid #e2e8f0',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontFamily: 'inherit',
                          resize: 'vertical'
                        }}
                        disabled={batchApellyasiyaLoading}
                      />
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                      <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#475569', marginBottom: '12px' }}>
                        Hər Sual Üçün Müəllim Seçin: *
                      </label>
                      {batchApellyasiyaLoading ? (
                        <div style={{ padding: '12px', textAlign: 'center', color: '#64748b' }}>
                          Müəllimlər yüklənir...
                        </div>
                      ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxHeight: '400px', overflowY: 'auto' }}>
                          {Array.from(selectedQuestionsForAppeal).map(questionNum => {
                            const gradingData = (selectedStudent as any)[`${questionNum}_c`];
                            const teachersList = batchQuestionTeachersList.get(questionNum) || [];
                            const selectedTeacherId = batchQuestionTeachers.get(questionNum) || '';

                            // Fenn adını al
                            let fennName = '';
                            if (isBuraxilis) {
                              const gradeNum = typeof selectedStudent.grade === 'number' ? selectedStudent.grade : parseInt(selectedStudent.grade as string);
                              const subject = getFennFromQuestionNumber(questionNum, gradeNum, buraxilisBlankCtx(selectedExam));
                              if (subject) {
                                fennName = subject === 'Xarici dil'
                                  ? normalizeXdil(selectedStudent.xdil) || 'İngilis dili'
                                  : subject;
                              }
                            } else {
                              const qrup = selectedStudent.specialtyGroup;
                              const subGroup = selectedStudent.subGroup;
                              fennName = getFennFromQuestionNumberForBlok(questionNum, qrup, subGroup) || '';
                            }

                            return (
                              <div 
                                key={questionNum} 
                                style={{ 
                                  padding: '12px', 
                                  background: '#f8fafc', 
                                  borderRadius: '8px',
                                  border: '1px solid #e2e8f0'
                                }}
                              >
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                  <div>
                                    <strong style={{ fontSize: '14px', color: '#1e293b' }}>{questionNum}</strong>
                                    {fennName && (
                                      <span style={{ fontSize: '12px', color: '#64748b', marginLeft: '8px' }}>
                                        ({fennName})
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <select
                                  value={selectedTeacherId}
                                  onChange={(e) => {
                                    const newMap = new Map(batchQuestionTeachers);
                                    newMap.set(questionNum, e.target.value);
                                    setBatchQuestionTeachers(newMap);
                                  }}
                                  style={{
                                    width: '100%',
                                    padding: '8px',
                                    border: '2px solid #e2e8f0',
                                    borderRadius: '6px',
                                    fontSize: '13px',
                                    background: 'white',
                                    cursor: 'pointer'
                                  }}
                                  disabled={batchApellyasiyaLoading}
                                >
                                  <option value="">Müəllim seçin...</option>
                                  {teachersList.map(teacher => (
                                    <option key={teacher.id} value={teacher.id}>
                                      {teacher.name} {teacher.id === gradingData?.hocaId ? '(Yoxlayan müəllim)' : ''}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </ConfirmDialogText>
                  <ConfirmDialogButtons>
                    <ConfirmButton 
                      variant="cancel" 
                      onClick={() => {
                        setShowBatchApellyasiyaModal(false);
                        setBatchApellyasiyaReason('');
                        setBatchQuestionTeachers(new Map());
                        setBatchQuestionTeachersList(new Map());
                        setBatchModalStep('select');
                        setModalSelectedQuestions(new Set());
                      }}
                      disabled={batchApellyasiyaLoading}
                    >
                      Ləğv et
                    </ConfirmButton>
                    <ConfirmButton 
                      variant="danger" 
                      onClick={handleBatchCreateApellyasiya}
                      disabled={batchApellyasiyaLoading || !batchApellyasiyaReason.trim() || Array.from(selectedQuestionsForAppeal).some(q => !batchQuestionTeachers.get(q))}
                    >
                      {batchApellyasiyaLoading ? 'İşlənir...' : `${selectedQuestionsForAppeal.size} Apellyasiya Təyin Et`}
                    </ConfirmButton>
                  </ConfirmDialogButtons>
                </>
              )}
            </>
          )}
        </BatchModalContent>
      </ConfirmDialog>

      {/* Confirmation Dialog */}
      <ConfirmDialog show={!!confirmZeroFenn} onClick={() => setConfirmZeroFenn(null)}>
        <ConfirmDialogContent onClick={(e) => e.stopPropagation()}>
          <ConfirmDialogTitle>Boş Kağız Təsdiqi</ConfirmDialogTitle>
          <ConfirmDialogText>
            <strong>{confirmZeroFenn}</strong> fənni üçün <strong>boş kağız</strong> işarəsi qoyacaqsınız. 
            Bu əməliyyat bütün sualları <strong>0 bal</strong> olaraq işarələyəcək və müəllim məlumatını 
            <strong> "Admin"</strong> olaraq qeyd edəcək.
            <br /><br />
            Bu əməliyyatı təsdiq edirsiniz?
          </ConfirmDialogText>
          <ConfirmDialogButtons>
            <ConfirmButton 
              variant="cancel" 
              onClick={() => setConfirmZeroFenn(null)}
              disabled={isSettingZero}
            >
              Ləğv et
            </ConfirmButton>
            <ConfirmButton 
              variant="danger" 
              onClick={handleSetFennToZero}
              disabled={isSettingZero}
            >
              {isSettingZero ? 'İşlənir...' : 'Bəli, Boş Kağız İşarələ'}
            </ConfirmButton>
          </ConfirmDialogButtons>
        </ConfirmDialogContent>
      </ConfirmDialog>

      {/* Student Detail Modal */}
      <StudentDetailModal show={!!selectedStudent} onClick={() => setSelectedStudent(null)}>
        <ModalContent onClick={(e) => e.stopPropagation()}>
          {selectedStudent && (
            <>
              <ModalHeader>
                <ModalTitle>
                  {selectedStudent.firstName} {selectedStudent.lastName}
                </ModalTitle>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  {(() => {
                    // En az 1 apellyasiyası nəticələnmiş mi kontrol et
                    if (isBuraxilis && selectedStudent.grade) {
                      const results = collectApellyasiyaResults(selectedStudent);
                      if (results.length > 0) {
                        return (
                          <>
                    <Button
                      onClick={copyApellyasiyaToClipboard}
                      style={{
                        padding: '8px 16px',
                        fontSize: '13px',
                        background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)'
                      }}
                    >
                      <Icon name="assignments" size={14} style={{ marginRight: 6 }} /> Kopyala
                    </Button>
                    <Button
                      onClick={exportApellyasiyaToTxt}
                      style={{
                        padding: '8px 16px',
                        fontSize: '13px',
                        background: 'linear-gradient(135deg, #10b981, #059669)'
                      }}
                    >
                      <Icon name="photo" size={14} style={{ marginRight: 6 }} /> TXT Export
                    </Button>
                    <Button
                      onClick={exportApellyasiyaToExcel}
                      style={{
                        padding: '8px 16px',
                        fontSize: '13px',
                        background: 'linear-gradient(135deg, #3b82f6, #2563eb)'
                      }}
                    >
                      <Icon name="stats" size={14} style={{ marginRight: 6 }} /> Excel Export
                    </Button>
                          </>
                        );
                      }
                    }
                    return null;
                  })()}
                  <CloseButton onClick={() => setSelectedStudent(null)}>×</CloseButton>
                </div>
              </ModalHeader>

              {/* Appeal Statistics Card */}
              {(() => {
                const stats = calculateAppealStatistics(selectedStudent);
                if (stats.total > 0) {
                  const completionPercentage = stats.total > 0 ? Math.round((stats.completed / stats.total) * 100) : 0;
                  return (
                    <AppealStatsCard>
                      <AppealStatsTitle>
                        📊 Apellyasiya Statistikası
                      </AppealStatsTitle>
                      <AppealStatsGrid>
                        <AppealStatItem $type="total">
                          <AppealStatValue $type="total">{stats.total}</AppealStatValue>
                          <AppealStatLabel>Ümumi</AppealStatLabel>
                        </AppealStatItem>
                        <AppealStatItem $type="pending">
                          <AppealStatValue $type="pending">{stats.pending}</AppealStatValue>
                          <AppealStatLabel><IconClock size={14} style={{ marginRight: 4 }} /> Gözləyir</AppealStatLabel>
                        </AppealStatItem>
                        <AppealStatItem $type="completed">
                          <AppealStatValue $type="completed">{stats.completed}</AppealStatValue>
                          <AppealStatLabel><IconCheckCircle size={14} style={{ marginRight: 4 }} /> Təsdiqləndi</AppealStatLabel>
                        </AppealStatItem>
                        {stats.rejected > 0 && (
                          <AppealStatItem $type="rejected">
                            <AppealStatValue $type="rejected">{stats.rejected}</AppealStatValue>
                            <AppealStatLabel>❌ Rədd Edildi</AppealStatLabel>
                          </AppealStatItem>
                        )}
                      </AppealStatsGrid>
                      {stats.total > 0 && (
                        <div style={{ marginTop: '16px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '13px', color: '#64748b' }}>
                            <span>Tamamlanma: {stats.completed}/{stats.total}</span>
                            <span>{completionPercentage}%</span>
                          </div>
                          <AppealProgressBar $percentage={completionPercentage} />
                        </div>
                      )}
                    </AppealStatsCard>
                  );
                }
                return null;
              })()}

              {/* Batch Action Button */}
              {selectedQuestionsForAppeal.size > 0 && (
                <div style={{ 
                  marginBottom: '20px', 
                  padding: '16px', 
                  background: 'linear-gradient(135deg, #eff6ff, #dbeafe)', 
                  borderRadius: '12px',
                  border: '2px solid #3b82f6',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '12px'
                }}>
                  <div style={{ fontSize: '15px', fontWeight: '600', color: '#1e40af' }}>
                    {selectedQuestionsForAppeal.size} sual seçildi
                  </div>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    <Button
                      onClick={() => setSelectedQuestionsForAppeal(new Set())}
                      style={{
                        padding: '8px 16px',
                        fontSize: '13px',
                        background: '#e5e7eb',
                        color: '#374151'
                      }}
                    >
                      Seçimi Təmizlə
                    </Button>
                    <Button
                      onClick={() => handleOpenBatchApellyasiyaModal(true)}
                      style={{
                        padding: '8px 16px',
                        fontSize: '13px',
                        background: 'linear-gradient(135deg, #f59e0b, #d97706)'
                      }}
                    >
                      📝 Toplu Apellyasiya Təyin Et
                    </Button>
                    {selectedQuestionsForAppeal.size > 0 && (
                      <Button
                        onClick={() => handleOpenBatchApellyasiyaModal(false)}
                        style={{
                          padding: '8px 16px',
                          fontSize: '13px',
                          background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)'
                        }}
                      >
                        📋 Seçilənləri Təyin Et ({selectedQuestionsForAppeal.size})
                      </Button>
                    )}
                  </div>
                </div>
              )}

              <StudentInfo>
                <InfoRow>
                  <InfoLabel>Şagird ID:</InfoLabel>
                  <InfoValue>{selectedStudent.student_id}</InfoValue>
                </InfoRow>
                <InfoRow>
                  <InfoLabel>Sinif:</InfoLabel>
                  <InfoValue>{selectedStudent.grade}. Sinif</InfoValue>
                </InfoRow>
                {isBuraxilis ? (
                  <>
                    {selectedStudent.variant && (
                      <InfoRow>
                        <InfoLabel>Variant:</InfoLabel>
                        <InfoValue>{selectedStudent.variant}</InfoValue>
                      </InfoRow>
                    )}
                    {selectedStudent.xdil && (
                      <InfoRow>
                        <InfoLabel>Xarici Dil:</InfoLabel>
                        <InfoValue>{normalizeXdil(selectedStudent.xdil)}</InfoValue>
                      </InfoRow>
                    )}
                  </>
                ) : (
                  <>
                    <InfoRow>
                      <InfoLabel>Qrup:</InfoLabel>
                      <InfoValue>Qrup {selectedStudent.specialtyGroup}</InfoValue>
                    </InfoRow>
                    {selectedStudent.subGroup && (
                      <InfoRow>
                        <InfoLabel>SubGroup:</InfoLabel>
                        <InfoValue>{selectedStudent.subGroup}</InfoValue>
                      </InfoRow>
                    )}
                  </>
                )}
                <InfoRow>
                  <InfoLabel>Vəziyyət:</InfoLabel>
                  <InfoValue>{selectedStudent.status}</InfoValue>
                </InfoRow>
                {((selectedStudent as any)['1_path'] || (selectedStudent as any)['2_path']) && (
                  <InfoRow>
                    <InfoLabel>Tam səhifə:</InfoLabel>
                    <InfoValue style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      {(selectedStudent as any)['1_path'] && (
                        <Button
                          onClick={() => {
                            setImageLoading(true);
                            setViewingImage({ fenn: 'Ön üz', studentId: selectedStudent.student_id });
                          }}
                          style={{ padding: '8px 16px', fontSize: '13px' }}
                        >
                          📄 Ön üz
                        </Button>
                      )}
                      {(selectedStudent as any)['2_path'] && (
                        <Button
                          onClick={() => {
                            setImageLoading(true);
                            setViewingImage({ fenn: 'Arxa üz', studentId: selectedStudent.student_id });
                          }}
                          style={{ padding: '8px 16px', fontSize: '13px' }}
                        >
                          📄 Arxa üz
                        </Button>
                      )}
                    </InfoValue>
                  </InfoRow>
                )}
                <InfoRow>
                  <InfoLabel>
                    {selectedStudent.specialtyGroup && !isBuraxilis ? 'Yoxlanmış Sual:' : (isBuraxilis ? 'Yoxlanmış Sual:' : 'Yoxlanmış Fənn:')}
                  </InfoLabel>
                  <InfoValue>
                    {(() => {
                      // BLOK mode: count Q##_c graded questions using actual assigned questions
                      if (!isBuraxilis && selectedStudent.specialtyGroup) {
                        const mode = detectBlokMode(selectedStudent);
                        const actualQuestions = getActualBlokQuestions(selectedStudent);

                        const totalQuestions = actualQuestions.length;
                        let gradedCount = 0;

                        actualQuestions.forEach(questionNum => {
                          const qField = `${questionNum}_c`;
                          const qValue = (selectedStudent as any)[qField];
                          if (qValue && typeof qValue === 'object' && qValue.hocaId) {
                            gradedCount++;
                          }
                        });

                        return `${gradedCount} / ${totalQuestions}`;
                      }

                      // Buraxılış mode: count from effective questions (xdil-filtered)
                      if (isBuraxilis && selectedStudent.grade) {
                        const gradeNum = typeof selectedStudent.grade === 'number' ? selectedStudent.grade : parseInt(selectedStudent.grade as string);
                        const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, selectedStudent.xdil, buraxilisBlankCtx(selectedExam, selectedStudent));
                        if (gradeQuestions && gradeQuestions.length > 0) {
                          const totalQuestions = gradeQuestions.reduce((sum: number, subj: { subject: string; questions: string[] }) => sum + subj.questions.length, 0);
                          let gradedCount = 0;
                          gradeQuestions.forEach((subj: { subject: string; questions: string[] }) => {
                            subj.questions.forEach((q: string) => {
                              const qField = `${q}_c`;
                              const qValue = (selectedStudent as any)[qField];
                              if (qValue && typeof qValue === 'object' && qValue.hocaId) {
                                gradedCount++;
                              }
                            });
                          });
                          return `${gradedCount} / ${totalQuestions}`;
                        }
                      }

                      // Fallback: completedFennCount (legacy)
                      return `${selectedStudent.completedFennCount || 0} / ${selectedStudent.totalFennCount || 0}`;
                    })()}
                  </InfoValue>
                </InfoRow>
              </StudentInfo>

              <FennResultsSection>
                <FennTitle>Bütün Suallar</FennTitle>
                {selectedStudent && (() => {
                  // Buraxılış imtahanında specialtyGroup Blok sayıqlamasını işə salmasın.
                  const isBlokStudent = !isBuraxilis && !!selectedStudent.specialtyGroup;

                  // Only show Buraxılış rendering if NOT Blok
                  if (!isBlokStudent && selectedStudent.grade) {
                    // Buraxılış mode: show questions grouped by subject (effective only - xdil-filtered)
                    const gradeNum = typeof selectedStudent.grade === 'number' ? selectedStudent.grade : parseInt(selectedStudent.grade as string);
                    const gradeQuestions = getEffectiveBuraxilisQuestionsForStudent(gradeNum, selectedStudent.xdil, buraxilisBlankCtx(selectedExam, selectedStudent));
                    if (!gradeQuestions || gradeQuestions.length === 0) return null;

                    return gradeQuestions.map((subjectGroup: { subject: string; questions: string[] }) => {
                      const { subject, questions } = subjectGroup;
                      
                      return (
                        <div key={subject} style={{ marginBottom: '24px' }}>
                          <FennTitle style={{ fontSize: '18px', marginBottom: '12px' }}>
                            {subject}
                          </FennTitle>
                          {questions.map((questionNum: string) => {
                            const gradingData = (selectedStudent as any)[`${questionNum}_c`];
                            const questionRawData = (selectedStudent as any)[questionNum];
                            const questionImagePath = questionRawData && typeof questionRawData === 'object'
                              ? questionRawData.path
                              : undefined;
                            const isGraded = !!gradingData;

                            const viewQuestionButton = questionImagePath ? (
                              <ViewButton
                                onClick={() => {
                                  setViewingImage({
                                    fenn: `${subject} - ${questionNum}`,
                                    studentId: selectedStudent.student_id
                                  });
                                  setImageLoading(true);
                                  // Şəkil modalında bu dəfə birbaşa sual şəkli göstəriləcək
                                  // path-i ayrıca state-də saxlayacağıq
                                  // Bunun üçün viewingImage ilə birlikdə questionData da istifadə olunacaq
                                  setTimeout(() => {
                                    if (imageContainerRef.current) {
                                      imageContainerRef.current.scrollTop = 0;
                                    }
                                  }, 100);
                                }}
                              >
                                👁 Suala Bax
                              </ViewButton>
                            ) : null;

                            if (isGraded) {
                              // Check if question can be selected for batch appeal
                              const apellyasiya = apellyasiyas.get(questionNum);
                              const isApellyasiyaCompleted = gradingData && 
                                                          typeof gradingData === 'object' && 
                                                          (gradingData.apellyasiya_status === true || 
                                                           gradingData.apellyasiya_result === true);
                              const isApellyasiyaPending = apellyasiya && 
                                                          apellyasiya.apellyasiya_status === 'pending' && 
                                                          !isApellyasiyaCompleted;
                              const canSelectForAppeal = !apellyasiya && !isApellyasiyaCompleted && !isApellyasiyaPending;
                              const isSelected = selectedQuestionsForAppeal.has(questionNum);

                              return (
                                <FennCardSelected 
                                  key={questionNum} 
                                  $selected={isSelected}
                                >
                                  <FennHeader>
                                    <FennHeaderLeft>
                                      {canSelectForAppeal && (
                                        <QuestionCheckboxLabel $disabled={false}>
                                          <QuestionCheckbox
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={() => handleToggleQuestionForAppeal(questionNum)}
                                            disabled={false}
                                          />
                                        </QuestionCheckboxLabel>
                                      )}
                                      <FennName style={{ color: '#10b981', display: 'inline-flex', alignItems: 'center', gap: 4 }}><IconCheckCircle size={14} style={{ marginRight: 0 }} /> {questionNum}</FennName>
                                      {gradingData.hoca && (
                                        <FennTeacher>
                                          Müəllim: {gradingData.hoca}
                                          {gradingData.timestamp && (
                                            <span style={{ fontSize: '11px', color: '#94a3b8', marginLeft: '8px' }}>
                                              ({new Date(gradingData.timestamp.toDate()).toLocaleDateString('az-AZ')})
                                            </span>
                                          )}
                                        </FennTeacher>
                                      )}
                                    </FennHeaderLeft>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                      <div>
                                        <TotalScore>
                                          Bal: {gradingData.score}
                                        </TotalScore>
                                        {(() => {
                                          // Q26 criteria gösterimi
                                          const assignmentForQ26 = selectedExam && selectedStudent ? {
                                            sinif: String(selectedStudent.grade || ''),
                                            fenn: subject
                                          } : null;
                                          const isQ26Question = isQ26SpecialGrading(assignmentForQ26 as any, questionNum);
                                          
                                          if (isQ26Question && gradingData.criteria) {
                                            return (
                                              <div style={{ 
                                                marginTop: '4px', 
                                                display: 'flex', 
                                                gap: '6px', 
                                                flexWrap: 'wrap',
                                                fontSize: '11px',
                                                color: '#64748b'
                                              }}>
                                                <span style={{ 
                                                  background: '#f1f5f9', 
                                                  padding: '2px 6px', 
                                                  borderRadius: '4px' 
                                                }}>
                                                  Məzmun: {gradingData.criteria.content ?? '-'}
                                                </span>
                                                <span style={{ 
                                                  background: '#f1f5f9', 
                                                  padding: '2px 6px', 
                                                  borderRadius: '4px' 
                                                }}>
                                                  Ardıcıllıq: {gradingData.criteria.sequence ?? '-'}
                                                </span>
                                                <span style={{ 
                                                  background: '#f1f5f9', 
                                                  padding: '2px 6px', 
                                                  borderRadius: '4px' 
                                                }}>
                                                  Qrammatika: {gradingData.criteria.grammar ?? '-'}
                                                </span>
                                                <span style={{ 
                                                  background: '#f1f5f9', 
                                                  padding: '2px 6px', 
                                                  borderRadius: '4px' 
                                                }}>
                                                  Söz Ehtiyatı: {gradingData.criteria.vocabulary ?? '-'}
                                                </span>
                                                {gradingData.criteria.penalty > 0 && (
                                                  <span style={{ 
                                                    background: '#fee2e2', 
                                                    padding: '2px 6px', 
                                                    borderRadius: '4px',
                                                    color: '#dc2626'
                                                  }}>
                                                    Cərimə: -{gradingData.criteria.penalty}
                                                  </span>
                                                )}
                                              </div>
                                            );
                                          }
                                          return null;
                                        })()}
                                      </div>
                                      {viewQuestionButton}
                                      <Button
                                        onClick={() => handleOpenQuestionScoringModal(selectedStudent, questionNum)}
                                        style={{ 
                                          padding: '6px 12px', 
                                          fontSize: '12px',
                                          background: 'linear-gradient(135deg, #3b82f6, #2563eb)'
                                        }}
                                      >
                                        📝 Bal ver
                                      </Button>
                                      {(() => {
                                        const apellyasiya = apellyasiyas.get(questionNum);
                                        // Önce Q##_c field'ından kontrol et (en güncel durum)
                                        const isApellyasiyaCompleted = gradingData && 
                                                                      typeof gradingData === 'object' && 
                                                                      (gradingData.apellyasiya_status === true || 
                                                                       gradingData.apellyasiya_result === true);
                                        // Sonra yoxla-s document'indeki status'u kontrol et
                                        const isApellyasiyaPending = apellyasiya && 
                                                                    apellyasiya.apellyasiya_status === 'pending' && 
                                                                    !isApellyasiyaCompleted;
                                        
                                        // Apellyasiya tamamlandıysa, her zaman "Təsdiqləndi" göster
                                        if (isApellyasiyaCompleted) {
                                          return (
                                            <Badge color="linear-gradient(135deg, #10b981, #059669)">
                                              <><IconCheckCircle size={14} /> Apellyasiya təsdiqləndi</>
                                            </Badge>
                                          );
                                        }
                                        
                                        // Apellyasiya gözləyir
                                        if (isApellyasiyaPending) {
                                          return (
                                            <Badge color="linear-gradient(135deg, #f59e0b, #d97706)">
                                              <><IconClock size={14} /> Apellyasiya gözləyir</>
                                            </Badge>
                                          );
                                        }
                                        
                                        // Apellyasiya yoksa, "Apellyasiya təyin et" butonu göster
                                        if (!apellyasiya) {
                                          return (
                                            <Button
                                              onClick={() => handleOpenApellyasiyaModal(selectedStudent, questionNum)}
                                              style={{ 
                                                padding: '6px 12px', 
                                                fontSize: '12px',
                                                background: 'linear-gradient(135deg, #f59e0b, #d97706)'
                                              }}
                                            >
                                              📝 Apellyasiya təyin et
                                            </Button>
                                          );
                                        }
                                        
                                        return null;
                                      })()}
                                      <DeleteScoreButton
                                        onClick={() => handleClearQuestionScore(selectedStudent, questionNum)}
                                      >
                                        🗑 Balı Sil
                                      </DeleteScoreButton>
                                    </div>
                                  </FennHeader>
                                  {gradingData.note && (
                                    <NotesSection>
                                      <NoteItem>
                                        <NoteLabel>Qeyd:</NoteLabel>
                                        <NoteText>{gradingData.note}</NoteText>
                                      </NoteItem>
                                    </NotesSection>
                                  )}
                                  {gradingData.apellyasiya_status && (
                                    <NotesSection>
                                      <div style={{ 
                                        background: 'linear-gradient(135deg, #fef3c7, #fde68a)', 
                                        padding: '12px', 
                                        borderRadius: '8px', 
                                        marginTop: '12px',
                                        borderLeft: '4px solid #f59e0b'
                                      }}>
                                        <div style={{ fontSize: '13px', fontWeight: '700', color: '#92400e', marginBottom: '8px' }}>
                                          📝 Apellyasiya Nəticəsi:
                                        </div>
                                        {gradingData.previous_score && gradingData.new_score && (
                                          <div style={{ fontSize: '13px', color: '#78350f', marginBottom: '6px' }}>
                                            <strong>Əvvəlki bal:</strong> {gradingData.previous_score} → 
                                            <strong style={{ color: gradingData.previous_score !== gradingData.new_score ? '#059669' : '#78350f' }}>
                                              {' '}Yeni bal: {gradingData.new_score}
                                            </strong>
                                            {gradingData.previous_score !== gradingData.new_score && (
                                              <span style={{ marginLeft: '8px', color: '#059669', fontWeight: '600' }}>
                                                (Dəyişdi)
                                              </span>
                                            )}
                                          </div>
                                        )}
                                        {gradingData.apellyasiya_note && (
                                          <div style={{ fontSize: '13px', color: '#78350f', marginBottom: '6px' }}>
                                            <strong>Müəllim qeydi:</strong> {gradingData.apellyasiya_note}
                                          </div>
                                        )}
                                        {gradingData.apellyasiya_hoca && gradingData.apellyasiya_hocaId !== gradingData.hocaId && (
                                          <div style={{ fontSize: '13px', color: '#78350f', marginBottom: '6px' }}>
                                            <strong>Apellyasiyanı yoxlayan:</strong> {gradingData.apellyasiya_hoca}
                                          </div>
                                        )}
                                        {gradingData.apellyasiya_onaylanma_tarihi && (
                                          <div style={{ fontSize: '12px', color: '#92400e', marginTop: '6px' }}>
                                            Təsdiqlənmə tarixi: {new Date(
                                              gradingData.apellyasiya_onaylanma_tarihi.toDate ? 
                                              gradingData.apellyasiya_onaylanma_tarihi.toDate() : 
                                              gradingData.apellyasiya_onaylanma_tarihi
                                            ).toLocaleString('az-AZ')}
                                          </div>
                                        )}
                                      </div>
                                    </NotesSection>
                                  )}
                                </FennCardSelected>
                              );
                            } else {
                              return (
                                <FennCard key={questionNum} style={{ borderColor: '#fee2e2', background: '#fef2f2', marginBottom: '12px' }}>
                                  <FennHeader>
                                    <FennHeaderLeft>
                                      <FennName style={{ color: '#ef4444' }}>❌ {questionNum}</FennName>
                                      <FennTeacher style={{ color: '#ef4444', fontWeight: '600' }}>
                                        Hələ yoxlanılmayıb
                                      </FennTeacher>
                                    </FennHeaderLeft>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                      {viewQuestionButton}
                                      <Button
                                        onClick={() => handleOpenQuestionScoringModal(selectedStudent, questionNum)}
                                        style={{ 
                                          padding: '6px 12px', 
                                          fontSize: '12px',
                                          background: 'linear-gradient(135deg, #3b82f6, #2563eb)'
                                        }}
                                      >
                                        📝 Bal ver
                                      </Button>
                                    </div>
                                  </FennHeader>
                                </FennCard>
                              );
                            }
                          })}
                        </div>
                      );
                    });
                  }

                  // Blok mode: OLD "Bütün Fənnlər" section removed - now using individual questions below
                  return null;
                  })()}

                  {/* Blok mode: show only the 9 assigned questions in 3 fenn rows */}
                  {(!isBuraxilis && selectedStudent.specialtyGroup) && (() => {
                    const mode = detectBlokMode(selectedStudent);
                    const actualQuestions = getActualBlokQuestions(selectedStudent);
                    const qrup = selectedStudent.specialtyGroup;
                    const subGroup = selectedStudent.subGroup;

                    // Define the 3 fenn rows with their questions for this system
                    const blokFennRows = [
                      {
                        fenn: getFennNameForBlokQuestion('Q28', qrup, subGroup),
                        questions: ['Q28', 'Q29', 'Q30']
                      },
                      {
                        fenn: getFennNameForBlokQuestion('Q58', qrup, subGroup),
                        questions: ['Q58', 'Q59', 'Q60']
                      },
                      {
                        fenn: getFennNameForBlokQuestion('Q88', qrup, subGroup),
                        questions: ['Q88', 'Q89', 'Q90']
                      }
                    ];

                    return blokFennRows.map(({ fenn: fennName, questions: fennQuestions }) => (
                      <div key={fennName} style={{ marginBottom: '24px' }}>
                          <FennTitle style={{ fontSize: '18px', marginBottom: '12px' }}>
                            {fennName}
                          </FennTitle>
                          {(() => {
                            const questionCards: JSX.Element[] = [];
                            // Loop through actual assigned questions for this fenn
                            fennQuestions.forEach(qNumStr => {
                              const gradingData = (selectedStudent as any)[`${qNumStr}_c`];
                              const questionRawData = (selectedStudent as any)[qNumStr];
                              const questionImagePath = questionRawData && typeof questionRawData === 'object'
                                ? questionRawData.path
                                : undefined;
                              const isGraded = !!gradingData;

                              const viewQuestionButton = questionImagePath ? (
                                <ViewButton
                                  onClick={() => {
                                    setViewingImage({
                                      fenn: `${fennName} - ${qNumStr}`,
                                      studentId: selectedStudent.student_id
                                    });
                                    setImageLoading(true);
                                    setTimeout(() => {
                                      if (imageContainerRef.current) {
                                        imageContainerRef.current.scrollTop = 0;
                                      }
                                    }, 100);
                                  }}
                                >
                                  👁 Suala Bax
                                </ViewButton>
                              ) : null;

                              if (isGraded) {
                                // Check if question can be selected for batch appeal
                                const apellyasiya = apellyasiyas.get(qNumStr);
                                const isApellyasiyaCompleted = gradingData &&
                                                              typeof gradingData === 'object' &&
                                                              (gradingData.apellyasiya_status === true ||
                                                               gradingData.apellyasiya_result === true);
                                const isApellyasiyaPending = apellyasiya &&
                                                            apellyasiya.apellyasiya_status === 'pending' &&
                                                            !isApellyasiyaCompleted;
                                const canSelectForAppeal = !apellyasiya && !isApellyasiyaCompleted && !isApellyasiyaPending;
                                const isSelected = selectedQuestionsForAppeal.has(qNumStr);

                                questionCards.push(
                                  <FennCardSelected 
                                    key={qNumStr} 
                                    $selected={isSelected}
                                  >
                                    <FennHeader>
                                      <FennHeaderLeft>
                                        {canSelectForAppeal && (
                                          <QuestionCheckboxLabel $disabled={false}>
                                            <QuestionCheckbox
                                              type="checkbox"
                                              checked={isSelected}
                                              onChange={() => handleToggleQuestionForAppeal(qNumStr)}
                                              disabled={false}
                                            />
                                          </QuestionCheckboxLabel>
                                        )}
                                        <FennName style={{ color: '#10b981', display: 'inline-flex', alignItems: 'center', gap: 4 }}><IconCheckCircle size={14} style={{ marginRight: 0 }} /> {qNumStr}</FennName>
                                        {gradingData.hoca && (
                                          <FennTeacher>
                                            Müəllim: {gradingData.hoca}
                                            {gradingData.timestamp && (
                                              <span style={{ fontSize: '11px', color: '#94a3b8', marginLeft: '8px' }}>
                                                ({new Date(gradingData.timestamp.toDate()).toLocaleDateString('az-AZ')})
                                              </span>
                                            )}
                                          </FennTeacher>
                                        )}
                                      </FennHeaderLeft>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                        <div>
                                          <TotalScore>
                                            Bal: {gradingData.score}
                                          </TotalScore>
                                          {(() => {
                                            // Q26 criteria gösterimi (Blok mode için de kontrol et)
                                            const assignmentForQ26 = selectedExam && selectedStudent ? {
                                              sinif: String(selectedStudent.grade || ''),
                                              fenn: fennName
                                            } : null;
                                            const isQ26Question = isQ26SpecialGrading(assignmentForQ26 as any, qNumStr);
                                            
                                            if (isQ26Question && gradingData.criteria) {
                                              return (
                                                <div style={{ 
                                                  marginTop: '4px', 
                                                  display: 'flex', 
                                                  gap: '6px', 
                                                  flexWrap: 'wrap',
                                                  fontSize: '11px',
                                                  color: '#64748b'
                                                }}>
                                                  <span style={{ 
                                                    background: '#f1f5f9', 
                                                    padding: '2px 6px', 
                                                    borderRadius: '4px' 
                                                  }}>
                                                    Məzmun: {gradingData.criteria.content ?? '-'}
                                                  </span>
                                                  <span style={{ 
                                                    background: '#f1f5f9', 
                                                    padding: '2px 6px', 
                                                    borderRadius: '4px' 
                                                  }}>
                                                    Ardıcıllıq: {gradingData.criteria.sequence ?? '-'}
                                                  </span>
                                                  <span style={{ 
                                                    background: '#f1f5f9', 
                                                    padding: '2px 6px', 
                                                    borderRadius: '4px' 
                                                  }}>
                                                    Qrammatika: {gradingData.criteria.grammar ?? '-'}
                                                  </span>
                                                  <span style={{ 
                                                    background: '#f1f5f9', 
                                                    padding: '2px 6px', 
                                                    borderRadius: '4px' 
                                                  }}>
                                                    Söz Ehtiyatı: {gradingData.criteria.vocabulary ?? '-'}
                                                  </span>
                                                  {gradingData.criteria.penalty > 0 && (
                                                    <span style={{ 
                                                      background: '#fee2e2', 
                                                      padding: '2px 6px', 
                                                      borderRadius: '4px',
                                                      color: '#dc2626'
                                                    }}>
                                                      Cərimə: -{gradingData.criteria.penalty}
                                                    </span>
                                                  )}
                                                </div>
                                              );
                                            }
                                            return null;
                                          })()}
                                        </div>
                                        {viewQuestionButton}
                                        <Button
                                          onClick={() => handleOpenQuestionScoringModal(selectedStudent, qNumStr)}
                                          style={{ 
                                            padding: '6px 12px', 
                                            fontSize: '12px',
                                            background: 'linear-gradient(135deg, #3b82f6, #2563eb)'
                                          }}
                                        >
                                          📝 Bal ver
                                        </Button>
                                        {(() => {
                                          const apellyasiya = apellyasiyas.get(qNumStr);
                                          // Önce Q##_c field'ından kontrol et (en güncel durum)
                                          const isApellyasiyaCompleted = gradingData &&
                                                                        typeof gradingData === 'object' &&
                                                                        (gradingData.apellyasiya_status === true ||
                                                                         gradingData.apellyasiya_result === true);
                                          // Sonra yoxla-s document'indeki status'u kontrol et
                                          const isApellyasiyaPending = apellyasiya &&
                                                                      apellyasiya.apellyasiya_status === 'pending' &&
                                                                      !isApellyasiyaCompleted;

                                          // Apellyasiya tamamlandıysa, her zaman "Təsdiqləndi" göster
                                          if (isApellyasiyaCompleted) {
                                            return (
                                              <Badge color="linear-gradient(135deg, #10b981, #059669)">
                                                <><IconCheckCircle size={14} /> Apellyasiya təsdiqləndi</>
                                              </Badge>
                                            );
                                          }

                                          // Apellyasiya gözləyir
                                          if (isApellyasiyaPending) {
                                            return (
                                              <Badge color="linear-gradient(135deg, #f59e0b, #d97706)">
                                                <><IconClock size={14} /> Apellyasiya gözləyir</>
                                              </Badge>
                                            );
                                          }

                                          // Apellyasiya yoksa, "Apellyasiya təyin et" butonu göster
                                          if (!apellyasiya) {
                                            return (
                                              <Button
                                                onClick={() => handleOpenApellyasiyaModal(selectedStudent, qNumStr)}
                                                style={{
                                                  padding: '6px 12px',
                                                  fontSize: '12px',
                                                  background: 'linear-gradient(135deg, #f59e0b, #d97706)'
                                                }}
                                              >
                                                📝 Apellyasiya təyin et
                                              </Button>
                                            );
                                          }

                                          return null;
                                        })()}
                                        <DeleteScoreButton
                                          onClick={() => handleClearQuestionScore(selectedStudent, qNumStr)}
                                        >
                                          🗑 Balı Sil
                                        </DeleteScoreButton>
                                      </div>
                                    </FennHeader>
                                    {gradingData.note && (
                                      <NotesSection>
                                        <NoteItem>
                                          <NoteLabel>Qeyd:</NoteLabel>
                                          <NoteText>{gradingData.note}</NoteText>
                                        </NoteItem>
                                      </NotesSection>
                                    )}
                                    {gradingData.apellyasiya_status && (
                                      <NotesSection>
                                        <div style={{
                                          background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
                                          padding: '12px',
                                          borderRadius: '8px',
                                          marginTop: '12px',
                                          borderLeft: '4px solid #f59e0b'
                                        }}>
                                          <div style={{ fontSize: '13px', fontWeight: '700', color: '#92400e', marginBottom: '8px' }}>
                                            📝 Apellyasiya Nəticəsi:
                                          </div>
                                          {gradingData.previous_score && gradingData.new_score && (
                                            <div style={{ fontSize: '13px', color: '#78350f', marginBottom: '6px' }}>
                                              <strong>Əvvəlki bal:</strong> {gradingData.previous_score} →
                                              <strong style={{ color: gradingData.previous_score !== gradingData.new_score ? '#059669' : '#78350f' }}>
                                                {' '}Yeni bal: {gradingData.new_score}
                                              </strong>
                                              {gradingData.previous_score !== gradingData.new_score && (
                                                <span style={{ marginLeft: '8px', color: '#059669', fontWeight: '600' }}>
                                                  (Dəyişdi)
                                                </span>
                                              )}
                                            </div>
                                          )}
                                          {gradingData.apellyasiya_note && (
                                            <div style={{ fontSize: '13px', color: '#78350f', marginBottom: '6px' }}>
                                              <strong>Müəllim qeydi:</strong> {gradingData.apellyasiya_note}
                                            </div>
                                          )}
                                          {gradingData.apellyasiya_hoca && gradingData.apellyasiya_hocaId !== gradingData.hocaId && (
                                            <div style={{ fontSize: '13px', color: '#78350f', marginBottom: '6px' }}>
                                              <strong>Apellyasiyanı yoxlayan:</strong> {gradingData.apellyasiya_hoca}
                                            </div>
                                          )}
                                          {gradingData.apellyasiya_onaylanma_tarihi && (
                                            <div style={{ fontSize: '12px', color: '#92400e', marginTop: '6px' }}>
                                              Təsdiqlənmə tarixi: {new Date(
                                                gradingData.apellyasiya_onaylanma_tarihi.toDate ?
                                                gradingData.apellyasiya_onaylanma_tarihi.toDate() :
                                                gradingData.apellyasiya_onaylanma_tarihi
                                              ).toLocaleString('az-AZ')}
                                            </div>
                                          )}
                                        </div>
                                      </NotesSection>
                                    )}
                                  </FennCardSelected>
                                );
                              } else {
                                questionCards.push(
                                  <FennCard key={qNumStr} style={{ borderColor: '#fee2e2', background: '#fef2f2', marginBottom: '12px' }}>
                                    <FennHeader>
                                      <FennHeaderLeft>
                                        <FennName style={{ color: '#ef4444' }}>❌ {qNumStr}</FennName>
                                        <FennTeacher style={{ color: '#ef4444', fontWeight: '600' }}>
                                          Hələ yoxlanılmayıb
                                        </FennTeacher>
                                      </FennHeaderLeft>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                        {viewQuestionButton}
                                        <Button
                                          onClick={() => handleOpenQuestionScoringModal(selectedStudent, qNumStr)}
                                          style={{ 
                                            padding: '6px 12px', 
                                            fontSize: '12px',
                                            background: 'linear-gradient(135deg, #3b82f6, #2563eb)'
                                          }}
                                        >
                                          📝 Bal ver
                                        </Button>
                                      </div>
                                    </FennHeader>
                                  </FennCard>
                                );
                              }
                            });
                            return questionCards;
                          })()}
                        </div>
                      )
                    );
                  })()}
              </FennResultsSection>
            </>
          )}
        </ModalContent>
      </StudentDetailModal>

      {/* Question Scoring Modal */}
      <QuestionScoringModal
        show={showQuestionScoringModal}
        questionNumber={scoringQuestionNumber || ''}
        student={selectedStudent}
        onClose={() => {
          setShowQuestionScoringModal(false);
          setScoringQuestionNumber(null);
        }}
        onSave={handleSaveQuestionScore}
        saving={savingScore}
        selectedExam={selectedExam}
      />

      {/* Bulk Actions Footer - Modal içinde seçili fennler olduğunda göster */}
      <BulkActionsFooter show={!!selectedStudent && selectedFennList.length > 0}>
        <BulkActionsInfo>
          <BulkActionsCount>
            {selectedFennList.length} fənn seçildi
          </BulkActionsCount>
          <BulkActionsText>
            Seçilən fənnlər: {selectedFennList.join(', ')}
          </BulkActionsText>
        </BulkActionsInfo>
        <BulkActionsButtons>
          <BulkButton 
            variant="cancel" 
            onClick={handleClearSelection}
            disabled={isBulkSettingZero}
          >
            Seçimi Təmizlə
          </BulkButton>
          <BulkButton 
            variant="danger" 
            onClick={() => setShowBulkConfirm(true)}
            disabled={isBulkSettingZero}
          >
            🚫 Seçilənləri Boş Kağız Olaraq İşarələ
          </BulkButton>
        </BulkActionsButtons>
      </BulkActionsFooter>

      {/* Bulk Confirmation Dialog */}
      <ConfirmDialog show={showBulkConfirm} onClick={() => !isBulkSettingZero && setShowBulkConfirm(false)}>
        <ConfirmDialogContent onClick={(e) => e.stopPropagation()}>
          <ConfirmDialogTitle>Toplu Boş Kağız Təsdiqi</ConfirmDialogTitle>
          <ConfirmDialogText>
            <strong>{selectedFennList.length} fənn</strong> üçün <strong>boş kağız</strong> işarəsi qoyacaqsınız:
            <br /><br />
            <strong style={{ color: '#3b82f6' }}>
              {selectedFennList.join(', ')}
            </strong>
            <br /><br />
            Bu əməliyyat bütün seçilmiş fənnlərin suallarını <strong>0 bal</strong> olaraq işarələyəcək və 
            müəllim məlumatını <strong>"Admin"</strong> olaraq qeyd edəcək.
            <br /><br />
            Bu əməliyyatı təsdiq edirsiniz?
          </ConfirmDialogText>
          <ConfirmDialogButtons>
            <ConfirmButton 
              variant="cancel" 
              onClick={() => setShowBulkConfirm(false)}
              disabled={isBulkSettingZero}
            >
              Ləğv et
            </ConfirmButton>
            <ConfirmButton 
              variant="danger" 
              onClick={handleBulkSetToZero}
              disabled={isBulkSettingZero}
            >
              {isBulkSettingZero ? 'İşlənir...' : `Bəli, ${selectedFennList.length} Fənni İşarələ`}
            </ConfirmButton>
          </ConfirmDialogButtons>
        </ConfirmDialogContent>
      </ConfirmDialog>

      </Container>

      {/* PHASE 2: Validation Modals - OUTSIDE Container */}
      {showValidationPreviewModal && (
        <div style={{
          display: 'flex',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 99999,
          alignItems: 'center',
          justifyContent: 'center',
          padding: 20
        }}>
        <ValidationModalContent>
            <ValidationHeader>
              <ValidationTitle>🔍 Data Validation - Preview</ValidationTitle>
            </ValidationHeader>

            {validationPreview && (
              <>
                <ValidationWarning>
                  Bu əməliyyat geri qaytarılmazdır! Silinəcək {validationPreview.totalCount} Q##_c field-i nəzərdən keçirin.
                </ValidationWarning>

                <ValidationStats>
                  <ValidationStatBox>
                    <div className="number">{validationPreview.totalCount}</div>
                    <div className="label">Uyğunsuzluq Tapıldı</div>
                  </ValidationStatBox>
                </ValidationStats>

                {validationPreview.inconsistencies.length > 0 && (
                  <ValidationList>
                    {validationPreview.inconsistencies.map((item, index) => (
                      <ValidationListItem key={index}>
                        <div>
                          <ValidationListLabel>Şagird Adı</ValidationListLabel>
                          <ValidationListValue>{item.studentName}</ValidationListValue>
                        </div>
                        <div>
                          <ValidationListLabel>Şagird ID</ValidationListLabel>
                          <ValidationListValue>{item.studentId}</ValidationListValue>
                        </div>
                        <div>
                          <ValidationListLabel>Sual</ValidationListLabel>
                          <ValidationListValue>{item.questionNumber}</ValidationListValue>
                        </div>
                        <div>
                          <ValidationListLabel>Mövcud Q##_c</ValidationListLabel>
                          <ValidationListDetail>
                            Hoca: {item.currentQ_c?.hoca || 'N/A'}<br/>
                            Bal: {item.currentQ_c?.score || 'N/A'}<br/>
                            Qeyd: {item.currentQ_c?.note || 'N/A'}
                          </ValidationListDetail>
                        </div>
                      </ValidationListItem>
                    ))}
                  </ValidationList>
                )}

                <ValidationButtons>
                  <ValidationCancelButton onClick={handleCancelPreview}>
                    ✕ Ləğv et
                  </ValidationCancelButton>
                  <ValidationConfirmButton
                    onClick={handleExecuteCleanup}
                    disabled={validationPreview.totalCount === 0}
                  >
                    🗑️ {validationPreview.totalCount} Field-i Sil ({validationPreview.totalCount} təsdiqlə)
                  </ValidationConfirmButton>
                </ValidationButtons>
              </>
            )}
        </ValidationModalContent>
        </div>
      )}

      {showValidationResultsModal && (
      <div style={{
          display: 'flex',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 99999,
          alignItems: 'center',
          justifyContent: 'center',
          padding: 20
        }}>
        <ValidationModalContent>
            <ValidationHeader>
              <ValidationTitle><IconCheckCircle size={22} color="#10b981" style={{ marginRight: 8, verticalAlign: 'middle' }} /> Data Validation - Nəticələr</ValidationTitle>
            </ValidationHeader>

            {validationResults && (
              <>
                <ValidationSuccessIcon><IconCheckCircle size={32} color="#10b981" style={{ marginRight: 0 }} /></ValidationSuccessIcon>

                <ResultsSummary>
                  <div style={{ fontSize: '18px', fontWeight: '700', color: '#166534', marginBottom: '12px' }}>
                    Təmizləmə əməliyyatı uğurla tamamlandı!
                  </div>
                  <div style={{ fontSize: '14px', color: '#15803d' }}>
                    <><IconCheck size={14} /> {validationResults.deleted} Q##_c field uğurla silindi</>
                    {validationResults.errors > 0 && ` • ⚠️ ${validationResults.errors} xəta`}
                  </div>
                </ResultsSummary>

                {validationResults.errors > 0 && validationResults.details.length > 0 && (
                  <ResultsErrorList>
                    <div style={{ fontWeight: '600', marginBottom: '12px', color: '#991b1b' }}>
                      ⚠️ Xətalar ({validationResults.errors}):
                    </div>
                    {validationResults.details.map((detail, index) => (
                      <ErrorItem key={index}>
                        {detail.studentId} - {detail.questionNumber}
                        {detail.error && `: ${detail.error}`}
                      </ErrorItem>
                    ))}
                  </ResultsErrorList>
                )}

                <ValidationButtons>
                  <ValidationCancelButton onClick={handleRerunValidation}>
                    🔄 Yenidən Yoxla
                  </ValidationCancelButton>
                  <ValidationConfirmButton
                    onClick={handleCloseResults}
                    style={{
                      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                    }}
                  >
                    <><IconCheck size={14} /> Bağla</>
                  </ValidationConfirmButton>
                </ValidationButtons>
              </>
            )}
        </ValidationModalContent>
        </div>
      )}
    </div>
  );
};

export default StudentResultsPage;
